<div class="h-full w-full">
  <svg
    viewBox="0 0 248 56"
    fill="none"
    (pointerenter)="onPointerEnter($event)"
    (pointerleave)="onPointerLeave($event)"
    (pointerdown)="onPointerDown($event)"
  >
    <g
      id="Button"
      clip-path="url(#clip0_11_402)"
    >
      <rect
        width="248"
        height="56"
        [attr.fill]="sSBSFGradientColor"
      />
      <g id="Separator">
        <rect
          y="55"
          width="248"
          height="1"
          fill="url(#paint1_linear_11_402)"
          fill-opacity="0.6"
          style="mix-blend-mode: overlay"
        />
      </g>
      <g id="Light Reflection">
        <rect
          width="248"
          height="1"
          [attr.fill]="sSBSFLightReflection"
          style="mix-blend-mode: overlay"
        />
      </g>
      <g id="Icon Selected">
        <circle
          id="Ellipse 5"
          cx="36"
          cy="28"
          r="16"
          stroke="url(#paint3_linear_11_402)"
        />
      </g>
      <path
        id="Ships"
        d="M72.3154 30.4722H75.2124C75.3286 31.3022 76.2085 31.8916 77.3955 31.8916C78.541 31.8916 79.3047 31.4102 79.3047 30.6465C79.3047 30.0571 78.981 29.7251 77.769 29.3516L76.6235 29.0029C74.6313 28.3887 73.5938 27.3428 73.5938 25.7075C73.5938 23.3667 75.6025 21.8145 78.3999 21.8145C81.3301 21.8145 83.1895 23.209 83.2061 25.5332H80.3921C80.3589 24.6865 79.6118 24.1221 78.458 24.1221C77.3457 24.1221 76.6899 24.6699 76.6899 25.334C76.6899 25.9233 77.0884 26.3135 78.1675 26.6289L79.3628 26.9858C81.4712 27.6084 82.4258 28.5298 82.4258 30.2065C82.4258 32.5723 80.4253 34.2075 77.3374 34.2075C74.2827 34.2075 72.3403 32.8296 72.3154 30.4722ZM83.0317 34L85.5801 22.022H88.4189L87.4893 26.3384H87.5474C88.1865 25.3921 89.1992 24.7861 90.4858 24.7861C92.1626 24.7861 93.2666 25.8569 93.2666 27.3345C93.2666 27.6748 93.2251 28.04 93.1421 28.4302L91.9634 34H89.1328L90.2202 28.8784C90.2617 28.6377 90.2866 28.4385 90.2866 28.2476C90.2866 27.5254 89.7222 27.0024 88.8921 27.0024C87.979 27.0024 87.2153 27.6831 87.0078 28.6709L85.8789 34H83.0317ZM97.8071 23.9229C96.9937 23.9229 96.3545 23.2754 96.3545 22.5034C96.3545 21.7231 96.9937 21.0757 97.8071 21.0757C98.6206 21.0757 99.2598 21.7231 99.2598 22.5034C99.2598 23.2754 98.6206 23.9229 97.8071 23.9229ZM93.9224 34L95.8481 24.9604H98.7119L96.7861 34H93.9224ZM100.887 36.9219H98.0396L100.58 24.9604H103.36L103.086 26.2637H103.145C103.809 25.3174 104.821 24.8276 105.958 24.8276C107.859 24.8276 109.03 26.1807 109.03 28.3555C109.03 31.6841 107.121 34.1328 104.547 34.1328C103.236 34.1328 102.273 33.4688 101.916 32.3398H101.866L100.887 36.9219ZM103.908 31.8584C105.128 31.8584 106.1 30.522 106.1 28.8037C106.1 27.7246 105.527 27.0273 104.622 27.0273C103.385 27.0273 102.406 28.4717 102.406 30.1152C102.406 31.1528 103.003 31.8584 103.908 31.8584ZM110.557 27.7163C110.557 25.9316 112.118 24.7529 114.517 24.7529C116.766 24.7529 118.352 25.9731 118.41 27.7329H115.836C115.795 27.1104 115.255 26.6787 114.475 26.6787C113.728 26.6787 113.271 26.9941 113.271 27.4673C113.271 27.8657 113.537 28.0732 114.458 28.3804L115.421 28.6958C117.131 29.2686 117.787 29.9575 117.787 31.1694C117.787 32.9956 116.152 34.2158 113.687 34.2158C111.171 34.2158 109.544 32.9956 109.478 31.1362H112.192C112.242 31.8086 112.848 32.2734 113.77 32.2734C114.508 32.2734 114.965 31.958 114.965 31.4766C114.965 31.103 114.699 30.9121 113.811 30.6133L112.998 30.3394C111.321 29.7832 110.557 28.9614 110.557 27.7163Z"
        [attr.fill]="sSBSFTextColor"
      />
      <g id="240854203_268db94c-f89a-4eaf-9300-422bbe0ead46 1">
        <path
          id="Vector"
          d="M27.1776 38.445C27.1235 38.4442 27.0307 38.4551 26.9856 38.4252L26.9805 38.3909C27.0299 38.3499 27.1192 38.358 27.1834 38.3523C27.1857 38.3866 27.1936 38.414 27.1776 38.445Z"
          fill="#250C28"
        />
        <path
          id="Vector_2"
          d="M25.3987 35.7718L25.9638 35.7656C25.9648 35.8216 25.9622 35.8791 25.9726 35.9342L25.7682 35.9333L25.4997 35.9198L25.5779 35.916C25.6218 35.9034 25.644 35.8961 25.6914 35.8972L25.7066 35.9085C25.7288 35.9173 25.7397 35.9083 25.7595 35.9009C25.7887 35.9134 25.8041 35.9144 25.8352 35.916C25.8384 35.8767 25.839 35.842 25.8354 35.8025C25.8038 35.8022 25.7816 35.7796 25.7383 35.7794C25.6373 35.7789 25.5265 35.8035 25.4277 35.7795L25.3987 35.7718Z"
          fill="#B90822"
        />
        <path
          id="Vector_3"
          d="M26.1926 37.2405C26.2765 37.2574 26.3475 37.2811 26.4343 37.2796L26.4595 37.2811C26.5692 37.3057 26.6995 37.295 26.8107 37.2818C26.8354 37.3421 26.8551 37.3951 26.8622 37.4601L26.8302 37.4808C26.7021 37.5064 26.5434 37.5365 26.4249 37.4679L26.1926 37.2405Z"
          fill="#420D27"
        />
        <path
          id="Vector_4"
          d="M26.0337 36.8051L26.2552 36.8042C26.2927 36.8518 26.2811 36.8721 26.2905 36.9287L26.3144 36.9315C26.3368 37.0585 26.3668 37.1682 26.4344 37.2796C26.3475 37.2811 26.2765 37.2574 26.1926 37.2405L26.1564 37.1996C26.1326 37.119 26.0864 37.035 26.0579 36.9533L26.0337 36.8051Z"
          fill="#56334E"
        />
        <path
          id="Vector_5"
          d="M26.0337 36.8051L26.2552 36.8042C26.2927 36.8518 26.2811 36.8721 26.2905 36.9287C26.2148 36.9544 26.1371 36.9516 26.0579 36.9533L26.0337 36.8051Z"
          fill="#250C28"
        />
        <path
          id="Vector_6"
          d="M26.3143 36.9315L26.5359 36.9349L26.5372 36.9457L26.7043 36.9465L27.0852 36.9424C27.0507 37.0795 26.9978 37.1758 26.8719 37.249L26.8107 37.2818C26.6995 37.295 26.5692 37.3057 26.4595 37.2811L26.4343 37.2796C26.3668 37.1682 26.3368 37.0585 26.3143 36.9315Z"
          fill="#56334E"
        />
        <path
          id="Vector_7"
          d="M26.5372 36.9456L26.7044 36.9465L26.6953 37.2556C26.6624 37.2872 26.5846 37.2751 26.5376 37.2752L26.5372 36.9456Z"
          fill="#886676"
        />
        <path
          id="Vector_8"
          d="M26.3143 36.9315L26.5359 36.9349L26.5372 36.9457L26.5376 37.2752L26.4595 37.2811L26.4343 37.2796C26.3668 37.1682 26.3368 37.0585 26.3143 36.9315Z"
          fill="#8E8796"
        />
        <path
          id="Vector_9"
          d="M25.8769 35.5839L26.0806 35.5839L26.5378 35.5841L26.7686 35.5824C26.8087 35.6298 26.7897 35.692 26.7857 35.7527L26.814 35.7518C26.7666 35.8056 26.7823 35.8616 26.7819 35.9315L26.7673 35.9302L26.526 35.9329L26.1718 35.9323L26.1605 35.7654L25.9637 35.7656L25.3987 35.7718L25.3575 35.7419C25.3571 35.6963 25.3488 35.6357 25.3735 35.5966C25.5102 35.56 25.7312 35.5845 25.8769 35.5839Z"
          fill="#FBFAFB"
        />
        <path
          id="Vector_10"
          d="M26.7857 35.7527L26.814 35.7518C26.7666 35.8056 26.7823 35.8616 26.7819 35.9315L26.7673 35.9303L26.526 35.933L26.5255 35.912C26.5232 35.8628 26.528 35.8142 26.5318 35.7652C26.6168 35.7655 26.7021 35.7699 26.7857 35.7527Z"
          fill="#5F112B"
        />
        <path
          id="Vector_11"
          d="M26.5255 35.912L26.5541 35.9009L26.5607 35.8798C26.5712 35.8483 26.5663 35.8602 26.5847 35.8298C26.6507 35.8449 26.6868 35.8568 26.7351 35.9062C26.7511 35.9226 26.744 35.9161 26.7673 35.9302L26.5261 35.9329L26.5255 35.912Z"
          fill="#88235D"
        />
        <path
          id="Vector_12"
          d="M26.1605 35.7654L26.5318 35.7652C26.528 35.8142 26.5232 35.8628 26.5255 35.912L26.526 35.9329L26.1718 35.9323L26.1605 35.7654Z"
          fill="#9F2B44"
        />
        <path
          id="Vector_13"
          d="M35.1459 13.7884C35.2516 13.7506 35.3765 13.7035 35.4875 13.6914C35.5828 13.681 35.8049 13.7457 35.8797 13.8088L35.8766 13.8898C35.8515 14.0267 35.8533 14.2011 35.8703 14.3396L35.4704 14.3395C35.3627 14.339 35.2415 14.3287 35.137 14.3551C35.1045 14.3428 35.0782 14.3255 35.0488 14.3072C35.0944 14.2651 35.1304 14.2076 35.1676 14.1578L35.1459 13.7884Z"
          fill="#130B24"
        />
        <path
          id="Vector_14"
          d="M25.9637 35.7656L26.1605 35.7654L26.1718 35.9323L26.526 35.9329L26.7672 35.9302C26.7655 35.9848 26.7683 36.0433 26.7581 36.0968C26.7491 36.1632 26.7442 36.2242 26.7484 36.2912L26.7407 36.2944L26.6411 36.2885L26.1632 36.2946L25.9545 36.2959L25.357 36.2997C25.3381 36.2456 25.3408 36.1532 25.3558 36.0975L25.3639 35.9539C25.4629 35.9155 25.6574 35.94 25.7681 35.9333L25.9726 35.9342C25.9622 35.8791 25.9648 35.8216 25.9637 35.7656Z"
          fill="#FBFAFB"
        />
        <path
          id="Vector_15"
          d="M25.9637 35.7656L26.1605 35.7654L26.1718 35.9323L25.9726 35.9342C25.9622 35.8791 25.9648 35.8216 25.9637 35.7656Z"
          fill="#5F112B"
        />
        <path
          id="Vector_16"
          d="M25.9526 36.0986L26.196 36.0982C26.1994 36.1565 26.2 36.2159 26.2137 36.2729L26.1632 36.2946L25.9545 36.2959C25.9477 36.2314 25.9523 36.1636 25.9526 36.0986Z"
          fill="#88051B"
        />
        <path
          id="Vector_17"
          d="M26.1959 36.0982L26.5103 36.0982L26.7581 36.0968C26.7491 36.1632 26.7442 36.2242 26.7484 36.2912L26.7407 36.2944L26.6411 36.2885L26.1632 36.2946L26.2136 36.2729C26.1999 36.2159 26.1994 36.1565 26.1959 36.0982Z"
          fill="#823578"
        />
        <path
          id="Vector_18"
          d="M26.5103 36.0982L26.7581 36.0968C26.7491 36.1632 26.7442 36.2242 26.7484 36.2912L26.7407 36.2944L26.6411 36.2885C26.6062 36.27 26.5892 36.2709 26.5504 36.2675L26.5429 36.2263L26.5315 36.1962C26.5277 36.1633 26.5362 36.1501 26.5208 36.1173L26.5103 36.0982Z"
          fill="#88235D"
        />
        <path
          id="Vector_19"
          d="M25.3558 36.0975L25.9526 36.0986C25.9523 36.1636 25.9476 36.2314 25.9545 36.2959L25.357 36.2997C25.3381 36.2456 25.3408 36.1532 25.3558 36.0975Z"
          fill="#B90822"
        />
        <path
          id="Vector_20"
          d="M26.1632 36.2946L26.6411 36.2885L26.7408 36.2944C26.7516 36.3523 26.764 36.4176 26.735 36.4712L26.8088 36.4721L27.0764 36.4831L27.0898 36.5658L27.0937 36.7936L27.0852 36.9424L26.7044 36.9465L26.5372 36.9457L26.5359 36.9349L26.3144 36.9315L26.2905 36.9287C26.2811 36.8721 26.2927 36.8518 26.2552 36.8042L26.0337 36.8051L26.026 36.659L25.9768 36.4697C25.8412 36.4467 25.6712 36.4644 25.5319 36.4634C25.4763 36.463 25.4081 36.4738 25.3605 36.4458L25.3571 36.2997L25.9545 36.2959L26.1632 36.2946Z"
          fill="#FBFAFB"
        />
        <path
          id="Vector_21"
          d="M25.9767 36.4697L26.2261 36.475L26.2534 36.571C26.1664 36.592 26.0988 36.6062 26.0259 36.659L25.9767 36.4697Z"
          fill="#250C28"
        />
        <path
          id="Vector_22"
          d="M26.2261 36.475L26.5325 36.4744L26.5468 36.5442C26.5645 36.5553 26.5789 36.565 26.5989 36.5716L26.5769 36.6509L26.5586 36.6556L26.5395 36.6269L26.5326 36.5821C26.4947 36.5529 26.3107 36.5707 26.2534 36.571L26.2261 36.475Z"
          fill="#420D27"
        />
        <path
          id="Vector_23"
          d="M26.0259 36.659C26.0988 36.6062 26.1663 36.592 26.2534 36.571L26.2577 36.7964L26.2552 36.8042L26.0337 36.8051L26.0259 36.659Z"
          fill="#9F2B44"
        />
        <path
          id="Vector_24"
          d="M26.2534 36.571C26.3107 36.5707 26.4947 36.5529 26.5326 36.5821L26.5395 36.6268C26.5379 36.6803 26.5414 36.7396 26.5303 36.7919L26.5122 36.7956L26.5328 36.8055L26.5359 36.9349L26.3143 36.9315L26.2905 36.9287C26.281 36.8721 26.2927 36.8518 26.2552 36.8042L26.2577 36.7964L26.2534 36.571Z"
          fill="#8E8796"
        />
        <path
          id="Vector_25"
          d="M26.2578 36.7964L26.5122 36.7956L26.5328 36.8055L26.5359 36.9349L26.3144 36.9315L26.2905 36.9287C26.2811 36.8721 26.2927 36.8518 26.2552 36.8042L26.2578 36.7964Z"
          fill="#473250"
        />
        <path
          id="Vector_26"
          d="M26.735 36.4711L26.8087 36.4721L27.0764 36.4831L27.0897 36.5657L27.0937 36.7936L27.0852 36.9424L26.7044 36.9465L26.5372 36.9457L26.5359 36.9349L26.5328 36.8055L26.5122 36.7956L26.5303 36.7919C26.5414 36.7396 26.5379 36.6803 26.5395 36.6268L26.5586 36.6556L26.5769 36.6509L26.5989 36.5716C26.579 36.565 26.5645 36.5553 26.5468 36.5442L26.5325 36.4744L26.735 36.4711Z"
          fill="#56334E"
        />
        <path
          id="Vector_27"
          d="M26.599 36.5716L26.7223 36.5677L26.7185 36.7946L26.5303 36.7919C26.5414 36.7396 26.5379 36.6803 26.5395 36.6268L26.5586 36.6556L26.5769 36.6509L26.599 36.5716Z"
          fill="#5D5670"
        />
        <path
          id="Vector_28"
          d="M26.735 36.4711L26.8087 36.4721L27.0764 36.4831L27.0897 36.5657L26.7223 36.5677L26.599 36.5716C26.579 36.565 26.5645 36.5553 26.5468 36.5442L26.5325 36.4744L26.735 36.4711Z"
          fill="#5F112B"
        />
        <path
          id="Vector_29"
          d="M26.5328 36.8055L27.0937 36.7936L27.0851 36.9424L26.7043 36.9465L26.5372 36.9456L26.5359 36.9349L26.5328 36.8055Z"
          fill="#250C28"
        />
        <path
          id="Vector_30"
          d="M25.6857 34.5292C25.8634 34.4564 26.1591 34.476 26.3499 34.4954L26.5401 34.5037L26.5378 35.5841L26.0806 35.5839L25.8769 35.5839L25.703 34.6724L25.6857 34.5292Z"
          fill="#5D5670"
        />
        <path
          id="Vector_31"
          d="M25.6857 34.5292C25.8634 34.4564 26.1591 34.476 26.3499 34.4954L25.8646 34.5052L26.0806 35.5839L25.8769 35.5839L25.703 34.6724L25.6857 34.5292Z"
          fill="#473250"
        />
        <path
          id="Vector_32"
          d="M26.7686 35.5824C26.8285 35.5905 26.8836 35.5962 26.944 35.5932L27.2047 35.5969L27.1867 35.7494L26.814 35.7518L26.7857 35.7527C26.7897 35.692 26.8087 35.6298 26.7686 35.5824Z"
          fill="#C7A7A3"
        />
        <path
          id="Vector_33"
          d="M27.2306 35.5912L27.6277 35.5985L27.7284 35.6049C27.7441 35.6475 27.7375 35.69 27.7346 35.7344C27.6973 35.7596 27.6423 35.7496 27.5972 35.7495C27.4603 35.7495 27.3235 35.7495 27.1866 35.7494L27.2047 35.5969L27.2306 35.5912Z"
          fill="#FA9072"
        />
        <path
          id="Vector_34"
          d="M27.1769 35.932L27.7122 35.9316L27.7335 35.9539C27.7321 35.9981 27.737 36.0589 27.7218 36.0995L27.1751 36.098L27.1769 35.932Z"
          fill="#F56D3B"
        />
        <path
          id="Vector_35"
          d="M27.1457 36.2965L27.6226 36.2987L27.7121 36.3076C27.7371 36.3497 27.7276 36.4149 27.7278 36.4645L27.146 36.4642L27.1457 36.2965Z"
          fill="#FA9072"
        />
        <path
          id="Vector_36"
          d="M26.7819 35.9315L27.1768 35.932L27.1751 36.098L27.7218 36.0995C27.7268 36.1596 27.7298 36.212 27.7201 36.2717C27.6877 36.2957 27.6617 36.2935 27.6226 36.2987L27.1457 36.2965L27.146 36.4642L26.8087 36.4721L26.735 36.4711C26.764 36.4176 26.7515 36.3523 26.7407 36.2944L26.7484 36.2912C26.7442 36.2242 26.7491 36.1632 26.7581 36.0968C26.7683 36.0433 26.7656 35.9848 26.7673 35.9303L26.7819 35.9315Z"
          fill="#5F112B"
        />
        <path
          id="Vector_37"
          d="M26.7819 35.9315L27.1768 35.932L27.1751 36.098L26.7581 36.0968C26.7683 36.0433 26.7656 35.9848 26.7673 35.9303L26.7819 35.9315Z"
          fill="#FA9072"
        />
        <path
          id="Vector_38"
          d="M26.7484 36.2912L27.1457 36.2965L27.146 36.4642L26.8087 36.4721L26.735 36.4711C26.764 36.4176 26.7515 36.3523 26.7407 36.2944L26.7484 36.2912Z"
          fill="#C7A7A3"
        />
        <path
          id="Vector_39"
          d="M27.6438 34.1595L27.7997 34.1566L27.6277 35.5985L27.2307 35.5912C27.259 35.4757 27.2516 35.3396 27.2683 35.2197C27.3171 34.8703 27.3869 34.5155 27.3976 34.1621L27.6438 34.1595Z"
          fill="#5F112B"
        />
        <path
          id="Vector_40"
          d="M26.5529 34.1633L27.3976 34.1621C27.3869 34.5155 27.317 34.8703 27.2683 35.2197C27.2516 35.3396 27.259 35.4757 27.2306 35.5912L27.2047 35.5969L26.9441 35.5932C26.8836 35.5962 26.8286 35.5905 26.7686 35.5824L26.5378 35.5841L26.5401 34.5037C26.5404 34.3923 26.5324 34.2727 26.5529 34.1633Z"
          fill="#250C28"
        />
        <path
          id="Vector_41"
          d="M26.5401 34.5037L26.9842 34.5058C26.9567 34.7245 26.9372 34.9469 26.9039 35.1644C26.8919 35.2428 26.8833 35.3239 26.8667 35.4013C26.8546 35.4579 26.8265 35.5185 26.8299 35.5763C26.8637 35.5787 26.917 35.5739 26.944 35.5932C26.8836 35.5962 26.8286 35.5905 26.7686 35.5824L26.5378 35.5841L26.5401 34.5037Z"
          fill="#473250"
        />
        <path
          id="Vector_42"
          d="M39.4623 16.826C39.9859 17.1845 40.4126 17.6313 40.5324 18.273L40.5775 18.5766L39.9344 18.113C39.908 17.9234 39.9425 17.7241 39.9072 17.5366C39.8578 17.2747 39.5978 17.1374 39.4844 16.9171L39.4781 16.904L39.4623 16.826Z"
          fill="#88051B"
        />
        <path
          id="Vector_43"
          d="M37.0716 16.16C37.208 16.1633 37.3668 16.1506 37.4998 16.176L37.7411 16.1985C37.9907 16.2066 38.2428 16.1902 38.4926 16.1862C38.6141 16.1842 38.7542 16.1708 38.8724 16.2033C39.0247 16.2451 39.1533 16.3495 39.2589 16.4624C39.2783 16.4832 39.2942 16.5032 39.3083 16.5282C39.377 16.6224 39.4258 16.7146 39.4622 16.826L39.478 16.904L39.4844 16.9171C39.5978 17.1374 39.8577 17.2747 39.9071 17.5366C39.9425 17.7241 39.9079 17.9234 39.9344 18.113L40.5775 18.5766L40.9127 18.8204L41.3101 19.0958L41.7516 19.417C41.6495 19.4505 41.5596 19.5226 41.4653 19.5741C41.3911 19.6146 41.2639 19.651 41.2253 19.7262C41.2415 19.9228 41.2314 20.1253 41.2306 20.3226C41.2301 20.4304 41.2428 20.5566 41.224 20.6622C41.0402 20.5092 40.8577 20.3863 40.636 20.2938C40.556 20.2605 40.4735 20.2316 40.3889 20.2128C40.3164 20.1968 40.179 20.197 40.1277 20.146L39.1306 20.1294L38.8389 20.1303L37.0716 16.16Z"
          fill="#130B24"
        />
        <path
          id="Vector_44"
          d="M39.9344 18.113L40.5775 18.5766L40.9127 18.8204L41.3101 19.0958L41.7517 19.417C41.6496 19.4505 41.5596 19.5226 41.4653 19.5741C41.3912 19.6146 41.2639 19.6509 41.2254 19.7261C41.2415 19.9228 41.2314 20.1253 41.2306 20.3226C41.2302 20.4304 41.2428 20.5565 41.224 20.6622C41.0402 20.5092 40.8578 20.3863 40.636 20.2938C40.5561 20.2605 40.4735 20.2316 40.3889 20.2128C40.3165 20.1967 40.179 20.197 40.1278 20.1459C39.9942 19.8418 39.8678 19.5347 39.7341 19.2306C39.6263 18.9853 39.4961 18.7407 39.4259 18.4816L39.4395 18.4884C39.6194 18.5757 39.7848 18.7061 39.9472 18.8227C39.9622 18.7513 39.9494 18.6606 39.9474 18.5877C39.9431 18.4295 39.9387 18.2713 39.9344 18.113Z"
          fill="#F8F5EC"
        />
        <path
          id="Vector_45"
          d="M39.9344 18.113L40.5775 18.5766L40.9127 18.8204L41.3101 19.0958L41.7516 19.417C41.6496 19.4505 41.5596 19.5226 41.4653 19.5741C41.3911 19.6146 41.2639 19.6509 41.2253 19.7261L39.9472 18.8227C39.9622 18.7513 39.9494 18.6606 39.9474 18.5877C39.943 18.4295 39.9387 18.2713 39.9344 18.113Z"
          fill="#56334E"
        />
        <path
          id="Vector_46"
          d="M37.4999 16.1759L37.7411 16.1985C37.9908 16.2066 38.2428 16.1902 38.4927 16.1862C38.6142 16.1842 38.7542 16.1708 38.8724 16.2033C39.0247 16.2451 39.1533 16.3495 39.259 16.4624C39.2784 16.4832 39.2942 16.5032 39.3083 16.5281C39.377 16.6224 39.4258 16.7146 39.4623 16.826L39.4781 16.904L39.4816 18.2618L38.4695 18.2664L38.3637 18.0268L37.4999 16.1759Z"
          fill="#473250"
        />
        <path
          id="Vector_47"
          d="M38.182 16.8628L38.5853 16.8823C38.7907 16.8985 38.8979 16.9324 39.0368 17.0951C39.0821 17.1483 39.1122 17.1995 39.1408 17.2631C39.1901 17.4763 39.1752 17.7174 39.1706 17.9355L38.6627 17.9351L38.182 16.8628Z"
          fill="#5D5670"
        />
        <path
          id="Vector_48"
          d="M38.5853 16.8823C38.7907 16.8985 38.898 16.9324 39.0368 17.0951C39.0821 17.1483 39.1122 17.1995 39.1408 17.2631L39.1347 17.3024C39.1162 17.3771 39.1159 17.5032 39.0719 17.5628C38.958 17.5529 38.8657 17.4321 38.7889 17.3564C38.6789 17.3444 38.5098 17.3514 38.4374 17.2571C38.4063 17.2167 38.4008 17.1797 38.4089 17.1289C38.4276 17.0108 38.497 16.9522 38.5853 16.8823Z"
          fill="#797388"
        />
        <path
          id="Vector_49"
          d="M37.9473 16.5113C38.2083 16.4958 38.5269 16.4725 38.7771 16.554C38.9806 16.6204 39.1556 16.7499 39.3163 16.8877C39.3151 16.769 39.2886 16.6451 39.3083 16.5282C39.377 16.6224 39.4258 16.7146 39.4623 16.826L39.4781 16.904L39.4816 18.2618L38.4695 18.2664L38.3637 18.0268C38.4371 17.9963 38.5565 18.0126 38.6359 18.0124C38.8586 18.0118 39.0813 18.0118 39.3041 18.012L39.3083 17.2369L39.2531 17.1616L39.1566 17.0432C39.0862 16.9679 39.0107 16.8829 38.9228 16.8286C38.6661 16.67 38.3234 16.7031 38.0328 16.6936L37.9473 16.5113Z"
          fill="#5D5670"
        />
        <path
          id="Vector_50"
          d="M42.8718 32.2035C42.8952 32.2777 42.8895 32.3553 42.8891 32.4323L42.8943 32.5673L42.9325 32.5939C42.9077 32.6623 42.9191 32.7536 42.9197 32.8262C42.917 32.8734 42.9073 32.9256 42.9272 32.9697C43.0019 32.9928 43.1502 32.9641 43.2353 32.9655L43.2325 33.2255L43.5307 33.2261L43.6686 33.2277C43.6928 33.269 43.6834 33.3364 43.6827 33.3841L43.2366 33.374L43.2361 33.6368L43.2646 33.6461C43.2401 33.691 43.2368 33.7161 43.238 33.7665L43.293 33.7946L43.4337 33.7894C43.4447 33.8695 43.4532 33.9595 43.5243 34.0114C43.5858 34.0564 43.6548 34.0457 43.6743 34.1299L43.6867 34.2056C43.7205 34.2243 43.7371 34.2183 43.7744 34.2167L43.7916 34.3327L43.797 34.7147L43.8021 34.7394C43.8409 34.9373 43.7347 35.153 43.9347 35.2929L43.9451 35.2998L43.9458 35.3069C43.9316 35.4068 43.905 35.4968 43.8844 35.5945L43.4755 35.5996C43.4699 35.649 43.4583 35.6931 43.4755 35.7407L43.5225 35.7539C43.5457 35.808 43.5489 35.8187 43.5264 35.8731L43.4955 35.9334C43.456 35.9893 43.4654 36.0145 43.4661 36.0815C43.5087 36.1077 43.5744 36.0969 43.625 36.0965C43.6235 36.1779 43.6236 36.2218 43.5732 36.2875L43.5011 36.305C43.4563 36.338 43.4599 36.3484 43.4463 36.4004L43.4564 36.4382C43.4808 36.4502 43.499 36.4593 43.5258 36.4648L43.5391 36.4887C43.4252 36.6366 43.2913 36.7684 43.1639 36.9046C42.9909 37.0895 42.8191 37.2756 42.6458 37.4603C42.1169 38.0238 41.5833 38.5889 41.0374 39.1359C40.6794 39.4946 40.3073 39.8381 39.9541 40.2017L38.1494 41.9416L34.4193 41.9393L33.419 40.9658L32.9403 40.4684C31.8982 39.2948 30.801 38.1697 29.736 37.0167C29.5225 36.7855 29.3085 36.5546 29.0963 36.3222C28.9978 36.2144 28.8513 36.0824 28.785 35.9528L31.1899 37.7963C31.2119 37.9073 31.3533 37.9826 31.4375 38.0502C31.8987 38.42 32.322 38.8711 32.7225 39.3049C32.857 39.4506 32.9879 39.5992 33.1259 39.7418C33.1816 39.7994 33.2391 39.8694 33.3031 39.9173C33.4134 39.8702 33.5932 39.902 33.7139 39.9009C33.7761 39.9004 33.8345 39.91 33.8797 39.8647C33.9192 39.8879 33.945 39.9013 33.9923 39.9046C34.0429 39.8964 34.0961 39.8991 34.1475 39.8988L34.4652 39.8973C34.5469 39.9418 34.7729 39.9145 34.8721 39.9147L34.883 39.9007C34.9604 39.926 35.0591 39.9038 35.1408 39.9008C35.2731 39.896 35.4061 39.901 35.5385 39.9005C35.632 39.9001 35.7305 39.8915 35.8211 39.9154L35.8284 39.9049L36.1951 39.91L36.6901 39.912L37.2816 39.9157L37.2787 39.7269L37.4274 39.6153L39.4232 38.0618C39.3707 37.9126 39.4287 37.7075 39.4062 37.5464L39.4095 37.5367C39.5038 37.4959 39.5918 37.4138 39.6737 37.3512C39.8028 37.2524 39.9344 37.1563 40.0644 37.0586C40.6059 36.6514 41.1448 36.2414 41.6874 35.8355C41.8261 35.7318 41.9593 35.6213 42.0944 35.5131C42.1256 35.4881 42.2139 35.4265 42.2283 35.3948C42.2392 35.3709 42.2394 35.3185 42.2435 35.2908C42.2445 35.3323 42.2419 35.3661 42.2586 35.405L42.5667 35.4667L42.5715 32.4471L42.5825 32.4496L42.5965 32.4165C42.6201 32.4307 42.6084 32.4254 42.6357 32.4345L42.6597 32.4423L42.6766 32.4504C42.7308 32.4719 42.7813 32.4638 42.8338 32.4438C42.8815 32.3943 42.8658 32.2749 42.8718 32.2035Z"
          fill="url(#paint4_linear_11_402)"
        />
        <path
          id="Vector_51"
          d="M42.9214 33.632L43.2361 33.6369L43.2646 33.6461C43.2401 33.691 43.2368 33.7161 43.238 33.7665L43.293 33.7946L42.9752 33.8039L42.9309 33.7742L42.9214 33.632Z"
          fill="#130B24"
        />
        <path
          id="Vector_52"
          d="M43.5307 33.2261L43.6686 33.2277C43.6927 33.269 43.6833 33.3364 43.6826 33.3841L43.2365 33.3741C43.1545 33.3678 42.9858 33.3974 42.9215 33.3568L42.9195 33.2595C42.9262 33.2513 42.9299 33.239 42.9397 33.2349C42.9598 33.2264 43.0228 33.2351 43.0489 33.2351C43.1996 33.2354 43.3696 33.2535 43.5171 33.2286L43.5307 33.2261Z"
          fill="#130B24"
        />
        <path
          id="Vector_53"
          d="M42.5715 32.4471L42.5825 32.4496L42.5824 35.6253L39.4232 38.0618C39.3707 37.9126 39.4287 37.7075 39.4062 37.5464L39.4095 37.5367C39.5038 37.4959 39.5918 37.4138 39.6737 37.3512C39.8028 37.2524 39.9345 37.1563 40.0644 37.0586C40.6059 36.6514 41.1448 36.2414 41.6874 35.8355C41.8261 35.7318 41.9593 35.6213 42.0944 35.5131C42.1256 35.4881 42.2139 35.4265 42.2283 35.3948C42.2392 35.3709 42.2394 35.3185 42.2435 35.2908C42.2445 35.3324 42.2419 35.3661 42.2586 35.405L42.5667 35.4667L42.5715 32.4471Z"
          fill="#C7A7A3"
        />
        <path
          id="Vector_54"
          d="M33.8797 39.8647C33.9192 39.8879 33.945 39.9013 33.9922 39.9046C34.0429 39.8964 34.0961 39.8991 34.1475 39.8988L34.4652 39.8973C34.5469 39.9418 34.7729 39.9145 34.8721 39.9147L34.883 39.9007C34.9604 39.926 35.0591 39.9038 35.1408 39.9008C35.2731 39.896 35.4061 39.901 35.5385 39.9005C35.632 39.9001 35.7304 39.8915 35.8211 39.9155L35.8284 39.9049L36.1951 39.91L36.6901 39.912L37.2816 39.9157L37.2859 40.1605L37.289 40.3072L37.2869 40.6941L33.456 40.6982L33.4527 40.3149C33.4521 40.264 33.4535 40.2163 33.4603 40.1659C33.4525 40.046 33.3835 39.997 33.303 39.9173C33.4133 39.8702 33.5932 39.902 33.7139 39.901C33.7761 39.9004 33.8344 39.91 33.8797 39.8647Z"
          fill="#473250"
        />
        <path
          id="Vector_55"
          d="M33.4603 40.1659L37.2859 40.1605L37.289 40.3072L33.4527 40.3149C33.4521 40.264 33.4535 40.2163 33.4603 40.1659Z"
          fill="#1B1536"
        />
        <path
          id="Vector_56"
          d="M33.8797 39.8647C33.9192 39.8879 33.945 39.9013 33.9922 39.9046C34.0429 39.8964 34.0961 39.8991 34.1475 39.8988L34.4652 39.8973C34.5469 39.9418 34.7728 39.9145 34.8721 39.9147L34.883 39.9007C34.9604 39.926 35.0591 39.9038 35.1408 39.9008C35.2731 39.896 35.406 39.901 35.5385 39.9005C35.6319 39.9001 35.7304 39.8915 35.8211 39.9155L35.8284 39.9049L36.1951 39.91L36.6901 39.912L37.2815 39.9157L37.2859 40.1605L33.4603 40.1659C33.4525 40.046 33.3835 39.997 33.303 39.9173C33.4133 39.8702 33.5932 39.902 33.7139 39.901C33.7761 39.9004 33.8344 39.91 33.8797 39.8647Z"
          fill="#434D6A"
        />
        <path
          id="Vector_57"
          d="M34.883 39.9007C34.9604 39.9261 35.0591 39.9038 35.1408 39.9008C35.2731 39.896 35.4061 39.901 35.5385 39.9005C35.632 39.9001 35.7305 39.8915 35.8211 39.9155C35.714 39.951 35.5932 39.9408 35.4815 39.9413C35.2817 39.9421 35.068 39.9559 34.8721 39.9147L34.883 39.9007Z"
          fill="#797388"
        />
        <path
          id="Vector_58"
          d="M43.4783 34.338C43.5707 34.4771 43.6814 34.5949 43.797 34.7147L43.8021 34.7394C43.8409 34.9373 43.7347 35.153 43.9347 35.2929L43.9451 35.2998L43.9458 35.3069C43.9316 35.4068 43.905 35.4968 43.8844 35.5945L43.4755 35.5996L43.4783 34.338Z"
          fill="#D31D22"
        />
        <path
          id="Vector_59"
          d="M44.8727 36.0865L45.1631 36.0804C45.1243 36.0943 45.0818 36.1025 45.0588 36.1393L45.0698 36.1736L45.0073 36.2869C44.9621 36.2898 44.9155 36.2906 44.871 36.2988L44.8727 36.0865Z"
          fill="#620210"
        />
        <path
          id="Vector_60"
          d="M46.6572 37.7287L46.6976 37.7551L46.6936 37.7903C46.639 37.833 46.0992 37.8139 45.9829 37.8263C45.9508 37.8022 45.9201 37.7815 45.8975 37.7476C45.9324 37.7246 46.0386 37.7362 46.0849 37.7361C46.2757 37.7353 46.4666 37.7364 46.6572 37.7287Z"
          fill="#420D27"
        />
        <path
          id="Vector_61"
          d="M43.9458 35.3069C44.041 35.3473 44.1286 35.3737 44.2323 35.3783C44.3744 35.3644 44.5219 35.3722 44.6647 35.3731C44.7263 35.3736 44.8004 35.365 44.8587 35.3832L44.8529 35.5836C45.0918 35.583 45.3307 35.5825 45.5695 35.5824C45.6703 35.5824 45.7921 35.567 45.8881 35.5929C45.9188 35.6361 45.9124 35.6453 45.9093 35.6965C45.8858 35.7154 45.871 35.7243 45.8407 35.7305C45.7555 35.7478 45.6472 35.7348 45.5592 35.7351C45.3273 35.7357 45.0953 35.7357 44.8634 35.7357L43.4755 35.7407C43.4583 35.6932 43.4699 35.649 43.4755 35.5996L43.8844 35.5945C43.905 35.4968 43.9316 35.4068 43.9458 35.3069Z"
          fill="#FBFAFB"
        />
        <path
          id="Vector_62"
          d="M43.9458 35.3069C44.041 35.3473 44.1286 35.3737 44.2323 35.3783L44.236 35.5874L43.8844 35.5945C43.905 35.4968 43.9316 35.4068 43.9458 35.3069Z"
          fill="#5F112B"
        />
        <path
          id="Vector_63"
          d="M44.2323 35.3783C44.3743 35.3644 44.5219 35.3722 44.6647 35.3731C44.7263 35.3736 44.8004 35.365 44.8587 35.3832L44.8529 35.5836L44.2359 35.5873L44.2323 35.3783Z"
          fill="#ED3131"
        />
        <path
          id="Vector_64"
          d="M43.4755 35.7407L44.8634 35.7357L44.8628 35.9356C45.0911 35.9362 45.3195 35.9371 45.5478 35.938C45.6195 35.9383 45.7501 35.9209 45.8101 35.9599C45.8252 35.9991 45.8244 36.0034 45.8154 36.0447C45.7049 36.1138 45.3107 36.0674 45.1631 36.0804L44.8727 36.0865C44.6793 36.1107 44.47 36.0961 44.2747 36.0957L43.8648 36.0955L43.6249 36.0965C43.5744 36.0969 43.5087 36.1077 43.4661 36.0815C43.4653 36.0145 43.456 35.9893 43.4955 35.9334L43.5263 35.8731C43.5489 35.8187 43.5457 35.808 43.5225 35.7539L43.4755 35.7407Z"
          fill="#FBFAFB"
        />
        <path
          id="Vector_65"
          d="M43.5225 35.7539L43.8895 35.7501L43.896 35.9395L43.4955 35.9334L43.5263 35.8731C43.5489 35.8187 43.5457 35.808 43.5225 35.7539Z"
          fill="#ED3131"
        />
        <path
          id="Vector_66"
          d="M43.4755 35.7407L44.8634 35.7357L44.8628 35.9356L44.2681 35.9369L43.8961 35.9395L43.8895 35.7501L43.5225 35.7539L43.4755 35.7407Z"
          fill="#F56D3B"
        />
        <path
          id="Vector_67"
          d="M43.8895 35.7501L44.2728 35.7459L44.2681 35.9369L43.896 35.9396L43.8895 35.7501Z"
          fill="#88051B"
        />
        <path
          id="Vector_68"
          d="M44.2747 36.0957C44.47 36.0961 44.6793 36.1107 44.8727 36.0865L44.871 36.2988L44.8988 36.3031C45.0713 36.3281 45.8242 36.2725 45.9158 36.3323C45.9149 36.3834 45.9184 36.4015 45.8914 36.4461C45.7894 36.475 45.6626 36.4596 45.5557 36.4596C45.3321 36.4596 45.1086 36.459 44.885 36.4584C44.8856 36.5979 44.8861 36.7375 44.8856 36.877C44.8854 36.9543 44.8963 37.0415 44.8621 37.1119C44.8178 37.1398 44.8178 37.1406 44.766 37.1345C44.7147 37.0568 44.7463 36.581 44.7479 36.4572L44.4609 36.4572C44.4611 36.5854 44.4611 36.7135 44.4605 36.8416C44.4602 36.8998 44.469 36.9663 44.4434 37.0194C44.402 37.0401 44.3895 37.0353 44.3445 37.0309C44.2995 36.9678 44.3101 36.8945 44.31 36.8188C44.3098 36.6981 44.3103 36.5774 44.3108 36.4567L43.88 36.4581C43.8449 36.5153 43.8079 36.5716 43.7804 36.6329C43.7031 36.5686 43.6294 36.5314 43.5391 36.4887L43.5257 36.4648C43.499 36.4593 43.4807 36.4502 43.4564 36.4382L43.4463 36.4004C43.4599 36.3484 43.4563 36.338 43.5011 36.305L43.5732 36.2875C43.6235 36.2218 43.6234 36.1779 43.6249 36.0965L43.8648 36.0955L44.2747 36.0957Z"
          fill="#FBFAFB"
        />
        <path
          id="Vector_69"
          d="M43.5258 36.4649L43.88 36.4581C43.845 36.5153 43.8079 36.5716 43.7805 36.6329C43.7031 36.5686 43.6294 36.5315 43.5391 36.4887L43.5258 36.4649Z"
          fill="#ED3131"
        />
        <path
          id="Vector_70"
          d="M44.2747 36.0957C44.47 36.0961 44.6793 36.1107 44.8726 36.0865L44.8709 36.2988L43.501 36.305L43.5732 36.2875C43.6235 36.2218 43.6234 36.1779 43.6249 36.0965L43.8647 36.0955L44.2747 36.0957Z"
          fill="#ED3131"
        />
        <path
          id="Vector_71"
          d="M43.6249 36.0965L43.8647 36.0955L43.8695 36.2939L43.5732 36.2875C43.6235 36.2218 43.6234 36.1779 43.6249 36.0965Z"
          fill="#D31D22"
        />
        <path
          id="Vector_72"
          d="M43.8647 36.0955L44.2747 36.0957L44.2605 36.2946L43.8695 36.2939L43.8647 36.0955Z"
          fill="#620210"
        />
        <path
          id="Vector_73"
          d="M45.4255 23.752C45.5046 23.7773 45.5823 23.8066 45.6503 23.8552C45.8164 24.0147 45.9838 24.1743 46.1223 24.3591C46.397 24.7258 46.5379 25.1792 46.5478 25.6357L46.5496 26.9626C46.5148 26.9955 46.4791 26.9847 46.4322 26.9855L45.9182 26.9863C45.9164 26.5699 45.9171 26.1534 45.9045 25.7372C45.8926 25.3423 45.8685 24.9306 45.7621 24.5483C45.6836 24.2666 45.5626 24.0088 45.4255 23.752Z"
          fill="#886676"
        />
        <path
          id="Vector_74"
          d="M44.4905 34.2062C44.7347 34.2047 44.9788 34.2033 45.223 34.2025C45.3231 34.2022 45.4545 34.1845 45.5479 34.214L45.5425 34.2362C45.5272 34.3028 45.5319 34.3814 45.5296 34.4496C45.5254 34.5769 45.5229 34.704 45.5222 34.8313C45.5209 35.0339 45.5356 35.1953 45.3434 35.3222C45.2302 35.397 45.0569 35.4385 44.9218 35.4089C44.8992 35.4039 44.8843 35.3986 44.8654 35.3859L44.8587 35.3832C44.8004 35.365 44.7263 35.3736 44.6647 35.3731C44.5219 35.3722 44.3743 35.3644 44.2323 35.3783C44.1286 35.3736 44.041 35.3472 43.9458 35.3069L43.9451 35.2998L43.9346 35.2929C43.7347 35.153 43.8409 34.9373 43.8021 34.7394L43.797 34.7147L43.7915 34.3328L43.7744 34.2167C43.8462 34.197 43.9385 34.207 44.0133 34.2068C44.1724 34.2063 44.3314 34.2062 44.4905 34.2062Z"
          fill="#434D6A"
        />
        <path
          id="Vector_75"
          d="M43.7916 34.3327L44.7402 34.3294L43.9801 34.3374C43.977 34.5287 43.9689 34.7185 43.9617 34.9094C43.9568 35.0395 43.9647 35.1708 43.9451 35.2998L43.9347 35.2929C43.7347 35.153 43.8409 34.9373 43.8022 34.7394L43.797 34.7147L43.7916 34.3327Z"
          fill="#473250"
        />
        <path
          id="Vector_76"
          d="M44.4905 34.2062C44.7347 34.2047 44.9788 34.2033 45.223 34.2025C45.3231 34.2022 45.4545 34.1845 45.5479 34.214L45.5425 34.2362C45.5272 34.3028 45.5319 34.3814 45.5296 34.4496C45.5254 34.5769 45.5229 34.704 45.5222 34.8313C45.5209 35.0339 45.5356 35.1953 45.3434 35.3222C45.2302 35.397 45.0569 35.4385 44.9218 35.4089C44.8992 35.4039 44.8843 35.3986 44.8654 35.3859L44.9529 35.3546C44.9637 35.3424 44.9778 35.3325 44.9853 35.3181C45.0087 35.2739 45.0014 35.1387 45.0041 35.0827C45.0161 34.8322 45.0284 34.5818 45.0361 34.3311L44.7402 34.3294L43.7915 34.3327L43.7744 34.2167C43.8462 34.197 43.9385 34.207 44.0133 34.2067C44.1724 34.2063 44.3314 34.2062 44.4905 34.2062Z"
          fill="#1B1536"
        />
        <path
          id="Vector_77"
          d="M45.0641 27.3398C45.1605 27.3232 45.2709 27.3327 45.3688 27.3335C45.5496 27.335 45.7305 27.3357 45.9113 27.3363L46.2545 27.3346C46.2572 27.384 46.2565 27.4364 46.2701 27.4842C46.2961 27.5308 46.2892 27.5659 46.2838 27.6165L46.2702 27.6344C46.2544 27.717 46.2436 27.7963 46.2108 27.8743L46.2146 27.8941C46.2334 27.8994 46.261 27.8991 46.269 27.9189C46.2811 27.9491 46.2721 27.9963 46.2624 28.0266L46.2181 28.0601C46.219 28.1318 46.2141 28.2089 46.2259 28.2796L46.2655 28.3028C46.2767 28.3497 46.2777 28.3797 46.2723 28.4277C46.2584 28.4989 46.2363 28.6407 46.2619 28.7085L46.2946 28.7412C46.287 28.7746 46.2781 28.8019 46.2633 28.8328C46.2594 28.8948 46.2524 28.9583 46.2557 29.0204L46.2843 29.0242C46.3141 28.9467 46.3432 28.9014 46.3981 28.8391L47.0578 28.8333C47.0946 28.8941 47.1346 28.9518 47.1524 29.0213C47.1341 29.1482 47.1447 29.2868 47.1452 29.4153C47.1462 29.6492 47.1473 29.883 47.1484 30.1168C47.1518 30.8709 47.1494 31.6249 47.154 32.3789L47.1546 32.6425C47.1563 32.7679 47.1819 32.949 47.1283 33.0622C47.0359 33.1962 46.9144 33.2965 46.7915 33.4013C46.6538 33.5188 46.5171 33.6332 46.3682 33.7363L46.3408 33.7288L46.2945 33.6228C46.2676 33.6313 46.2793 33.6232 46.2627 33.6468C46.214 33.7162 46.1882 33.7489 46.1024 33.7605L45.8074 33.7672L45.8078 33.9282C45.7494 33.9664 45.6872 34.002 45.6376 34.0513C45.6142 33.9704 45.6232 33.8591 45.6208 33.7737C45.6141 33.5369 45.6122 33.3002 45.6104 33.0634C45.6059 32.452 45.5972 31.8408 45.5931 31.2294C45.5843 29.935 45.5368 28.6412 45.5416 27.3469L45.0641 27.3398Z"
          fill="#434D6A"
        />
        <path
          id="Vector_78"
          d="M45.9165 27.3516C45.9213 27.3893 45.9268 27.4242 45.9211 27.4622C45.8701 27.4843 45.8005 27.4741 45.7456 27.4728L45.7176 27.4507C45.7267 27.426 45.7246 27.4108 45.7195 27.3857L45.7133 27.3562L45.9165 27.3516Z"
          fill="#47667E"
        />
        <path
          id="Vector_79"
          d="M45.7714 28.8519L45.9108 28.8455L45.9088 29.1052L45.7519 29.1059L45.7501 29.0891C45.7463 29.0249 45.7286 28.8968 45.7714 28.8519Z"
          fill="#47667E"
        />
        <path
          id="Vector_80"
          d="M45.7324 28.4535L45.9167 28.4446L45.9119 28.6807L45.8685 28.6982C45.8214 28.691 45.7817 28.6995 45.7375 28.6775L45.7324 28.4535Z"
          fill="#434D6A"
        />
        <path
          id="Vector_81"
          d="M45.8109 28.0378L45.9065 28.0388C45.9393 28.0755 45.9286 28.2067 45.9231 28.2593L45.9189 28.2844L45.7319 28.2816L45.7295 28.0418L45.8109 28.0378Z"
          fill="#47667E"
        />
        <path
          id="Vector_82"
          d="M45.7237 27.6529L45.9243 27.6457L45.9264 27.8926L45.7594 27.9002L45.7267 27.886L45.7237 27.6529Z"
          fill="#47667E"
        />
        <path
          id="Vector_83"
          d="M45.7714 28.8519L45.7482 28.832C45.7448 28.7887 45.7387 28.7504 45.7551 28.7089L45.8685 28.7037L46.262 28.7085L46.2946 28.7412C46.287 28.7745 46.2781 28.8019 46.2633 28.8328C46.1481 28.8347 46.0244 28.828 45.9108 28.8455L45.7714 28.8519Z"
          fill="#130B24"
        />
        <path
          id="Vector_84"
          d="M45.9142 28.3004L46.2655 28.3028C46.2767 28.3497 46.2777 28.3797 46.2723 28.4276C46.1603 28.4293 46.025 28.4184 45.9167 28.4446L45.7324 28.4535C45.7278 28.4081 45.7203 28.3364 45.7476 28.3015L45.9142 28.3004Z"
          fill="#130B24"
        />
        <path
          id="Vector_85"
          d="M45.9108 28.8455C46.0244 28.828 46.1481 28.8347 46.2633 28.8328C46.2594 28.8948 46.2524 28.9582 46.2557 29.0204L46.2844 29.0242L46.2885 29.0448L46.2781 29.0509C46.1606 29.0856 46.0318 29.1059 45.9088 29.1052L45.9108 28.8455Z"
          fill="#5F112B"
        />
        <path
          id="Vector_86"
          d="M46.2781 29.0509L46.2823 29.2718L45.9161 29.2669L45.7779 29.2672C45.7445 29.2337 45.7543 29.1541 45.752 29.1059L45.9088 29.1052C46.0319 29.1059 46.1606 29.0856 46.2781 29.0509Z"
          fill="#130B24"
        />
        <path
          id="Vector_87"
          d="M45.9167 28.4446C46.025 28.4184 46.1603 28.4293 46.2723 28.4276C46.2584 28.4989 46.2364 28.6407 46.262 28.7085L45.8685 28.7037L45.8686 28.6982L45.9119 28.6807L45.9167 28.4446Z"
          fill="#5F112B"
        />
        <path
          id="Vector_88"
          d="M45.9264 27.8926L46.2146 27.8941C46.2334 27.8994 46.261 27.8991 46.269 27.9189C46.2811 27.9491 46.2722 27.9963 46.2624 28.0266L46.2181 28.0601C46.219 28.1318 46.2141 28.2089 46.2259 28.2795L46.2656 28.3028L45.9142 28.3004L45.9189 28.2844L45.923 28.2593C45.9286 28.2067 45.9393 28.0755 45.9065 28.0388L45.8109 28.0378L45.7295 28.0418C45.7242 27.9997 45.7286 27.9585 45.7309 27.9163L45.7594 27.9002L45.9264 27.8926Z"
          fill="#5F112B"
        />
        <path
          id="Vector_89"
          d="M45.9264 27.8926L46.2146 27.8941C46.2334 27.8994 46.261 27.8991 46.269 27.9189C46.2811 27.9491 46.2722 27.9963 46.2624 28.0266C46.1614 28.0297 46.0604 28.0312 45.9594 28.0322C45.9144 28.0326 45.8536 28.026 45.8109 28.0378L45.7295 28.0418C45.7242 27.9997 45.7286 27.9585 45.7309 27.9163L45.7594 27.9002L45.9264 27.8926Z"
          fill="url(#paint5_linear_11_402)"
        />
        <path
          id="Vector_90"
          d="M46.2884 29.0448L46.2922 29.5019L46.2925 29.6738L45.9204 29.683L45.8062 29.6764L45.7994 29.5097C45.8433 29.5058 45.8792 29.5116 45.9139 29.4829L45.916 29.2669L46.2823 29.2718L46.2781 29.0509L46.2884 29.0448Z"
          fill="#250C28"
        />
        <path
          id="Vector_91"
          d="M45.7994 29.5097L46.2922 29.5019L46.2925 29.6738L45.9204 29.683L45.8062 29.6764L45.7994 29.5097Z"
          fill="#130B24"
        />
        <path
          id="Vector_92"
          d="M45.9114 27.3363L46.2545 27.3346C46.2572 27.384 46.2565 27.4364 46.2701 27.4841C46.2961 27.5308 46.2892 27.5659 46.2838 27.6165L46.2702 27.6344C46.2544 27.717 46.2436 27.7963 46.2108 27.8743L46.2146 27.8941L45.9264 27.8926L45.9243 27.6457L45.7237 27.6529C45.7257 27.5929 45.7254 27.5379 45.7462 27.4808L45.7456 27.4728C45.8005 27.4741 45.8701 27.4843 45.9211 27.4622C45.9268 27.4242 45.9213 27.3893 45.9165 27.3516L45.9114 27.3363Z"
          fill="#130B24"
        />
        <path
          id="Vector_93"
          d="M45.9113 27.3363L46.2544 27.3346C46.2571 27.384 46.2565 27.4364 46.2701 27.4841L45.7461 27.4808L45.7455 27.4728C45.8004 27.4741 45.8701 27.4843 45.9211 27.4622C45.9268 27.4242 45.9213 27.3893 45.9165 27.3516L45.9113 27.3363Z"
          fill="#420D27"
        />
        <path
          id="Vector_94"
          d="M45.9243 27.6458C46.0205 27.6175 46.1677 27.6354 46.2703 27.6344C46.2544 27.717 46.2436 27.7963 46.2108 27.8743L46.2146 27.8941L45.9264 27.8926L45.9243 27.6458Z"
          fill="#420D27"
        />
        <path
          id="Vector_95"
          d="M46.2925 29.6738L46.3132 31.9785C46.2901 31.9663 46.2722 31.9611 46.2471 31.9547C46.1625 31.9964 46.0891 32.0541 46.0136 32.11C46.0156 32.023 46.0473 31.791 46.0032 31.7271C45.9371 31.7193 45.881 31.7326 45.8167 31.746L45.817 29.9305L45.8062 29.6764L45.9205 29.683L46.2925 29.6738Z"
          fill="#250C28"
        />
        <path
          id="Vector_96"
          d="M45.8062 29.6764L45.9205 29.683C45.9189 29.7463 45.9334 29.8664 45.8981 29.9158L45.817 29.9305L45.8062 29.6764Z"
          fill="#5F112B"
        />
        <path
          id="Vector_97"
          d="M45.8168 31.746C45.881 31.7326 45.9371 31.7193 46.0032 31.7271C46.0473 31.791 46.0156 32.023 46.0137 32.11C46.0891 32.0541 46.1625 31.9964 46.2471 31.9547C46.2722 31.9611 46.2901 31.9663 46.3132 31.9785L46.308 33.1697L46.4468 33.0682C46.4938 33.0313 46.5271 32.9828 46.5631 32.9356C46.5657 32.8395 46.5744 32.7404 46.5552 32.6456L47.1547 32.6425C47.1563 32.7679 47.1819 32.949 47.1283 33.0622C47.0359 33.1962 46.9144 33.2965 46.7915 33.4013C46.6538 33.5188 46.5171 33.6332 46.3682 33.7363L46.3408 33.7288L46.2945 33.6228C46.2676 33.6313 46.2793 33.6232 46.2627 33.6468C46.214 33.7162 46.1882 33.7489 46.1024 33.7605L45.8074 33.7673L45.8168 31.746Z"
          fill="#130B24"
        />
        <path
          id="Vector_98"
          d="M46.5552 32.6455L47.1547 32.6425C47.1563 32.7678 47.1819 32.9489 47.1283 33.0622C47.0417 33.0931 46.9486 33.0828 46.8581 33.0805C46.721 33.0772 46.5839 33.0728 46.4468 33.0681C46.4938 33.0313 46.5271 32.9828 46.5631 32.9356C46.5657 32.8394 46.5744 32.7404 46.5552 32.6455Z"
          fill="#434D6A"
        />
        <path
          id="Vector_99"
          d="M46.3981 28.8391L47.0578 28.8333C47.0946 28.8941 47.1346 28.9518 47.1525 29.0213C47.1341 29.1482 47.1447 29.2868 47.1452 29.4153C47.1462 29.6492 47.1473 29.883 47.1484 30.1168C47.1518 30.8709 47.1494 31.6249 47.154 32.3789L47.1547 32.6425L46.5552 32.6456C46.5744 32.7404 46.5657 32.8395 46.5631 32.9356C46.5271 32.9828 46.4938 33.0313 46.4468 33.0681L46.308 33.1697L46.3132 31.9785L46.2925 29.6738L46.2922 29.5019L46.2885 29.0448L46.2844 29.0242C46.3141 28.9467 46.3432 28.9014 46.3981 28.8391Z"
          fill="#434D6A"
        />
        <path
          id="Vector_100"
          d="M47.154 32.3789L47.1547 32.6425L46.5552 32.6456C46.5249 32.6119 46.5308 32.4417 46.5139 32.3824L47.154 32.3789Z"
          fill="#130B24"
        />
        <path
          id="Vector_101"
          d="M46.3981 28.8391L47.0578 28.8333C47.0946 28.8941 47.1346 28.9518 47.1525 29.0213C46.958 29.0193 46.6789 28.9738 46.5051 29.0667C46.4973 29.079 46.4859 29.0897 46.4817 29.1037C46.4715 29.138 46.4781 29.2069 46.4777 29.2438C46.4764 29.3596 46.4774 29.4755 46.4776 29.5913C46.4788 30.2068 46.4849 30.8221 46.4911 31.4376C46.493 31.6301 46.4927 31.8226 46.4938 32.0151C46.4944 32.123 46.4873 32.2546 46.5081 32.3602L46.5139 32.3824C46.5308 32.4417 46.5249 32.6119 46.5552 32.6456C46.5744 32.7404 46.5657 32.8395 46.5631 32.9356C46.5271 32.9828 46.4938 33.0313 46.4468 33.0681L46.308 33.1696L46.3132 31.9785L46.2925 29.6738L46.2922 29.5019L46.2885 29.0448L46.2844 29.0242C46.3141 28.9467 46.3432 28.9014 46.3981 28.8391Z"
          fill="url(#paint6_linear_11_402)"
        />
        <path
          id="Vector_102"
          d="M45.9182 26.9863L46.4322 26.9855L46.4324 27.3332L46.2544 27.3346L45.9113 27.3363C45.7305 27.3357 45.5496 27.335 45.3687 27.3335C45.2709 27.3327 45.1605 27.3231 45.0641 27.3398L45.5416 27.3469C45.5368 28.6412 45.5843 29.935 45.593 31.2294C45.5971 31.8408 45.6058 32.452 45.6104 33.0634C45.6122 33.3002 45.614 33.5369 45.6207 33.7737C45.6231 33.8591 45.6142 33.9704 45.6375 34.0513C45.6394 34.1066 45.6425 34.1463 45.617 34.1965L45.5479 34.214C45.4544 34.1845 45.3231 34.2022 45.223 34.2025C44.9788 34.2033 44.7346 34.2047 44.4904 34.2062C44.3314 34.2062 44.1724 34.2063 44.0133 34.2068C43.9385 34.207 43.8462 34.197 43.7744 34.2167C43.7371 34.2183 43.7205 34.2243 43.6867 34.2056L43.6743 34.1299C43.6548 34.0457 43.5858 34.0564 43.5243 34.0114C43.4532 33.9595 43.4447 33.8695 43.4337 33.7894L43.293 33.7946L43.238 33.7665C43.2368 33.7161 43.2401 33.691 43.2646 33.6461L43.2361 33.6369L43.2365 33.3741L43.6826 33.3841C43.6833 33.3364 43.6927 33.269 43.6686 33.2277L43.5307 33.2261L43.2325 33.2255L43.2353 32.9655C43.1501 32.9641 43.0018 32.9928 42.9272 32.9697C42.9073 32.9256 42.917 32.8734 42.9197 32.8262C42.9191 32.7536 42.9077 32.6623 42.9324 32.5939L42.8943 32.5673L42.8891 32.4323C42.8894 32.3553 42.8952 32.2777 42.8718 32.2035L42.8721 32.1947C42.8691 32.1342 42.8684 32.0783 42.8771 32.0183L42.9173 32.0092C42.9263 31.9662 42.9239 31.9186 42.925 31.8746L42.8666 31.8271C42.8666 31.7466 42.857 31.6571 42.8869 31.5814L42.9003 31.5537C42.9175 31.5009 42.8966 31.4136 42.864 31.3743C42.8594 31.3 42.8545 31.2359 42.873 31.1628C42.8749 31.1266 42.8774 31.0923 42.8843 31.0567L42.8904 31.0269C42.8799 31.0032 42.8698 30.9871 42.8551 30.9662L42.8572 30.7544L42.8573 30.5289L42.8585 30.3322L42.8951 30.3221C42.9021 30.2462 42.9063 30.1811 42.891 30.1053L42.8808 30.0986C42.8745 30.0398 42.8829 29.9802 42.888 29.9214C42.8967 29.8521 42.8859 29.7736 42.9117 29.7082L42.8918 29.679C42.8908 29.6208 42.8773 29.5556 42.9078 29.5056L43.0697 29.5019L43.1909 29.5093L43.1887 29.2438C43.3151 29.2434 43.4414 29.2429 43.5677 29.2424C43.6152 29.2422 43.6592 29.2523 43.6988 29.2244L43.6979 29.123C43.6415 29.0765 43.2709 29.1035 43.1765 29.1036L43.1721 28.8296C43.1615 28.7884 43.1673 28.7591 43.1751 28.7185C43.2268 28.7184 43.3079 28.7283 43.3549 28.7083L43.3673 28.7012L43.1697 28.7049L43.1761 28.434L43.1715 28.4233L43.1715 28.3248L43.1747 28.2987L43.1656 28.03L43.1581 28.0188L43.1719 27.8921L43.1728 27.6137C43.0967 27.6023 43.012 27.6077 42.9346 27.6064L42.9301 27.5107L42.9247 27.4798C42.9215 27.4347 42.9157 27.3967 42.9037 27.3531C42.8845 27.3441 42.8747 27.3331 42.8597 27.3184L42.859 26.99L43.3903 26.9901C43.4424 27.0217 43.5385 27.0023 43.5982 26.9931L43.6172 26.9907L44.6601 26.9957L45.5269 26.9868L45.9182 26.9863Z"
          fill="#67C6CE"
        />
        <path
          id="Vector_103"
          d="M43.2646 33.6461C43.3556 33.6459 43.6078 33.6173 43.675 33.6606L43.6781 33.7666C43.6256 33.8008 43.4996 33.7879 43.4337 33.7894L43.293 33.7946L43.238 33.7665C43.2368 33.7161 43.2401 33.691 43.2646 33.6461Z"
          fill="#250C28"
        />
        <path
          id="Vector_104"
          d="M43.3673 28.7012L43.689 28.7004C43.7203 28.7394 43.7091 28.7754 43.7086 28.8245C43.6601 28.8473 43.5896 28.8369 43.5368 28.8365C43.4153 28.8357 43.2935 28.836 43.1722 28.8296C43.1616 28.7884 43.1673 28.7591 43.1751 28.7185C43.2268 28.7184 43.3079 28.7283 43.3549 28.7083L43.3673 28.7012Z"
          fill="#010001"
        />
        <path
          id="Vector_105"
          d="M43.1747 28.2987C43.3067 28.2979 43.4386 28.2971 43.5706 28.2963C43.615 28.2961 43.6658 28.2856 43.7033 28.3098L43.7049 28.4158C43.6666 28.446 43.6187 28.4343 43.5709 28.4342C43.4393 28.4342 43.3077 28.4341 43.1761 28.434L43.1715 28.4234L43.1715 28.3248L43.1747 28.2987Z"
          fill="#010001"
        />
        <path
          id="Vector_106"
          d="M43.172 27.8921C43.3047 27.8917 43.4373 27.8913 43.57 27.8908C43.6199 27.8907 43.666 27.8798 43.7078 27.9087L43.7082 28.0146C43.6642 28.04 43.6026 28.0301 43.5514 28.0301C43.4228 28.0301 43.2942 28.03 43.1657 28.03L43.1581 28.0188L43.172 27.8921Z"
          fill="url(#paint7_linear_11_402)"
        />
        <path
          id="Vector_107"
          d="M43.1733 27.4728C43.2943 27.4721 43.4153 27.4714 43.5363 27.4708C43.568 27.4706 43.6328 27.461 43.6587 27.4701C43.6695 27.4739 43.6761 27.485 43.6848 27.4924L43.6814 27.6049C43.6249 27.6403 43.4379 27.6182 43.365 27.6173L43.1728 27.6137C43.0967 27.6023 43.012 27.6077 42.9346 27.6064L42.9301 27.5107L43.1655 27.4836L43.1733 27.4728Z"
          fill="#130B24"
        />
        <path
          id="Vector_108"
          d="M43.1655 27.4836L43.1722 27.5112C43.1793 27.5408 43.1813 27.5681 43.1819 27.5986C43.2441 27.5999 43.3055 27.597 43.365 27.6173L43.1728 27.6137C43.0967 27.6023 43.012 27.6077 42.9346 27.6064L42.9301 27.5107L43.1655 27.4836Z"
          fill="#1B1536"
        />
        <path
          id="Vector_109"
          d="M43.2173 32.4237C43.295 32.4234 43.6453 32.4024 43.6874 32.4421L43.684 32.5525C43.6448 32.5728 43.5982 32.5659 43.5551 32.566C43.4447 32.5662 43.3342 32.5662 43.2237 32.5658L42.9324 32.5939L42.8943 32.5673L42.8891 32.4323L42.9292 32.4179L43.2173 32.4237Z"
          fill="url(#paint8_linear_11_402)"
        />
        <path
          id="Vector_110"
          d="M43.0697 29.5019L43.191 29.5093C43.2762 29.5096 43.6384 29.4872 43.6866 29.5283L43.6878 29.6267C43.646 29.6535 43.6137 29.6456 43.5643 29.6458C43.4479 29.6464 43.3065 29.6306 43.1949 29.6541C43.0915 29.7047 43.0267 29.7137 42.9118 29.7082L42.8918 29.679C42.8908 29.6208 42.8774 29.5556 42.9078 29.5056L43.0697 29.5019Z"
          fill="url(#paint9_linear_11_402)"
        />
        <path
          id="Vector_111"
          d="M42.8584 30.3322L42.8951 30.3221L43.1907 30.329C43.3205 30.3292 43.4502 30.3294 43.58 30.3296C43.6235 30.3297 43.6747 30.3185 43.7091 30.3457L43.7116 30.4615C43.6752 30.4852 43.6264 30.4772 43.5844 30.4776C43.4601 30.4786 43.3287 30.4703 43.2056 30.4827L43.0508 30.5238L42.9897 30.5291L42.8573 30.5289L42.8584 30.3322Z"
          fill="url(#paint10_linear_11_402)"
        />
        <path
          id="Vector_112"
          d="M42.9325 32.5939L43.2238 32.5658L43.2264 32.8301C43.3274 32.8293 43.4286 32.8286 43.5297 32.8279C43.581 32.8275 43.6338 32.8165 43.6781 32.8433L43.6814 32.9591C43.6449 32.9803 43.5987 32.9719 43.5579 32.9712C43.4504 32.9696 43.3428 32.9677 43.2353 32.9655C43.1502 32.9641 43.0019 32.9928 42.9272 32.9697C42.9073 32.9256 42.917 32.8734 42.9198 32.8262C42.9191 32.7536 42.9077 32.6623 42.9325 32.5939Z"
          fill="url(#paint11_linear_11_402)"
        />
        <path
          id="Vector_113"
          d="M42.9325 32.5939L43.2237 32.5658L43.2263 32.8301L42.9197 32.8262C42.9191 32.7536 42.9077 32.6623 42.9325 32.5939Z"
          fill="#5F112B"
        />
        <path
          id="Vector_114"
          d="M43.2213 32.0088L43.6865 32.0032C43.7085 32.0413 43.6985 32.0924 43.6965 32.1351C43.6579 32.1591 43.6005 32.15 43.5563 32.1503C43.4442 32.151 43.3292 32.1451 43.2176 32.1563L43.2173 32.4237L42.9292 32.4179L42.8891 32.4323C42.8894 32.3553 42.8952 32.2777 42.8718 32.2035L42.8721 32.1947C42.8691 32.1342 42.8684 32.0783 42.8771 32.0183L42.9173 32.0092L42.9891 32.0115L43.2213 32.0088Z"
          fill="#130B24"
        />
        <path
          id="Vector_115"
          d="M42.8721 32.1947C42.9088 32.1892 42.9462 32.185 42.9818 32.1744C43.0219 32.1625 43.0392 32.1587 43.0823 32.169C43.1279 32.1744 43.1727 32.1637 43.2177 32.1563L43.2173 32.4237L42.9292 32.4179L42.8891 32.4323C42.8895 32.3553 42.8952 32.2777 42.8718 32.2035L42.8721 32.1947Z"
          fill="#620210"
        />
        <path
          id="Vector_116"
          d="M42.8721 32.1947C42.9088 32.1892 42.9462 32.185 42.9818 32.1744C43.0219 32.1625 43.0392 32.1588 43.0823 32.169C43.0224 32.2542 42.9609 32.3165 42.9292 32.4179L42.8891 32.4323C42.8895 32.3553 42.8952 32.2777 42.8718 32.2035L42.8721 32.1947Z"
          fill="#250C28"
        />
        <path
          id="Vector_117"
          d="M43.2129 31.5838C43.3608 31.5816 43.537 31.5595 43.6814 31.586C43.6921 31.6338 43.6897 31.6732 43.6853 31.7218C43.64 31.7418 43.5815 31.7341 43.5326 31.7344C43.4285 31.7352 43.3238 31.7329 43.2197 31.7364L43.2213 32.0088L42.9891 32.0114L42.9173 32.0092C42.9264 31.9662 42.9239 31.9186 42.925 31.8746L42.8666 31.8271C42.8666 31.7466 42.8571 31.6571 42.8869 31.5814L42.9905 31.5884L43.2129 31.5838Z"
          fill="#130B24"
        />
        <path
          id="Vector_118"
          d="M42.8666 31.8271C42.8899 31.8247 42.9071 31.8234 42.9302 31.8283C42.9553 31.8336 42.9586 31.828 42.982 31.8184L42.9926 31.761L43.0305 31.746C43.0753 31.7268 43.1323 31.7362 43.1808 31.7383L43.2197 31.7364L43.2213 32.0088L42.9891 32.0115L42.9173 32.0092C42.9264 31.9663 42.9239 31.9186 42.925 31.8746L42.8666 31.8271Z"
          fill="#88051B"
        />
        <path
          id="Vector_119"
          d="M42.8666 31.8271C42.8899 31.8247 42.9071 31.8234 42.9302 31.8283C42.9553 31.8336 42.9586 31.828 42.982 31.8184L42.9926 31.761L43.0305 31.746C43.0753 31.7268 43.1323 31.7362 43.1808 31.7383C43.1434 31.7469 43.0945 31.7467 43.073 31.7791L43.0831 31.814L43.0709 31.8293C43.0262 31.8871 42.9992 31.9386 42.9891 32.0115L42.9173 32.0092C42.9264 31.9663 42.9239 31.9186 42.925 31.8746L42.8666 31.8271Z"
          fill="#250C28"
        />
        <path
          id="Vector_120"
          d="M43.2056 30.4827L43.2048 30.7384L43.2861 30.7417C43.404 30.7401 43.587 30.7129 43.6967 30.7468C43.7044 30.7915 43.7034 30.8304 43.7002 30.8755C43.6333 30.9157 43.3876 30.8916 43.2954 30.8917C43.2893 30.8917 43.2311 30.8892 43.2273 30.8918C43.2108 30.9025 43.2077 30.9197 43.2021 30.9362C43.1246 30.9594 43.0642 30.948 42.9878 30.9563C42.9347 30.9776 42.9106 30.9793 42.8551 30.9662L42.8572 30.7544L42.8573 30.5289L42.9897 30.5291L43.0508 30.5238L43.2056 30.4827Z"
          fill="#130B24"
        />
        <path
          id="Vector_121"
          d="M42.9897 30.5291L43.0508 30.5238L43.0554 30.7241C43.0993 30.7498 43.1543 30.7393 43.2048 30.7383L43.2861 30.7417C43.1625 30.7653 43.0248 30.7615 42.899 30.7567L42.9914 30.7366C43.0001 30.6694 42.992 30.597 42.9897 30.5291Z"
          fill="#250C28"
        />
        <path
          id="Vector_122"
          d="M42.8573 30.5289L42.9897 30.5291C42.992 30.597 43.0001 30.6694 42.9914 30.7366L42.899 30.7567L42.8572 30.7544L42.8573 30.5289Z"
          fill="#5F112B"
        />
        <path
          id="Vector_123"
          d="M43.2056 30.4827L43.2048 30.7384C43.1543 30.7393 43.0993 30.7498 43.0554 30.7241L43.0508 30.5238L43.2056 30.4827Z"
          fill="#88051B"
        />
        <path
          id="Vector_124"
          d="M42.9117 29.7082C43.0267 29.7138 43.0915 29.7047 43.1949 29.6541L43.1939 29.9199C43.3565 29.9174 43.5274 29.9037 43.6889 29.9202C43.7103 29.9584 43.7008 29.997 43.6992 30.0401C43.6074 30.0881 43.2239 30.0207 43.1903 30.1025L43.1907 30.329L42.8951 30.3221C42.902 30.2462 42.9063 30.1811 42.891 30.1053L42.8808 30.0986C42.8745 30.0398 42.8829 29.9802 42.888 29.9214C42.8967 29.8521 42.8859 29.7736 42.9117 29.7082Z"
          fill="url(#paint12_linear_11_402)"
        />
        <path
          id="Vector_125"
          d="M42.9118 29.7082C43.0267 29.7138 43.0915 29.7047 43.1949 29.6541L43.1939 29.9199L42.8881 29.9214C42.8967 29.8521 42.886 29.7736 42.9118 29.7082Z"
          fill="#5F112B"
        />
        <path
          id="Vector_126"
          d="M42.8911 30.1053C42.9656 30.0993 43.1284 30.0678 43.1903 30.1025L43.1908 30.329L42.8951 30.3221C42.9021 30.2462 42.9063 30.181 42.8911 30.1053Z"
          fill="#5F112B"
        />
        <path
          id="Vector_127"
          d="M43.2021 30.9362L43.2047 31.1658C43.3564 31.1665 43.553 31.1465 43.6992 31.1767L43.6955 31.3178L43.2248 31.3158L43.2169 31.3252L43.2133 31.3515L43.2128 31.5838L42.9905 31.5884L42.8869 31.5814L42.9003 31.5537C42.9175 31.5009 42.8966 31.4136 42.864 31.3743C42.8594 31.3 42.8545 31.2359 42.873 31.1628C42.8749 31.1266 42.8774 31.0923 42.8843 31.0567L42.8904 31.0269C42.8799 31.0032 42.8698 30.9871 42.8551 30.9662C42.9106 30.9793 42.9347 30.9776 42.9878 30.9563C43.0642 30.948 43.1246 30.9594 43.2021 30.9362Z"
          fill="#130B24"
        />
        <path
          id="Vector_128"
          d="M42.8551 30.9662C42.9106 30.9793 42.9347 30.9776 42.9878 30.9563L42.9933 31.1645L43.2047 31.1658C43.3564 31.1665 43.553 31.1465 43.6992 31.1767C43.5324 31.1913 43.3583 31.1847 43.1906 31.186C43.0907 31.1867 42.9657 31.2019 42.873 31.1628C42.8749 31.1266 42.8774 31.0923 42.8843 31.0567L42.8904 31.0269C42.8799 31.0033 42.8698 30.9871 42.8551 30.9662Z"
          fill="#250C28"
        />
        <path
          id="Vector_129"
          d="M43.2021 30.9362L43.2047 31.1658L42.9933 31.1645L42.9879 30.9563C43.0643 30.948 43.1246 30.9594 43.2021 30.9362Z"
          fill="#88051B"
        />
        <path
          id="Vector_130"
          d="M42.8869 31.5814L42.9003 31.5537C42.9176 31.5008 42.8966 31.4136 42.864 31.3743C42.8595 31.3 42.8545 31.2359 42.873 31.1628L42.8835 31.1885C42.9033 31.2424 42.8957 31.3108 42.8943 31.3676C42.9238 31.3794 42.9234 31.3857 42.955 31.375C42.955 31.3332 42.9604 31.3282 42.9851 31.2934L43.0019 31.3005C43.0698 31.3223 43.1534 31.3081 43.2248 31.3158L43.2169 31.3252L43.2133 31.3515L43.2129 31.5838L42.9905 31.5884L42.8869 31.5814Z"
          fill="#250C28"
        />
        <path
          id="Vector_131"
          d="M42.9784 31.4086C42.9878 31.372 42.9871 31.3522 43.0154 31.3253L43.217 31.3252L43.2133 31.3515C43.1398 31.4 43.0625 31.3939 42.9784 31.4086Z"
          fill="#5F112B"
        />
        <path
          id="Vector_132"
          d="M43.2133 31.3515L43.2128 31.5838L42.9905 31.5884C42.9912 31.5272 42.9865 31.4693 42.9783 31.4086C43.0624 31.3939 43.1398 31.4 43.2133 31.3515Z"
          fill="#88051B"
        />
        <path
          id="Vector_133"
          d="M44.161 30.3339L44.3407 30.3325L44.3407 32.2202L44.1885 32.2197C44.1824 32.2131 44.1744 32.2078 44.17 32.2C44.1654 32.1917 44.1702 32.1304 44.1702 32.1191C44.1703 32.0243 44.1703 31.9295 44.1701 31.8347C44.1692 31.3344 44.1645 30.8341 44.161 30.3339Z"
          fill="#1B1536"
        />
        <path
          id="Vector_134"
          d="M44.1856 27.3357L44.5873 27.3348L44.5809 27.3511L44.5542 27.3713L44.5519 29.9526L44.1942 29.954L44.1856 27.3357Z"
          fill="#434D6A"
        />
        <path
          id="Vector_135"
          d="M45.9182 26.9863L46.4322 26.9855L46.4324 27.3332L46.2545 27.3346L45.9114 27.3363C45.7305 27.3357 45.5496 27.335 45.3688 27.3335C45.271 27.3327 45.1605 27.3231 45.0641 27.3398L45.0608 29.953L44.7613 29.9519L44.5937 29.9532C44.5735 29.7393 44.5897 29.5085 44.5898 29.2928C44.59 28.8527 44.5907 28.4126 44.591 27.9724C44.5911 27.7682 44.6052 27.5534 44.581 27.3511L44.5873 27.3348L44.1857 27.3357L43.1736 27.3387L43.1733 27.4728L43.1655 27.4836L42.9301 27.5107L42.9248 27.4798C42.9216 27.4347 42.9158 27.3967 42.9038 27.3531C42.8845 27.3441 42.8747 27.333 42.8597 27.3184L42.8591 26.99L43.3903 26.9901C43.4424 27.0217 43.5385 27.0023 43.5982 26.9931L43.6172 26.9907L44.6601 26.9957L45.5269 26.9868L45.9182 26.9863Z"
          fill="#130B24"
        />
        <path
          id="Vector_136"
          d="M42.9037 27.353L43.1736 27.3387L43.1733 27.4727L43.1655 27.4836L42.9301 27.5107L42.9247 27.4798C42.9215 27.4347 42.9157 27.3967 42.9037 27.353Z"
          fill="#ED3131"
        />
        <path
          id="Vector_137"
          d="M44.5873 27.3348L44.7652 27.3348L44.7613 29.9519L44.5937 29.9532C44.5735 29.7393 44.5897 29.5085 44.5897 29.2928C44.5899 28.8527 44.5906 28.4126 44.5909 27.9724C44.5911 27.7682 44.6051 27.5534 44.5809 27.3511L44.5873 27.3348Z"
          fill="#5F112B"
        />
        <path
          id="Vector_138"
          d="M45.0641 27.3398L45.5416 27.3469C45.5368 28.6412 45.5843 29.935 45.5931 31.2294C45.5972 31.8408 45.6059 32.452 45.6104 33.0634C45.6122 33.3002 45.6141 33.5369 45.6208 33.7737C45.6232 33.8591 45.6142 33.9704 45.6376 34.0513C45.6395 34.1066 45.6426 34.1463 45.6171 34.1965L45.548 34.214C45.4545 34.1845 45.3232 34.2022 45.223 34.2025C44.9788 34.2033 44.7347 34.2047 44.4905 34.2062L44.6239 31.9841C44.643 31.6941 44.6299 31.3949 44.6301 31.1038C44.6302 30.8561 44.6469 30.5939 44.6209 30.348C44.5855 30.2263 44.5965 30.08 44.5937 29.9532L44.7613 29.9519L45.0608 29.953L45.0641 27.3398Z"
          fill="#528295"
        />
        <path
          id="Vector_139"
          d="M44.6208 30.348L44.8251 30.3401L44.8382 31.9833L44.6239 31.9841C44.643 31.6941 44.6299 31.3949 44.6301 31.1038C44.6302 30.8561 44.6469 30.5939 44.6208 30.348Z"
          fill="#1B1536"
        />
        <path
          id="Vector_140"
          d="M45.2042 30.3381C45.2483 30.3375 45.2947 30.3256 45.33 30.3533C45.3328 30.7676 45.3302 31.1821 45.3297 31.5964C45.3295 31.7846 45.352 32.0054 45.3213 32.19L45.2594 32.2001L45.1572 32.2L45.1492 32.1891C45.1304 32.1537 45.1302 30.442 45.1497 30.347L45.2042 30.3381Z"
          fill="#1B1536"
        />
        <path
          id="Vector_141"
          d="M42.9347 27.6064C43.012 27.6077 43.0967 27.6023 43.1728 27.6137L43.172 27.8921L43.1592 27.897L42.921 27.8958L42.9347 27.6064Z"
          fill="#D31D22"
        />
        <path
          id="Vector_142"
          d="M42.907 28.4018L43.1715 28.4233L43.1761 28.434L43.1697 28.7049C43.0871 28.7086 42.9908 28.7033 42.9114 28.7232L42.9023 28.7271L42.907 28.4018Z"
          fill="#ED3131"
        />
        <path
          id="Vector_143"
          d="M43.1591 27.897L43.172 27.8921L43.1581 28.0188L43.1657 28.03L43.1747 28.2986L43.1715 28.3248L43.1716 28.4233L42.907 28.4018L42.9044 28.3318C42.9257 28.2168 42.9161 28.0819 42.9194 27.9639L42.921 27.8958L43.1591 27.897Z"
          fill="#ED3131"
        />
        <path
          id="Vector_144"
          d="M43.1715 28.3248L43.1716 28.4233L42.907 28.4018L42.9044 28.3318L43.1715 28.3248Z"
          fill="#130B24"
        />
        <path
          id="Vector_145"
          d="M43.1591 27.897L43.172 27.8921L43.1581 28.0188L43.0592 28.012C42.99 28.0062 42.9672 28.0169 42.9194 27.9639L42.921 27.8958L43.1591 27.897Z"
          fill="#420D27"
        />
        <path
          id="Vector_146"
          d="M43.1591 27.897L43.1719 27.8921L43.1581 28.0188L43.0592 28.012C43.0548 27.9793 43.0619 27.9486 43.0667 27.9163C43.0992 27.9147 43.1279 27.9057 43.1591 27.897Z"
          fill="#250C28"
        />
        <path
          id="Vector_147"
          d="M44.5503 23.0139L44.6105 22.9953L44.6129 23.7045L43.8821 23.7036C43.9012 23.6943 43.9173 23.6879 43.9381 23.6826L43.9576 23.678L43.8706 23.494L43.882 23.4104C44.056 23.2215 44.2869 23.0431 44.5503 23.0139Z"
          fill="#47667E"
        />
        <path
          id="Vector_148"
          d="M44.6105 22.9953L44.7635 23.0108C45.1343 23.0911 45.4197 23.3623 45.6203 23.6752L45.6706 23.7568C45.6671 23.7938 45.6654 23.8206 45.6503 23.8552C45.5823 23.8066 45.5045 23.7773 45.4255 23.752C45.3404 23.7034 45.2181 23.7084 45.1213 23.7006L44.6129 23.7045L44.6105 22.9953Z"
          fill="#473250"
        />
        <path
          id="Vector_149"
          d="M43.882 23.4104L43.8706 23.494L43.9577 23.678L43.9381 23.6826C43.9173 23.6879 43.9012 23.6943 43.8821 23.7036L43.8061 23.71C43.7616 23.7709 43.7515 23.8626 43.7346 23.9353C43.6111 24.4687 43.6271 25.0198 43.6235 25.5635C43.6202 26.0392 43.6165 26.515 43.6172 26.9907L43.5982 26.9931C43.5385 27.0023 43.4424 27.0217 43.3903 26.9901L42.8591 26.99L42.6884 26.9904C42.6714 26.7153 42.6781 26.434 42.6766 26.1583C42.6743 25.7503 42.6394 25.3203 42.7462 24.9233C42.8951 24.3691 43.1987 23.9851 43.6963 23.7C43.7343 23.5868 43.8018 23.4972 43.882 23.4104Z"
          fill="#FBFAFB"
        />
        <path
          id="Vector_150"
          d="M43.882 23.4104L43.8706 23.494L43.9576 23.678L43.9381 23.6826C43.9173 23.6879 43.9012 23.6943 43.8821 23.7036L43.8061 23.71C43.7616 23.7709 43.7515 23.8626 43.7346 23.9353C43.611 24.4687 43.6271 25.0198 43.6234 25.5635C43.6202 26.0392 43.6164 26.515 43.6172 26.9907L43.5982 26.9931C43.5385 27.0023 43.4424 27.0217 43.3903 26.9901L43.5149 26.9866C43.551 26.9469 43.5367 26.8706 43.5368 26.8168C43.5368 26.6905 43.5369 26.5641 43.537 26.4378C43.5376 25.5206 43.481 24.5987 43.6963 23.7C43.7342 23.5868 43.8018 23.4972 43.882 23.4104Z"
          fill="url(#paint13_linear_11_402)"
        />
        <path
          id="Vector_151"
          d="M43.8821 23.7036L44.6129 23.7045C44.6139 23.8177 44.6058 23.9407 44.6255 24.052C44.4607 24.0816 44.3267 24.1401 44.2301 24.2829C44.1426 24.4125 44.115 24.593 44.1506 24.7441C44.1804 24.8705 44.2682 24.9839 44.3804 25.0485C44.4458 25.0863 44.509 25.1002 44.5831 25.1113L44.635 25.1329C44.6512 25.2484 44.6413 25.3748 44.6411 25.4916C44.6408 25.707 44.6397 25.9221 44.6469 26.1375L44.6563 26.6809L44.6476 26.6835L44.6601 26.9957L43.6172 26.9907C43.6164 26.515 43.6202 26.0392 43.6234 25.5635C43.6271 25.0198 43.611 24.4687 43.7346 23.9353C43.7514 23.8626 43.7616 23.7709 43.8061 23.71L43.8821 23.7036Z"
          fill="#FBFAFB"
        />
        <path
          id="Vector_152"
          d="M44.6476 26.6835C44.5453 26.6838 44.4313 26.6927 44.3323 26.6661C44.3071 26.6458 44.2833 26.6265 44.2733 26.5944C44.245 26.5041 44.2433 26.2452 44.2836 26.1604C44.3657 26.1121 44.5497 26.1369 44.647 26.1375L44.6563 26.6809L44.6476 26.6835Z"
          fill="#ED3131"
        />
        <path
          id="Vector_153"
          d="M45.1213 23.7006C45.2181 23.7084 45.3404 23.7034 45.4255 23.752C45.5626 24.0088 45.6836 24.2666 45.7621 24.5483C45.8685 24.9306 45.8926 25.3423 45.9045 25.7372C45.9171 26.1534 45.9164 26.5699 45.9182 26.9863L45.5269 26.9868L44.6601 26.9957L44.6476 26.6835L44.6563 26.6809L44.6469 26.1375C44.6398 25.9221 44.6408 25.707 44.6412 25.4916C44.6413 25.3747 44.6512 25.2484 44.635 25.1329L44.5831 25.1113C44.5091 25.1002 44.4458 25.0863 44.3804 25.0485C44.2682 24.9839 44.1804 24.8705 44.1506 24.7441C44.115 24.593 44.1426 24.4124 44.2302 24.2829C44.3267 24.14 44.4608 24.0816 44.6255 24.052C44.6058 23.9407 44.6139 23.8177 44.6129 23.7045L45.1213 23.7006Z"
          fill="#E2D4CA"
        />
        <path
          id="Vector_154"
          d="M44.647 26.1375C44.7589 26.1295 44.9268 26.0973 45.0286 26.1504C45.0896 26.218 45.0726 26.4679 45.0635 26.5615C45.0586 26.6113 45.04 26.6444 45.0059 26.6794L44.6563 26.6809L44.647 26.1375Z"
          fill="#D31D22"
        />
        <path
          id="Vector_155"
          d="M44.6255 24.052C44.7947 24.0657 44.9222 24.0969 45.0349 24.2347C45.1219 24.3413 45.1651 24.5006 45.1494 24.6374C45.133 24.781 45.0618 24.913 44.9461 25.0006C44.8302 25.0884 44.7245 25.1122 44.5831 25.1113C44.5091 25.1002 44.4458 25.0863 44.3804 25.0485C44.2682 24.9839 44.1804 24.8705 44.1506 24.7441C44.115 24.593 44.1426 24.4125 44.2302 24.2829C44.3267 24.1401 44.4608 24.0816 44.6255 24.052Z"
          fill="#250C28"
        />
        <path
          id="Vector_156"
          d="M44.6822 24.6818C44.7308 24.6997 44.7578 24.7115 44.8092 24.7004C44.8383 24.6941 44.8578 24.6918 44.8872 24.6972C44.8791 24.7576 44.8473 24.801 44.8011 24.8407C44.7707 24.8669 44.7264 24.8855 44.6879 24.8964L44.6724 24.9418L44.6501 24.9493C44.629 24.9173 44.6368 24.9105 44.6401 24.8737C44.692 24.8259 44.6676 24.7787 44.6775 24.7115L44.6822 24.6818Z"
          fill="#473250"
        />
        <path
          id="Vector_157"
          d="M44.7056 24.5156L44.7714 24.5408L44.794 24.5258L44.8153 24.5158C44.8435 24.5017 44.8613 24.4859 44.8848 24.4652C44.9184 24.4989 44.9079 24.5259 44.9079 24.5726C44.9079 24.6174 44.9153 24.6594 44.8872 24.6972C44.8578 24.6918 44.8383 24.6941 44.8092 24.7004C44.7578 24.7115 44.7308 24.6997 44.6823 24.6818L44.6633 24.6069C44.6745 24.5736 44.689 24.5464 44.7056 24.5156Z"
          fill="#420D27"
        />
        <path
          id="Vector_158"
          d="M44.459 24.2816C44.5272 24.2125 44.5353 24.1808 44.635 24.1776L44.6601 24.2128C44.6989 24.2913 44.6522 24.4729 44.7056 24.5156C44.689 24.5464 44.6744 24.5736 44.6632 24.6069L44.6822 24.6818L44.6775 24.7115C44.6676 24.7787 44.692 24.8259 44.6401 24.8737L44.5972 24.9039L44.5517 24.8585C44.5231 24.8776 44.5234 24.8736 44.4912 24.8736C44.4824 24.8987 44.4794 24.9018 44.4609 24.919C44.3775 24.8636 44.4629 24.6859 44.4092 24.6052L44.3953 24.5862C44.4141 24.5639 44.4238 24.5684 44.4516 24.5634L44.4081 24.5256L44.4156 24.503L44.4382 24.4955L44.4384 24.4575L44.424 24.4348C44.444 24.4141 44.4465 24.4098 44.4535 24.3818C44.4221 24.3712 44.4373 24.3786 44.4081 24.3591C44.4201 24.3251 44.4344 24.3077 44.459 24.2816Z"
          fill="#1B1536"
        />
        <path
          id="Vector_159"
          d="M44.459 24.2816C44.5273 24.2125 44.5354 24.1808 44.635 24.1776L44.6602 24.2128L44.6373 24.2532L44.6502 24.2836L44.5752 24.2963C44.5332 24.3023 44.4978 24.2983 44.459 24.2816Z"
          fill="#130B24"
        />
        <path
          id="Vector_160"
          d="M45.1213 23.7006C45.2181 23.7084 45.3404 23.7034 45.4255 23.752C45.5626 24.0088 45.6836 24.2666 45.7621 24.5483C45.8685 24.9306 45.8926 25.3423 45.9045 25.7372C45.9171 26.1534 45.9164 26.5699 45.9182 26.9863L45.5269 26.9868L45.5022 25.5625C45.4836 25.1966 45.4635 24.8157 45.3842 24.4575C45.3447 24.2787 45.284 24.1047 45.223 23.9323C45.1966 23.8578 45.1788 23.7527 45.1213 23.7006Z"
          fill="#B1969E"
        />
        <path
          id="Vector_161"
          d="M41.3896 22.3594C41.3957 22.3389 41.4019 22.3204 41.415 22.3031C41.4477 22.2599 41.5077 22.2155 41.5619 22.2081C41.5299 22.3086 41.4946 22.4228 41.4338 22.5097L41.3896 22.3594Z"
          fill="#88051B"
        />
        <path
          id="Vector_162"
          d="M43.1636 28.83L43.1722 28.8297L43.1766 29.1036L43.0238 29.0883C42.9989 29.0078 42.9751 28.9372 42.9317 28.8644C43.003 28.8726 43.0109 28.8696 43.0608 28.9197C43.0991 28.9213 43.1189 28.9256 43.1539 28.9069L43.1636 28.83Z"
          fill="#B90822"
        />
        <path
          id="Vector_163"
          d="M42.9818 29.2561L43.1888 29.2439L43.191 29.5093L43.0698 29.5019L43.0474 29.4692L42.9818 29.2561Z"
          fill="#88051B"
        />
        <path
          id="Vector_164"
          d="M42.648 28.5478C42.746 28.5838 42.8028 28.7172 42.9024 28.7271L42.9114 28.7232C42.9908 28.7033 43.0872 28.7086 43.1697 28.7049L43.3673 28.7012L43.3549 28.7083C43.3079 28.7283 43.2268 28.7184 43.1751 28.7185C43.1673 28.7591 43.1616 28.7884 43.1722 28.8297L43.1636 28.83L43.1539 28.9069C43.1189 28.9256 43.0991 28.9213 43.0608 28.9197C43.0109 28.8696 43.003 28.8726 42.9317 28.8644C42.8345 28.8119 42.7077 28.6414 42.648 28.5478Z"
          fill="#D31D22"
        />
        <path
          id="Vector_165"
          d="M43.1697 28.7049L43.3673 28.7012L43.3549 28.7083C43.3079 28.7283 43.2268 28.7184 43.1751 28.7185C43.1673 28.7591 43.1616 28.7884 43.1722 28.8297L43.1636 28.83C43.0937 28.8083 43.0037 28.8254 42.9432 28.8003C42.9238 28.7922 42.9174 28.7436 42.9114 28.7232C42.9908 28.7033 43.0871 28.7086 43.1697 28.7049Z"
          fill="#130B24"
        />
        <path
          id="Vector_166"
          d="M41.5268 27.3044C41.8294 27.5791 42.0931 27.9022 42.3567 28.2136C42.4279 28.2978 42.5157 28.3786 42.5777 28.469C42.5136 28.4113 42.4367 28.37 42.3755 28.3104C42.1565 28.097 41.9594 27.8586 41.7634 27.6243C41.6826 27.5277 41.5691 27.4238 41.5268 27.3044Z"
          fill="#88051B"
        />
        <path
          id="Vector_167"
          d="M41.3896 22.3594L41.4338 22.5097C41.2804 22.8552 40.9896 23.1158 40.73 23.3839C40.4856 23.6364 40.237 23.8858 39.9985 24.1439L40.0035 23.309C40.2047 23.3363 40.4286 23.2893 40.6129 23.208C40.9835 23.0446 41.2469 22.732 41.3896 22.3594Z"
          fill="#ED3131"
        />
        <path
          id="Vector_168"
          d="M41.2254 19.7262C41.4575 19.7341 41.6046 19.4792 41.8347 19.6271L41.8825 19.6584L41.8844 22.6979C41.4904 23.0913 41.0844 23.4732 40.6994 23.8754C40.5503 24.0312 40.3615 24.2036 40.2545 24.3921L39.9361 24.3886C40.1597 24.1922 40.3447 23.9554 40.552 23.7426C41.0717 23.2093 41.65 22.7608 41.7028 21.9581C41.7344 21.4784 41.6519 21.0696 41.3223 20.7023C41.3035 20.6814 41.292 20.668 41.2621 20.665L41.2308 20.6689L41.224 20.6622C41.2428 20.5566 41.2302 20.4304 41.2306 20.3226C41.2314 20.1253 41.2415 19.9228 41.2254 19.7262Z"
          fill="url(#paint14_linear_11_402)"
        />
        <path
          id="Vector_169"
          d="M39.4787 24.533L40.4642 24.538L40.4745 26.5816L42.4688 28.7044C42.4694 28.7167 42.466 28.7298 42.4706 28.7412C42.4778 28.7589 42.5219 28.7962 42.5359 28.8117C42.6124 28.8962 42.6945 28.9822 42.7647 29.0717C42.8095 29.129 42.841 29.1912 42.8753 29.2548C42.7838 29.1863 42.6998 29.1052 42.6182 29.0253C42.5813 28.9892 42.5535 28.9468 42.5107 28.9174C42.4076 28.8465 42.339 28.7241 42.2345 28.6571C42.1438 28.599 42.0568 28.5017 41.9799 28.4257C41.8192 28.2668 41.6658 28.1028 41.5095 27.9398C41.1104 27.5235 40.7116 27.107 40.3126 26.6905C40.1011 26.4698 39.8958 26.24 39.673 26.0305L39.4783 25.8244L39.4787 24.533Z"
          fill="#56334E"
        />
        <path
          id="Vector_170"
          d="M39.673 26.0305C39.8958 26.24 40.1011 26.4698 40.3127 26.6905C40.7116 27.107 41.1104 27.5235 41.5095 27.9398C41.6658 28.1028 41.8192 28.2668 41.98 28.4257C42.0569 28.5017 42.1438 28.599 42.2345 28.6571C42.339 28.7241 42.4076 28.8465 42.5107 28.9174C42.5535 28.9468 42.5813 28.9892 42.6182 29.0253C42.6998 29.1052 42.7838 29.1863 42.8754 29.2548C42.841 29.1912 42.8096 29.129 42.7647 29.0717C42.6945 28.9822 42.6124 28.8962 42.5359 28.8117C42.5219 28.7962 42.4778 28.7589 42.4706 28.7412C42.466 28.7298 42.4694 28.7167 42.4688 28.7044C42.5314 28.7423 42.5943 28.8268 42.637 28.8852C42.6731 28.9347 42.7229 28.9686 42.7581 29.0214C42.8161 29.1087 42.8777 29.1663 42.9114 29.2718C42.932 29.3363 42.9735 29.3324 42.97 29.415C42.9821 29.4332 42.9922 29.446 43.007 29.4616L43.0473 29.4692L43.0697 29.5019L42.9078 29.5056C42.8773 29.5556 42.8908 29.6208 42.8918 29.679L42.9118 29.7082C42.8859 29.7736 42.8967 29.8521 42.888 29.9214C42.8829 29.9802 42.8745 30.0398 42.8808 30.0986L42.891 30.1053C42.9063 30.1811 42.9021 30.2462 42.8951 30.3221L42.8585 30.3322L42.8589 30.1914C42.6024 29.9869 42.3818 29.7361 42.1437 29.511C41.2985 28.7121 40.5002 27.8649 39.6514 27.0697C39.681 26.9824 39.6614 26.8323 39.6621 26.7384C39.6639 26.5024 39.6702 26.2665 39.673 26.0305Z"
          fill="#250C28"
        />
        <path
          id="Vector_171"
          d="M38.8389 20.1303L39.1306 20.1294L40.1278 20.146C40.179 20.197 40.3165 20.1968 40.3889 20.2128C40.4735 20.2316 40.5561 20.2605 40.636 20.2938C40.8578 20.3863 41.0402 20.5092 41.224 20.6622L41.2308 20.6689L41.2446 20.6934C41.2913 20.774 41.3592 20.842 41.4086 20.9223C41.6212 21.2679 41.6414 21.5954 41.6124 21.9931C41.6001 22.0658 41.5898 22.1394 41.5619 22.2081C41.5077 22.2155 41.4478 22.2599 41.415 22.3031C41.4019 22.3204 41.3957 22.3389 41.3896 22.3594C41.247 22.732 40.9836 23.0446 40.6129 23.2081C40.4286 23.2893 40.2047 23.3363 40.0035 23.309L39.98 23.2794C39.9182 23.2173 39.8114 23.168 39.7369 23.1197C39.5916 23.0253 39.4463 22.9308 39.3046 22.8311C39.2509 22.7934 39.1527 22.7008 39.0904 22.6969L39.0987 21.5763L39.0981 20.7767L38.8389 20.1303Z"
          fill="#5F112B"
        />
        <path
          id="Vector_172"
          d="M39.7662 22.4928L39.777 22.4898L39.7887 22.4368C39.8354 22.4218 39.8759 22.4432 39.92 22.4587L39.9344 22.481L39.9276 22.6657L39.9535 22.6694C40.0246 22.6825 40.0901 22.6871 40.1621 22.69C40.1932 22.6644 40.1938 22.6528 40.208 22.6162C40.2515 22.6541 40.2869 22.6733 40.3417 22.6913C40.319 22.7147 40.3051 22.734 40.2904 22.7631C40.1886 22.764 40.0887 22.7592 39.9881 22.7424C39.8574 22.7207 39.7862 22.7058 39.7072 22.5929L39.6747 22.5827C39.6979 22.5725 39.7217 22.5656 39.7459 22.558L39.7662 22.4928Z"
          fill="#130B24"
        />
        <path
          id="Vector_173"
          d="M39.7662 22.4928L39.777 22.4898L39.7887 22.4368C39.8354 22.4218 39.8759 22.4432 39.92 22.4587L39.9344 22.481L39.9277 22.6657L39.8515 22.6476L39.8292 22.6401L39.7072 22.5929L39.6747 22.5827C39.6979 22.5725 39.7217 22.5656 39.7459 22.558L39.7662 22.4928Z"
          fill="#0F1758"
        />
        <path
          id="Vector_174"
          d="M41.0099 21.2167C41.0699 21.3326 41.1308 21.4601 41.1563 21.5887L41.1463 21.614C41.1243 21.6749 41.1325 21.7448 41.1254 21.8085C41.1164 21.8891 41.0916 21.966 41.0684 22.0432C41.0283 22.1769 40.9515 22.3027 40.8711 22.4158C40.7276 22.6177 40.5276 22.7171 40.2904 22.7631C40.305 22.734 40.319 22.7147 40.3417 22.6913L40.3587 22.6316L40.4497 22.6334C40.4967 22.6147 40.5146 22.5877 40.5433 22.5487C40.5459 22.5117 40.5482 22.5003 40.533 22.4672L40.5424 22.442C40.5736 22.4408 40.6106 22.4436 40.6389 22.4295C40.6656 22.4163 40.6932 22.4143 40.7225 22.41L40.7218 22.2487C40.7487 22.206 40.7788 22.2099 40.8265 22.1979L40.8661 22.2097L40.8521 22.2939C40.8826 22.2585 40.9008 22.2251 40.9263 22.187C40.9562 22.1423 40.984 22.1091 41.0026 22.0568L41.0475 21.907C41.0588 21.8731 41.0568 21.8508 41.0626 21.8162C41.0745 21.7452 41.083 21.6778 41.0727 21.6038L41.0539 21.4908C41.0482 21.4548 41.0351 21.4233 41.0281 21.3881C41.0195 21.3446 41.0156 21.3356 41.0323 21.294C41.0131 21.265 41.0175 21.2785 41.0126 21.2426L41.0099 21.2167Z"
          fill="#130B24"
        />
        <path
          id="Vector_175"
          d="M40.7218 22.2487C40.7487 22.206 40.7788 22.2099 40.8266 22.1979L40.8662 22.2097L40.8521 22.2939C40.8426 22.3254 40.8398 22.3292 40.8204 22.3535L40.8053 22.3729L40.6844 22.4972L40.6617 22.4897C40.6617 22.4617 40.7029 22.4309 40.7225 22.41L40.7218 22.2487Z"
          fill="#1B1536"
        />
        <path
          id="Vector_176"
          d="M39.4987 20.8531C39.5907 20.7942 39.6824 20.7456 39.7825 20.7023L39.7925 20.7617C39.6716 20.8237 39.5649 20.8883 39.4734 20.9905C39.3564 21.1211 39.2678 21.2446 39.2205 21.416L39.2079 21.4335C39.1981 21.4734 39.1901 21.5139 39.1729 21.5514C39.1726 21.6358 39.1661 21.7257 39.18 21.8085L39.1826 21.8341C39.1883 21.8822 39.2022 21.9369 39.2162 21.9827C39.2253 22.0121 39.2271 22.0332 39.2403 22.0623L39.2203 22.0564C39.1961 22.0182 39.1855 21.9757 39.1819 21.9311C39.1815 21.9261 39.1808 21.9047 39.1782 21.8994C39.1577 21.8562 39.1742 21.8219 39.1442 21.7858L39.1198 21.7969C39.1206 21.903 39.1341 22.0154 39.1114 22.119L39.0987 21.5763L39.0981 20.7767C39.184 20.8234 39.2592 20.9266 39.3256 20.9993C39.3799 20.9579 39.4587 20.9071 39.4987 20.8531Z"
          fill="#130B24"
        />
        <path
          id="Vector_177"
          d="M38.8389 20.1303L39.1306 20.1294L40.1278 20.146C40.179 20.197 40.3165 20.1968 40.3889 20.2128C40.4735 20.2316 40.5561 20.2605 40.636 20.2938C40.8578 20.3863 41.0402 20.5092 41.224 20.6622L41.2308 20.6689L41.2446 20.6934C41.2913 20.774 41.3592 20.842 41.4086 20.9223C41.6212 21.2679 41.6414 21.5954 41.6124 21.9931C41.4564 21.8762 41.2759 21.7426 41.1563 21.5887C41.1308 21.4601 41.0699 21.3326 41.0099 21.2167C40.9211 21.0453 40.7749 20.8869 40.6085 20.7886C40.3382 20.6289 40.081 20.624 39.7825 20.7023C39.6823 20.7456 39.5906 20.7942 39.4986 20.8531C39.4587 20.9071 39.3799 20.9579 39.3256 20.9993C39.2592 20.9266 39.184 20.8234 39.0981 20.7767L38.8389 20.1303Z"
          fill="#ED3131"
        />
        <path
          id="Vector_178"
          d="M38.8389 20.1303L39.1306 20.1294C39.1904 20.298 39.2873 20.4618 39.3687 20.6213C39.4057 20.6937 39.4438 20.794 39.4986 20.8531C39.4587 20.9071 39.3799 20.9579 39.3256 20.9993C39.2592 20.9266 39.184 20.8234 39.0981 20.7767L38.8389 20.1303Z"
          fill="#5F112B"
        />
        <path
          id="Vector_179"
          d="M39.7825 20.7023C40.081 20.624 40.3383 20.6289 40.6085 20.7886C40.775 20.8869 40.9211 21.0453 41.0099 21.2167L41.0127 21.2426C41.0176 21.2784 41.0131 21.265 41.0323 21.2939C41.0157 21.3356 41.0195 21.3446 41.0281 21.3881C41.0351 21.4233 41.0482 21.4548 41.0539 21.4908L41.0727 21.6038C41.083 21.6778 41.0745 21.7451 41.0626 21.8162C41.0568 21.8508 41.0589 21.8731 41.0475 21.907L41.0026 22.0568C40.9841 22.1091 40.9562 22.1423 40.9263 22.187C40.9009 22.2251 40.8827 22.2585 40.8521 22.2939L40.8661 22.2097L40.8265 22.1979C40.7788 22.2099 40.7487 22.206 40.7218 22.2487L40.7225 22.41C40.6932 22.4143 40.6656 22.4163 40.6389 22.4295C40.6107 22.4436 40.5736 22.4408 40.5424 22.442L40.533 22.4672C40.5482 22.5003 40.5459 22.5117 40.5434 22.5486C40.5146 22.5877 40.4967 22.6147 40.4497 22.6334L40.3588 22.6315L40.3417 22.6913C40.2869 22.6733 40.2515 22.6541 40.208 22.6162C40.1938 22.6528 40.1932 22.6644 40.1621 22.69C40.0901 22.6871 40.0245 22.6825 39.9535 22.6694L39.9276 22.6657L39.9343 22.481L39.9199 22.4587C39.8759 22.4432 39.8354 22.4218 39.7887 22.4368L39.777 22.4897L39.7662 22.4928L39.7459 22.558C39.7217 22.5656 39.6979 22.5724 39.6747 22.5826L39.6323 22.5577L39.6098 22.5427C39.565 22.5153 39.5378 22.481 39.5039 22.4414L39.4834 22.4368L39.4731 22.4065C39.4084 22.3749 39.381 22.3307 39.3436 22.2718L39.2403 22.0623C39.2271 22.0332 39.2253 22.0121 39.2162 21.9827C39.2021 21.9369 39.1883 21.8822 39.1826 21.8341L39.18 21.8085C39.1661 21.7257 39.1726 21.6358 39.1729 21.5514C39.1901 21.5139 39.1981 21.4734 39.2078 21.4335L39.2205 21.416C39.2677 21.2446 39.3564 21.1211 39.4734 20.9905C39.5649 20.8883 39.6716 20.8237 39.7924 20.7617L39.7825 20.7023Z"
          fill="#F8F5EC"
        />
        <path
          id="Vector_180"
          d="M39.371 21.8259C39.3929 21.833 39.4325 21.8398 39.4508 21.8516C39.4867 21.8749 39.4651 21.9003 39.5189 21.9072C39.5238 21.8755 39.5284 21.8457 39.5373 21.8148C39.5364 21.8566 39.546 21.9016 39.5188 21.9341C39.4684 21.9351 39.4218 21.9385 39.3734 21.9221L39.371 21.8259Z"
          fill="#0F1758"
        />
        <path
          id="Vector_181"
          d="M40.1672 21.3813C40.2291 21.3867 40.2566 21.3835 40.3086 21.4193L40.3135 21.5334L40.252 21.5566C40.2286 21.548 40.2075 21.5399 40.1858 21.5274C40.1606 21.5128 40.1642 21.4985 40.1566 21.4717L40.1672 21.3813Z"
          fill="#0F1758"
        />
        <path
          id="Vector_182"
          d="M40.7533 21.5466C40.7322 21.5038 40.7425 21.437 40.7537 21.3923C40.7981 21.3812 40.7988 21.3817 40.8408 21.4002L40.866 21.4376L40.9209 21.4239C40.9211 21.4661 40.9247 21.5072 40.9132 21.5481L40.7533 21.5466Z"
          fill="#1B1536"
        />
        <path
          id="Vector_183"
          d="M39.2107 21.5226L39.2181 21.4832C39.2499 21.4632 39.286 21.4697 39.322 21.4712C39.3624 21.518 39.3462 21.6031 39.3467 21.6649C39.2988 21.6658 39.2622 21.6603 39.2161 21.6498L39.2107 21.5226Z"
          fill="#1B1536"
        />
        <path
          id="Vector_184"
          d="M40.5556 21.1756L40.6086 21.1869C40.6396 21.1932 40.6703 21.1955 40.6963 21.2152C40.7155 21.2298 40.7105 21.3301 40.7113 21.3585C40.6645 21.359 40.6209 21.356 40.5745 21.35C40.5426 21.2986 40.5549 21.2355 40.5556 21.1756Z"
          fill="#0F1758"
        />
        <path
          id="Vector_185"
          d="M40.5882 21.3731L40.6843 21.3826C40.7213 21.4209 40.7088 21.4763 40.7091 21.5286L40.6691 21.5505L40.5603 21.5313C40.537 21.4863 40.5485 21.4407 40.554 21.3923L40.5882 21.3731Z"
          fill="#1B1536"
        />
        <path
          id="Vector_186"
          d="M39.9638 21.5268C40.0094 21.5021 40.0176 21.4921 40.0706 21.4983C40.1205 21.5497 40.1187 21.5605 40.116 21.635L40.1123 21.6758C40.0597 21.6981 40.031 21.7011 39.9745 21.6943C39.9611 21.642 39.9652 21.5808 39.9638 21.5268Z"
          fill="#1B347B"
        />
        <path
          id="Vector_187"
          d="M39.371 21.8259L39.3755 21.7973C39.3616 21.7684 39.352 21.7465 39.362 21.7144C39.3683 21.6942 39.3802 21.694 39.3977 21.6847C39.4388 21.7005 39.4841 21.7009 39.5276 21.7048L39.5401 21.7607L39.5373 21.8148C39.5284 21.8457 39.5238 21.8755 39.5189 21.9072C39.4651 21.9003 39.4867 21.8749 39.4508 21.8517C39.4325 21.8398 39.3929 21.833 39.371 21.8259Z"
          fill="#1B1536"
        />
        <path
          id="Vector_188"
          d="M40.5857 20.9412C40.6531 20.9711 40.6928 21.0068 40.7346 21.0669C40.7364 21.1099 40.7229 21.1441 40.7091 21.184C40.6472 21.1657 40.6075 21.149 40.56 21.1047C40.5532 21.0363 40.5512 21.0018 40.5857 20.9412Z"
          fill="#0F1758"
        />
        <path
          id="Vector_189"
          d="M40.1349 21.9738C40.1734 21.9356 40.1932 21.9102 40.2529 21.9155C40.2814 21.9181 40.2956 21.9215 40.3123 21.9443C40.3301 21.9687 40.3348 21.9863 40.3414 22.0151L40.3087 22.0924C40.2665 22.112 40.2367 22.1018 40.1937 22.0921C40.1467 22.0509 40.1491 22.0331 40.1349 21.9738Z"
          fill="#0F1758"
        />
        <path
          id="Vector_190"
          d="M39.7852 21.9248C39.8404 21.9262 39.8766 21.9259 39.9237 21.9565C39.9516 22.0073 39.936 22.0756 39.9312 22.1314C39.8812 22.1305 39.8287 22.1391 39.7868 22.1111C39.7753 22.0473 39.7802 21.9887 39.7852 21.9248Z"
          fill="#0F1758"
        />
        <path
          id="Vector_191"
          d="M40.2258 21.6181L40.3157 21.6732C40.3134 21.7387 40.3209 21.7862 40.284 21.8427C40.2404 21.8516 40.2243 21.8451 40.1848 21.8291C40.1699 21.8083 40.1546 21.7886 40.1427 21.7659L40.1408 21.7301C40.157 21.6771 40.1851 21.6543 40.2258 21.6181Z"
          fill="#0F1758"
        />
        <path
          id="Vector_192"
          d="M40.7415 21.7701L40.9224 21.7684C40.9331 21.8141 40.9258 21.8675 40.9239 21.9145L40.9038 21.9302C40.8513 21.9325 40.7917 21.9413 40.7423 21.9221C40.731 21.8699 40.7367 21.8228 40.7415 21.7701Z"
          fill="#1B1536"
        />
        <path
          id="Vector_193"
          d="M39.5831 22.3354C39.575 22.2914 39.5736 22.2545 39.575 22.2097C39.6354 22.1828 39.6495 22.1817 39.7156 22.1882C39.745 22.224 39.7582 22.2975 39.7545 22.346L39.7459 22.3836C39.689 22.3879 39.6453 22.3671 39.5945 22.3432L39.5831 22.3354Z"
          fill="#0F1758"
        />
        <path
          id="Vector_194"
          d="M39.9792 22.0332C40.028 22.0343 40.0607 22.0399 40.1061 22.0583C40.1382 22.1179 40.1259 22.1847 40.1255 22.2518L40.0989 22.2508C40.0443 22.2482 40.0058 22.2424 39.9691 22.2018C39.9576 22.1421 39.9684 22.0924 39.9792 22.0332Z"
          fill="#0F1758"
        />
        <path
          id="Vector_195"
          d="M40.352 22.0144C40.4134 22.0066 40.4748 21.9921 40.5283 22.0322C40.5264 22.0835 40.5247 22.1444 40.4951 22.1857C40.4465 22.1864 40.3891 22.1969 40.348 22.171C40.3444 22.117 40.3449 22.068 40.352 22.0144Z"
          fill="#1B1536"
        />
        <path
          id="Vector_196"
          d="M40.8408 21.4002L40.8659 21.3895C40.8353 21.3673 40.8545 21.375 40.824 21.3718C40.7938 21.3686 40.7705 21.3599 40.7422 21.3496C40.7311 21.2825 40.7381 21.2366 40.755 21.1729L40.76 21.1286L40.7798 21.1199C40.8437 21.1914 40.8916 21.2978 40.9129 21.3905L40.918 21.4114L40.9209 21.4239L40.8659 21.4376L40.8408 21.4002Z"
          fill="#0F1758"
        />
        <path
          id="Vector_197"
          d="M40.7802 22.1872L40.7433 22.1805L40.7317 22.1567C40.7203 22.1179 40.7306 21.9908 40.7524 21.9587L40.9133 21.9588C40.908 21.9796 40.9016 21.9906 40.8922 22.0097C40.875 22.0449 40.8796 22.0811 40.8811 22.1191C40.8478 22.1553 40.8377 22.1629 40.7918 22.1807L40.7802 22.1872Z"
          fill="#1B1536"
        />
        <path
          id="Vector_198"
          d="M40.3488 21.5434C40.3724 21.5179 40.3804 21.4968 40.4167 21.4949C40.4501 21.493 40.4721 21.5022 40.5027 21.5145C40.5342 21.5739 40.5153 21.6437 40.5104 21.7102C40.4764 21.7265 40.4386 21.7374 40.4027 21.7229C40.3715 21.7104 40.3636 21.7014 40.3447 21.6751C40.3558 21.6294 40.3523 21.5896 40.3488 21.5434Z"
          fill="#1B1536"
        />
        <path
          id="Vector_199"
          d="M40.386 21.1868C40.4269 21.1842 40.4678 21.1766 40.5057 21.1956C40.5093 21.2251 40.5272 21.3285 40.5082 21.3532C40.4939 21.3718 40.4714 21.3565 40.4603 21.3856C40.4909 21.3989 40.505 21.422 40.5244 21.4479L40.5335 21.4601C40.5061 21.4679 40.4778 21.4713 40.4497 21.4759C40.3972 21.4381 40.41 21.3992 40.3665 21.3504C40.3667 21.2916 40.3675 21.243 40.386 21.1868Z"
          fill="#0F1758"
        />
        <path
          id="Vector_200"
          d="M39.7859 22.1676C39.8518 22.1726 39.8912 22.176 39.9393 22.2249C39.9531 22.2871 39.9364 22.3657 39.9305 22.4292L39.7796 22.3836C39.7731 22.3075 39.7737 22.2437 39.7859 22.1676Z"
          fill="#0F1758"
        />
        <path
          id="Vector_201"
          d="M40.4205 21.7392L40.48 21.7603C40.5135 21.7797 40.519 21.795 40.5254 21.8328C40.5369 21.9004 40.5153 21.9441 40.4763 21.9943C40.4192 21.9816 40.3912 21.983 40.3495 21.9407C40.3467 21.9035 40.3415 21.8637 40.3477 21.8267C40.3565 21.7751 40.3811 21.7685 40.4205 21.7392Z"
          fill="#0F1758"
        />
        <path
          id="Vector_202"
          d="M39.9707 22.2661C40.0287 22.2813 40.0889 22.2862 40.1483 22.2934L40.1375 22.5177L39.9612 22.4672L39.9707 22.2661Z"
          fill="#0F1758"
        />
        <path
          id="Vector_203"
          d="M39.5643 21.7499L39.5869 21.7192C39.6448 21.7193 39.6889 21.7184 39.7314 21.7645L39.7456 21.7819C39.75 21.8296 39.7641 21.8845 39.7372 21.9269C39.6829 21.942 39.6499 21.9426 39.5945 21.9332C39.552 21.8891 39.5662 21.8107 39.5643 21.7499Z"
          fill="#0F1758"
        />
        <path
          id="Vector_204"
          d="M39.5429 22.0941C39.5506 22.0455 39.5468 21.9903 39.5869 21.9603C39.6461 21.9576 39.6799 21.9552 39.7307 21.9878C39.742 22.0361 39.7711 22.1153 39.7458 22.1567C39.6929 22.1726 39.6377 22.1924 39.5869 22.1581C39.5724 22.1482 39.5591 22.1324 39.5474 22.1194L39.5429 22.0941Z"
          fill="#0F1758"
        />
        <path
          id="Vector_205"
          d="M40.1123 21.6758L40.1408 21.7301L40.1427 21.7659L40.1177 21.8076L40.1158 21.9646L40.0032 21.968C39.9603 21.9384 39.966 21.9142 39.9557 21.8645L39.9771 21.7812L39.9745 21.6943C40.031 21.7011 40.0596 21.6981 40.1123 21.6758Z"
          fill="#0F1758"
        />
        <path
          id="Vector_206"
          d="M40.1123 21.6758L40.1408 21.7301L40.1427 21.7659L40.1177 21.8076C40.0746 21.7815 40.026 21.7841 39.9771 21.7812L39.9745 21.6943C40.031 21.7011 40.0596 21.6981 40.1123 21.6758Z"
          fill="#FBFAFB"
        />
        <path
          id="Vector_207"
          d="M40.7533 21.5466L40.9132 21.5481C40.9377 21.5949 40.9498 21.6574 40.9388 21.7102L40.9248 21.7437L40.9224 21.7684L40.7415 21.7701C40.7248 21.7031 40.7307 21.6113 40.7533 21.5466Z"
          fill="#0F1758"
        />
        <path
          id="Vector_208"
          d="M40.3371 21.0272C40.3436 21.0005 40.3482 20.9845 40.3651 20.962L40.3784 20.9458L40.3593 20.9004C40.3409 20.8684 40.329 20.8553 40.319 20.8171C40.3815 20.7983 40.49 20.8623 40.5498 20.8909C40.5377 20.9177 40.5418 20.9253 40.5128 20.9367C40.4898 20.9457 40.4709 20.9499 40.4467 20.9534L40.5092 21.0064C40.5139 21.0552 40.5208 21.0664 40.4939 21.1091C40.4435 21.1238 40.4326 21.1259 40.3816 21.1145C40.3614 21.0855 40.349 21.0605 40.3371 21.0272Z"
          fill="#0F1758"
        />
        <path
          id="Vector_209"
          d="M39.3689 21.4615C39.3667 21.387 39.3713 21.3505 39.4204 21.293L39.4801 21.2959C39.5135 21.3249 39.5375 21.3447 39.5423 21.3923C39.5443 21.4109 39.5372 21.4378 39.5339 21.4553L39.4871 21.4834C39.5253 21.5111 39.5315 21.5105 39.5377 21.5596C39.5429 21.6002 39.5364 21.6428 39.5323 21.6832C39.4744 21.6805 39.4332 21.6798 39.3828 21.6497C39.3605 21.5948 39.3691 21.5205 39.3689 21.4615Z"
          fill="#0F1758"
        />
        <path
          id="Vector_210"
          d="M39.4804 22.1789L39.534 22.2115L39.538 22.2286C39.5481 22.2638 39.5644 22.3038 39.5831 22.3354L39.5945 22.3432L39.6195 22.3857L39.7532 22.4162C39.7599 22.4423 39.7641 22.466 39.7662 22.4928L39.7459 22.558C39.7217 22.5656 39.6979 22.5725 39.6747 22.5827L39.6323 22.5577L39.6098 22.5427C39.565 22.5153 39.5378 22.481 39.5039 22.4414L39.4834 22.4368L39.4731 22.4065C39.4084 22.3749 39.381 22.3308 39.3436 22.2718L39.3673 22.2249L39.4053 22.2247C39.4293 22.2054 39.4528 22.1926 39.4804 22.1789Z"
          fill="#1B1536"
        />
        <path
          id="Vector_211"
          d="M39.2107 21.5226L39.2161 21.6498C39.2622 21.6603 39.2989 21.6658 39.3467 21.6649C39.3489 21.7735 39.3417 21.8852 39.3649 21.9902L39.3674 22.016L39.3842 22.0129L39.3841 21.9675C39.4292 21.9519 39.472 21.9561 39.5188 21.9579C39.5441 22.0003 39.5356 22.0473 39.5429 22.0941L39.5474 22.1194L39.5339 22.17L39.4804 22.1789C39.4528 22.1926 39.4293 22.2054 39.4053 22.2246L39.3673 22.2249L39.3436 22.2718L39.2403 22.0623C39.2271 22.0332 39.2253 22.0121 39.2162 21.9827C39.2021 21.9369 39.1883 21.8823 39.1826 21.8341L39.18 21.8085C39.1661 21.7257 39.1726 21.6358 39.1729 21.5514L39.2107 21.5226Z"
          fill="#0F1758"
        />
        <path
          id="Vector_212"
          d="M40.1603 22.5342L40.1654 22.5184C40.1712 22.4883 40.1699 22.4655 40.183 22.4368L40.2302 22.4224C40.2176 22.3666 40.2062 22.3653 40.1629 22.3308C40.162 22.2795 40.1621 22.2328 40.1717 22.1823C40.2125 22.1555 40.2597 22.1675 40.3059 22.1718C40.3542 22.2535 40.2805 22.3846 40.3313 22.4571L40.3525 22.4444C40.4142 22.4413 40.4831 22.4492 40.5343 22.4117L40.5424 22.442L40.533 22.4672C40.5482 22.5003 40.5459 22.5117 40.5433 22.5487C40.5146 22.5877 40.4967 22.6147 40.4497 22.6334L40.3587 22.6316L40.3417 22.6913C40.2869 22.6733 40.2515 22.6541 40.208 22.6162C40.1938 22.6528 40.1931 22.6644 40.1621 22.69C40.0901 22.6871 40.0245 22.6825 39.9535 22.6694L39.9276 22.6657L39.9343 22.481C40.0077 22.5039 40.0839 22.5257 40.1603 22.5342Z"
          fill="#0F1758"
        />
        <path
          id="Vector_213"
          d="M40.3587 22.6315C40.3508 22.5746 40.3527 22.5383 40.3663 22.4822L40.48 22.4818C40.4955 22.5088 40.5206 22.5277 40.5433 22.5487C40.5146 22.5877 40.4967 22.6147 40.4497 22.6334L40.3587 22.6315Z"
          fill="#1B1536"
        />
        <path
          id="Vector_214"
          d="M40.5708 21.7664C40.5415 21.7092 40.5489 21.6589 40.5526 21.5967L40.5709 21.571C40.6194 21.5692 40.6616 21.5593 40.7052 21.5818C40.7144 21.6365 40.7266 21.7244 40.6939 21.7714C40.7216 21.8162 40.7127 21.8591 40.7131 21.9112C40.7098 21.9591 40.7038 22.0058 40.7151 22.0529C40.7263 22.0995 40.7181 22.1409 40.7064 22.1866L40.6648 22.1946C40.6828 22.2174 40.6706 22.2081 40.7044 22.218L40.7218 22.2487L40.7225 22.41C40.6933 22.4143 40.6656 22.4163 40.6389 22.4295C40.6107 22.4436 40.5736 22.4408 40.5424 22.442L40.5343 22.4117C40.4831 22.4492 40.4143 22.4413 40.3525 22.4444L40.3433 22.4249C40.3297 22.3774 40.3371 22.2534 40.3665 22.2147L40.4335 22.2133C40.5597 22.2141 40.4777 22.2534 40.533 22.3083C40.534 22.288 40.5294 22.2667 40.536 22.2476C40.5388 22.2395 40.5664 22.2156 40.5667 22.2102C40.5669 22.2062 40.5432 22.1873 40.5394 22.1795C40.528 22.1559 40.5366 22.0615 40.5358 22.0303L40.5505 21.9081C40.5377 21.8691 40.5439 21.8264 40.5457 21.7859L40.5708 21.7664Z"
          fill="#1B1536"
        />
        <path
          id="Vector_215"
          d="M39.7825 20.7023C40.081 20.624 40.3383 20.6289 40.6085 20.7886C40.775 20.8869 40.9211 21.0453 41.0099 21.2167L41.0127 21.2426C41.0176 21.2784 41.0131 21.265 41.0323 21.2939C41.0157 21.3356 41.0195 21.3446 41.0281 21.3881C41.0351 21.4233 41.0482 21.4548 41.0539 21.4908L41.0727 21.6038C41.083 21.6778 41.0745 21.7451 41.0626 21.8162C41.0568 21.8508 41.0589 21.8731 41.0475 21.907L41.0026 22.0568C40.9841 22.1091 40.9562 22.1423 40.9263 22.187C40.9009 22.2251 40.8827 22.2585 40.8521 22.2939L40.8661 22.2097L40.8265 22.1979L40.7803 22.1872L40.7918 22.1807C40.8377 22.1628 40.8478 22.1552 40.8811 22.119C40.8796 22.0811 40.875 22.0449 40.8922 22.0097C40.9016 21.9906 40.908 21.9796 40.9134 21.9588L40.9268 21.9221C40.9511 21.8641 40.9439 21.802 40.9441 21.7396C40.9444 21.6297 40.949 21.5239 40.9381 21.4143C40.9356 21.3889 40.9349 21.3646 40.9287 21.3397C40.8818 21.1507 40.7475 20.9643 40.5835 20.8615C40.5399 20.8277 40.4918 20.8005 40.4424 20.7762C40.2253 20.6697 40.0148 20.6872 39.7925 20.7617L39.7825 20.7023Z"
          fill="#0F1758"
        />
        <path
          id="Vector_216"
          d="M39.7924 20.7618C40.0148 20.6872 40.2253 20.6697 40.4424 20.7762C40.4918 20.8005 40.5399 20.8277 40.5834 20.8615L40.5498 20.8909C40.49 20.8623 40.3815 20.7983 40.319 20.8171C40.329 20.8553 40.3409 20.8684 40.3593 20.9004L40.3784 20.9458L40.3651 20.962C40.3482 20.9845 40.3436 21.0005 40.3371 21.0272C40.3357 21.0768 40.3331 21.1199 40.3196 21.1678L40.3144 21.1853C40.301 21.2316 40.2928 21.2616 40.3023 21.3091L40.2908 21.3352L40.2647 21.3362L40.1697 21.3545L40.1672 21.3813L40.1565 21.4717L40.1243 21.4228C40.126 21.3597 40.1299 21.3254 40.094 21.2714C40.0814 21.284 40.0654 21.2939 40.0562 21.3092C40.0525 21.3154 40.052 21.3442 40.0487 21.3469C40.0455 21.3496 40.0176 21.3447 40.0107 21.3471C40.0049 21.3491 39.9776 21.3801 39.9729 21.3848L39.9653 21.3621C39.9503 21.3231 39.9554 21.3488 39.9495 21.3074L39.9464 21.2826L39.9388 21.294C39.9459 21.3347 39.9385 21.3589 39.9259 21.3969L39.921 21.411C39.9243 21.4499 39.9263 21.4884 39.9341 21.5268L39.9638 21.5268C39.9651 21.5808 39.9611 21.642 39.9745 21.6943L39.9771 21.7812L39.9557 21.8645L39.9347 21.8557L39.8291 21.8688C39.786 21.8502 39.7864 21.8328 39.7666 21.7915L39.7456 21.7819L39.7313 21.7645C39.6889 21.7184 39.6448 21.7193 39.5869 21.7192L39.5643 21.7499L39.5401 21.7607L39.5276 21.7048L39.5323 21.6832C39.5364 21.6428 39.5429 21.6002 39.5377 21.5596C39.5315 21.5105 39.5253 21.5111 39.4871 21.4834L39.5339 21.4553C39.5372 21.4378 39.5443 21.4109 39.5424 21.3923C39.5375 21.3447 39.5135 21.3249 39.4801 21.2959C39.4416 21.2546 39.4236 21.261 39.3689 21.2544C39.357 21.3162 39.3457 21.3743 39.347 21.4377L39.322 21.4593C39.2833 21.4536 39.2434 21.4505 39.2078 21.4335L39.2204 21.416C39.2677 21.2446 39.3564 21.1211 39.4734 20.9905C39.5648 20.8883 39.6716 20.8237 39.7924 20.7618Z"
          fill="#FBFAFB"
        />
        <path
          id="Vector_217"
          d="M39.9497 20.7795C39.9982 20.7786 40.0411 20.7677 40.0825 20.7944C40.0893 20.8376 40.092 20.8705 40.0845 20.9144L39.988 20.9246L39.9534 20.8928L39.9497 20.7795Z"
          fill="#0F1758"
        />
        <path
          id="Vector_218"
          d="M40.0885 20.9851L40.1141 20.9988L40.1181 21.1047C40.0832 21.1441 40.0512 21.1388 40.0004 21.1471L39.9571 21.0906C39.9536 21.0458 39.9442 21.031 39.9729 20.9949L40.0885 20.9851Z"
          fill="#0F1758"
        />
        <path
          id="Vector_219"
          d="M40.1764 20.7727L40.2789 20.8003C40.2967 20.8592 40.3121 20.9424 40.2958 21.0022L40.2576 21.0009C40.2135 20.9632 40.1446 20.915 40.1382 20.8578C40.1705 20.8603 40.1549 20.8631 40.1848 20.8486L40.1764 20.7727Z"
          fill="#0F1758"
        />
        <path
          id="Vector_220"
          d="M39.8326 21.1024L39.8821 21.1284C39.8957 21.1687 39.9129 21.2443 39.8984 21.2846C39.8907 21.3059 39.8414 21.3218 39.8209 21.332C39.7917 21.3011 39.7632 21.277 39.7556 21.2334C39.7724 21.1655 39.7837 21.1535 39.8326 21.1024Z"
          fill="#0F1758"
        />
        <path
          id="Vector_221"
          d="M39.9341 21.5268L39.9227 21.5392C39.887 21.5729 39.8522 21.5787 39.805 21.5754L39.774 21.5286C39.7722 21.4653 39.7655 21.4471 39.8002 21.3923C39.856 21.3842 39.8697 21.3916 39.921 21.411C39.9242 21.4499 39.9263 21.4884 39.9341 21.5268Z"
          fill="#0F1758"
        />
        <path
          id="Vector_222"
          d="M40.2647 21.3362L40.1635 21.1956C40.1711 21.1508 40.1707 21.1329 40.2 21.0972L40.2605 21.0935C40.3036 21.1162 40.3009 21.1219 40.3196 21.1678L40.3144 21.1853C40.301 21.2316 40.2928 21.2616 40.3023 21.3091L40.2908 21.3353L40.2647 21.3362Z"
          fill="#1B347B"
        />
        <path
          id="Vector_223"
          d="M39.858 20.8072C39.9049 20.8437 39.9052 20.8983 39.9148 20.9534C39.8921 21.0079 39.8733 21.0083 39.8224 21.0353C39.8093 21.029 39.801 21.0259 39.7896 21.0155C39.7527 20.9816 39.7519 20.9241 39.7467 20.8777C39.7737 20.8364 39.8138 20.8276 39.858 20.8072Z"
          fill="#0F1758"
        />
        <path
          id="Vector_224"
          d="M39.7667 21.7915C39.7753 21.741 39.7743 21.6604 39.814 21.629C39.851 21.6504 39.8297 21.6349 39.8523 21.6568C39.8707 21.6746 39.889 21.681 39.9124 21.6904C39.9453 21.7427 39.937 21.7966 39.9347 21.8557L39.8291 21.8688C39.786 21.8502 39.7864 21.8328 39.7667 21.7915Z"
          fill="#0F1758"
        />
        <path
          id="Vector_225"
          d="M39.5802 21.491L39.6626 21.4919C39.7074 21.4994 39.7216 21.5232 39.7459 21.558C39.7549 21.6104 39.7505 21.6379 39.7329 21.6879L39.6323 21.6913C39.5891 21.6842 39.5823 21.6674 39.5591 21.6345C39.5493 21.5772 39.5601 21.5449 39.5802 21.491Z"
          fill="#0F1758"
        />
        <path
          id="Vector_226"
          d="M39.5327 21.1799L39.6323 21.2301L39.6702 21.2036C39.6915 21.2264 39.6963 21.2362 39.7106 21.2624L39.7257 21.2885C39.7409 21.3155 39.7448 21.3389 39.7482 21.3696C39.7288 21.4128 39.7231 21.4205 39.6853 21.449C39.6407 21.4539 39.6348 21.4535 39.5945 21.4342C39.5702 21.4013 39.5543 21.3661 39.5587 21.3242L39.5802 21.241L39.5545 21.2307L39.5327 21.1799Z"
          fill="#0F1758"
        />
        <path
          id="Vector_227"
          d="M39.3362 21.2218C39.4299 21.091 39.5292 20.9868 39.6677 20.9034C39.7164 20.9642 39.7543 21.0022 39.7512 21.082C39.7221 21.1281 39.7045 21.1551 39.655 21.1797C39.6245 21.1709 39.6019 21.1628 39.5759 21.1445L39.4035 21.0317L39.5327 21.1799L39.5545 21.2307L39.5339 21.2868L39.4801 21.2959C39.4416 21.2546 39.4236 21.261 39.3689 21.2544C39.357 21.3162 39.3457 21.3743 39.347 21.4378L39.322 21.4593C39.2833 21.4536 39.2434 21.4505 39.2078 21.4335L39.2204 21.4161L39.2474 21.3696C39.274 21.3148 39.3005 21.2718 39.3362 21.2218Z"
          fill="#0F1758"
        />
        <path
          id="Vector_228"
          d="M40.7268 24.2891C40.7567 24.2796 40.7738 24.2728 40.7983 24.2521L40.8168 24.2351L40.8562 24.2482L40.5772 24.5351L40.5765 24.5116C40.5774 24.4061 40.6561 24.3564 40.7268 24.2891Z"
          fill="#5F112B"
        />
        <path
          id="Vector_229"
          d="M40.7268 24.2891C40.807 24.1798 40.9264 24.0783 41.0225 23.9804C41.066 23.9361 41.117 23.8694 41.1687 23.8355C41.1899 23.8216 41.2126 23.8167 41.2368 23.8109C41.1567 23.9263 41.0605 24.0287 40.9658 24.1321C40.9345 24.1663 40.8939 24.2233 40.8562 24.2482L40.8168 24.2351L40.7983 24.2521C40.7738 24.2728 40.7567 24.2796 40.7268 24.2891Z"
          fill="#5F112B"
        />
        <path
          id="Vector_230"
          d="M39.6515 27.0697C40.5003 27.8649 41.2985 28.7121 42.1437 29.511C42.3818 29.7361 42.6025 29.9869 42.8589 30.1914L42.8585 30.3322L42.8574 30.5289L42.8572 30.7544L42.8552 30.9662C42.8699 30.9871 42.88 31.0033 42.8904 31.0269L42.8844 31.0567C42.8774 31.0924 42.875 31.1266 42.873 31.1628C42.8545 31.2359 42.8595 31.3001 42.8641 31.3743C42.8967 31.4136 42.9176 31.5009 42.9003 31.5537L42.8869 31.5814C42.8571 31.6571 42.8667 31.7466 42.8667 31.8271L42.925 31.8746C42.924 31.9186 42.9264 31.9663 42.9173 32.0092L42.8771 32.0183C42.8685 32.0783 42.8691 32.1342 42.8721 32.1947L42.8718 32.2035C42.8658 32.275 42.8815 32.3943 42.8338 32.4438C42.7813 32.4638 42.7308 32.4719 42.6767 32.4504L42.6597 32.4423L42.6358 32.4345C42.6085 32.4254 42.6201 32.4307 42.5965 32.4165L42.5825 32.4496L42.5715 32.4471C42.5224 32.343 42.396 32.2409 42.3147 32.1591C42.1351 31.9783 41.9537 31.7992 41.7735 31.619C41.0653 30.9108 40.3485 30.2116 39.6436 29.5002C39.667 29.4356 39.6549 29.3516 39.6536 29.2833C39.6509 29.1475 39.6486 29.0117 39.648 28.8758C39.6454 28.2768 39.6229 27.6676 39.6515 27.0697Z"
          fill="#56334E"
        />
        <path
          id="Vector_231"
          d="M42.0641 30.554L41.9785 30.5941C41.9288 30.5829 41.9283 30.5766 41.8953 30.5368L41.9017 30.4971C41.9363 30.4518 41.9587 30.4337 42.011 30.4115L42.0641 30.554Z"
          fill="#FBFAFB"
        />
        <path
          id="Vector_232"
          d="M41.9172 30.2491L42.034 30.1478L42.1961 30.3152C42.1496 30.3498 42.1038 30.3912 42.0467 30.4057L42.0202 30.3971L41.9172 30.2491Z"
          fill="#ED3131"
        />
        <path
          id="Vector_233"
          d="M42.1961 30.3152C42.2432 30.3549 42.2694 30.3925 42.2989 30.4464L42.1402 30.5647C42.1086 30.5676 42.0928 30.5681 42.0641 30.554L42.011 30.4115L42.0202 30.3971L42.0466 30.4057C42.1037 30.3912 42.1496 30.3498 42.1961 30.3152Z"
          fill="#5F112B"
        />
        <path
          id="Vector_234"
          d="M42.2989 30.4464C42.3214 30.4821 42.4342 30.6351 42.4293 30.6577C42.4221 30.6911 42.4001 30.7153 42.3796 30.7416C42.2927 30.7387 42.2003 30.6246 42.1402 30.5647L42.2989 30.4464Z"
          fill="#ED3131"
        />
        <path
          id="Vector_235"
          d="M41.3391 29.4795L41.5347 29.6685L41.4194 29.7841L41.2087 29.6016L41.3391 29.4795Z"
          fill="#FFBF14"
        />
        <path
          id="Vector_236"
          d="M41.679 29.8127C41.7499 29.848 41.8301 29.9449 41.8898 30.0007L41.7768 30.1141C41.743 30.1125 41.6026 29.9637 41.5688 29.9327L41.679 29.8127Z"
          fill="#FFBF14"
        />
        <path
          id="Vector_237"
          d="M40.6123 28.7804C40.6921 28.8347 40.7679 28.9299 40.837 28.9992L40.7336 29.0934L40.7026 29.0969L40.52 28.9082L40.6123 28.7804Z"
          fill="#FFBF14"
        />
        <path
          id="Vector_238"
          d="M40.9769 29.1301C41.0499 29.1783 41.1195 29.2702 41.1811 29.3345L41.0651 29.4465C40.9902 29.3932 40.9232 29.3098 40.8586 29.2434L40.9769 29.1301Z"
          fill="#FFBF14"
        />
        <path
          id="Vector_239"
          d="M40.2345 28.4087C40.3255 28.4823 40.4035 28.5743 40.4831 28.6599L40.3713 28.7623C40.2966 28.7364 40.1787 28.5758 40.1223 28.5149L40.2345 28.4087Z"
          fill="#FFBF14"
        />
        <path
          id="Vector_240"
          d="M26.5757 21.02C26.641 21.1331 26.6383 21.3093 26.6518 21.4385C26.7025 21.9244 26.7094 22.4091 26.7409 22.8955L26.7158 22.9722L26.6223 22.7252L26.5845 22.716L26.5757 21.02Z"
          fill="#0F1758"
        />
        <path
          id="Vector_241"
          d="M26.4032 22.9197C26.3942 22.4203 26.4409 21.9046 26.4826 21.407C26.4906 21.3126 26.4918 21.062 26.5429 20.9968L26.5757 21.02L26.5845 22.7159L26.5816 22.895L26.4032 22.9197Z"
          fill="#FBFAFB"
        />
        <path
          id="Vector_242"
          d="M26.7409 22.8955C27.0319 22.9522 27.2903 23.2671 27.4596 23.4889L27.6668 23.8166L27.4685 23.8085L27.3029 23.8058L26.9635 23.8055C26.9453 23.7101 26.9134 23.62 26.8896 23.5261C26.8405 23.3327 26.7997 23.1544 26.7158 22.9723L26.7409 22.8955Z"
          fill="#1B1536"
        />
        <path
          id="Vector_243"
          d="M31.3964 17.3044L31.3971 16.8914C31.4049 16.7322 31.5777 16.5785 31.691 16.4786C31.8448 16.343 32.0321 16.2221 32.2306 16.1656C32.3841 16.122 32.5956 16.1467 32.7563 16.1465C33.057 16.146 33.3621 16.1356 33.6623 16.1547C33.5953 16.2418 33.5372 16.3359 33.4531 16.4074C33.3454 16.4461 33.2475 16.5118 33.1415 16.5472C33.0891 16.5647 33.0272 16.566 32.9722 16.5699L32.9298 16.5485C32.8122 16.4717 32.3081 16.5204 32.1604 16.5527C31.9148 16.6065 31.6866 16.7704 31.549 16.98L31.5367 16.9983C31.4761 17.0899 31.4301 17.1999 31.3964 17.3044Z"
          fill="#797388"
        />
        <path
          id="Vector_244"
          d="M26.5845 22.716L26.6223 22.7252L26.7158 22.9723C26.7997 23.1544 26.8405 23.3327 26.8896 23.5261C26.9134 23.62 26.9453 23.7101 26.9635 23.8055L26.5819 23.8052L26.5731 23.8076L25.7342 23.8063L25.5586 23.8079L25.5278 23.7904C25.71 23.4254 26.0095 23.0608 26.4032 22.9197L26.5816 22.895L26.5845 22.716Z"
          fill="#797388"
        />
        <path
          id="Vector_245"
          d="M26.5845 22.716L26.6223 22.7252L26.7158 22.9723C26.7997 23.1544 26.8405 23.3327 26.8896 23.5261C26.9134 23.62 26.9453 23.7101 26.9635 23.8055L26.5819 23.8052L26.5816 22.895L26.5845 22.716Z"
          fill="#5D5670"
        />
        <path
          id="Vector_246"
          d="M24.7941 27.1657C24.8662 27.2457 24.9173 27.3007 24.945 27.4073L24.9186 28.8983L24.2952 28.8959L24.2833 27.5753L24.7841 27.5752L24.7941 27.1657Z"
          fill="#D31D22"
        />
        <path
          id="Vector_247"
          d="M24.534 27.002C24.5312 26.2179 24.4595 25.4307 24.8199 24.7055C24.9635 24.4164 25.1504 24.1456 25.377 23.9155C25.4204 23.8714 25.4686 23.8103 25.5278 23.7904L25.5586 23.8079L25.7342 23.8063C25.6677 23.9236 25.6168 24.0386 25.5848 24.1699L25.5775 24.1984C25.5402 24.3472 25.5407 24.5074 25.5392 24.66C25.5371 24.8515 25.5366 25.043 25.5361 25.2346C25.5347 25.8282 25.5401 26.4221 25.5346 27.0156L24.7975 27.0131L24.7818 27.0014L24.534 27.002Z"
          fill="#ECE7E0"
        />
        <path
          id="Vector_248"
          d="M25.5586 23.8079L25.7342 23.8063C25.6677 23.9236 25.6168 24.0386 25.5848 24.1699L25.5775 24.1984C25.5402 24.3472 25.5408 24.5074 25.5392 24.66C25.5372 24.8515 25.5366 25.043 25.5361 25.2345C25.5347 25.8282 25.5401 26.4221 25.5346 27.0156L24.7975 27.0131L24.7818 27.0014L25.3963 26.9998C25.4038 26.4174 25.4029 25.8349 25.4044 25.2524C25.4052 24.9567 25.3873 24.6499 25.4147 24.3561C25.4306 24.1855 25.4633 23.9533 25.5586 23.8079Z"
          fill="#A99D9F"
        />
        <path
          id="Vector_249"
          d="M26.5819 23.8052L26.9635 23.8055L27.3029 23.8058L27.3022 27.0151L26.7521 27.0159L26.569 27.0158L25.5346 27.0156C25.5402 26.4221 25.5348 25.8282 25.5362 25.2346C25.5366 25.043 25.5372 24.8515 25.5392 24.66C25.5408 24.5074 25.5402 24.3472 25.5775 24.1984L25.5848 24.1699C25.6168 24.0386 25.6677 23.9236 25.7343 23.8063L26.5731 23.8076L26.5819 23.8052Z"
          fill="#ECE7E0"
        />
        <path
          id="Vector_250"
          d="M26.5606 26.3063L26.5897 26.3071L26.5864 26.591L26.5652 26.5939L26.1143 26.593L26.1148 26.3093L26.5606 26.3063Z"
          fill="#D31D22"
        />
        <path
          id="Vector_251"
          d="M26.5285 24.037C26.688 24.0621 26.8188 24.1089 26.9159 24.2456C27.0025 24.3675 27.0409 24.524 27.0114 24.6715C26.9887 24.7853 26.9193 24.8754 26.8378 24.9544C26.7449 25.0154 26.6637 25.0544 26.5529 25.0744C26.4229 25.0715 26.2909 25.0526 26.1885 24.9646C26.0793 24.8708 26.0164 24.7377 26.0058 24.5947C25.9949 24.4488 26.0209 24.3086 26.1217 24.1967C26.2323 24.0738 26.3726 24.0484 26.5285 24.037Z"
          fill="url(#paint15_linear_11_402)"
        />
        <path
          id="Vector_252"
          d="M26.7021 24.3182C26.7281 24.3894 26.7543 24.4662 26.7434 24.543C26.7168 24.5567 26.7048 24.5567 26.6753 24.5528L26.6338 24.5862L26.6375 24.637C26.6697 24.6492 26.672 24.6473 26.7056 24.6379L26.7132 24.6626C26.668 24.7345 26.6155 24.7936 26.5286 24.8118C26.4339 24.8316 26.329 24.8198 26.2354 24.8001C26.1965 24.7498 26.1577 24.7023 26.1298 24.6448C26.1987 24.6305 26.2648 24.6442 26.3352 24.6318L26.3953 24.6275C26.4451 24.6276 26.4062 24.6304 26.4508 24.6259L26.449 24.6084L26.4447 24.5862L26.4745 24.5523L26.5164 24.5436L26.5437 24.4802C26.616 24.4591 26.6662 24.3795 26.7021 24.3182Z"
          fill="#88051B"
        />
        <path
          id="Vector_253"
          d="M26.1298 24.6448L26.1228 24.5838C26.1202 24.4619 26.1605 24.3517 26.2504 24.267C26.3132 24.2077 26.398 24.1725 26.4852 24.1784C26.5835 24.185 26.6417 24.2483 26.7021 24.3182C26.6662 24.3794 26.616 24.4591 26.5436 24.4802L26.5164 24.5436L26.4744 24.5523L26.4446 24.5862L26.4489 24.6083L26.4508 24.6259C26.4062 24.6304 26.4451 24.6276 26.3953 24.6275L26.3352 24.6318C26.2648 24.6442 26.1987 24.6304 26.1298 24.6448Z"
          fill="#D31D22"
        />
        <path
          id="Vector_254"
          d="M26.3352 24.6318L26.3188 24.6119C26.2887 24.5721 26.2746 24.4924 26.2839 24.444C26.289 24.4174 26.3136 24.4109 26.3347 24.397C26.3885 24.3976 26.4597 24.3859 26.5041 24.4158C26.5125 24.4722 26.4982 24.5015 26.4744 24.5523L26.4446 24.5862L26.4489 24.6083L26.4508 24.6259C26.4062 24.6304 26.4451 24.6276 26.3952 24.6275L26.3352 24.6318Z"
          fill="#FBFAFB"
        />
        <path
          id="Vector_255"
          d="M26.5818 23.8052L26.9635 23.8055L27.3029 23.8058L27.3021 27.0151L26.752 27.0159L26.5689 27.0158L26.5652 26.5939L26.5863 26.591L26.5896 26.3071L26.5605 26.3063L26.5619 25.729L26.5468 25.7063C26.5685 25.6846 26.6075 25.7064 26.6451 25.6988L26.6527 25.676L26.6147 25.6759C26.581 25.6535 26.5658 25.6694 26.534 25.6458L26.5529 25.0744C26.6637 25.0544 26.7449 25.0154 26.8378 24.9544C26.9193 24.8754 26.9887 24.7853 27.0114 24.6715C27.0409 24.5239 27.0025 24.3675 26.9159 24.2456C26.8188 24.1089 26.688 24.0621 26.5284 24.037C26.5453 24.033 26.5566 24.0267 26.5718 24.0186L26.573 23.8076L26.5818 23.8052Z"
          fill="url(#paint16_linear_11_402)"
        />
        <path
          id="Vector_256"
          d="M26.5897 26.3071L26.8441 26.3051L26.8367 26.575L26.7999 26.599L26.5864 26.591L26.5897 26.3071Z"
          fill="#B90822"
        />
        <path
          id="Vector_257"
          d="M26.5864 26.591L26.7999 26.599L26.8365 26.6221C26.8381 26.74 26.8566 26.8886 26.8191 27.0007L26.752 27.0159L26.5689 27.0158L26.5652 26.5939L26.5864 26.591Z"
          fill="#E2D4CA"
        />
        <path
          id="Vector_258"
          d="M26.8378 24.9544C26.8753 25.0382 26.8628 25.1601 26.865 25.2511C26.8706 25.4761 26.8709 25.7011 26.8707 25.9261C26.8705 26.031 26.8889 26.1941 26.851 26.2916L26.8441 26.3051L26.5896 26.3071L26.5605 26.3063L26.5619 25.729L26.5468 25.7063C26.5685 25.6846 26.6075 25.7064 26.6451 25.6988L26.6527 25.676L26.6147 25.6759C26.581 25.6535 26.5658 25.6694 26.534 25.6458L26.5529 25.0744C26.6637 25.0544 26.7449 25.0154 26.8378 24.9544Z"
          fill="#E2D4CA"
        />
        <path
          id="Vector_259"
          d="M27.4596 23.4889C27.5057 23.3866 27.4843 23.1669 27.494 23.0499C27.5285 22.6337 27.5726 22.2187 27.6062 21.8023C27.6652 22.0381 27.7287 22.2734 27.7924 22.508C27.824 22.6242 27.8705 22.748 27.8852 22.8673C27.9158 23.1161 27.8907 23.3934 27.8888 23.6451C28.1592 23.9952 28.4676 24.3224 28.7211 24.6846C28.9 24.9401 29.0571 25.2263 29.1296 25.5313C29.1914 25.7917 29.17 26.081 29.1705 26.3479C29.1715 26.8264 29.1587 27.3067 29.1668 27.7848L28.1057 28.9049L28.0849 28.9002L28.0675 28.7988C28.0615 28.736 28.067 28.6717 28.0694 28.6087C28.0767 28.5418 28.0761 28.4783 28.0729 28.4111L28.0733 28.2181C28.081 28.1604 28.0764 28.1058 28.0722 28.0479L28.0743 27.8184C28.0869 27.7381 28.0793 27.6743 28.0614 27.596L28.0503 27.4546C28.0559 27.3914 28.143 27.4088 28.1894 27.3581C28.2227 27.3218 28.2502 27.2687 28.2452 27.2184L28.2412 27.1897L28.3068 27.1635C28.3462 27.1146 28.3509 27.0606 28.3612 27.0008L27.9692 27.006C27.7566 27.0365 27.5179 27.0156 27.3022 27.0151L27.3029 23.8058L27.4685 23.8085L27.6668 23.8166L27.4596 23.4889Z"
          fill="url(#paint17_linear_11_402)"
        />
        <path
          id="Vector_260"
          d="M27.3029 23.8058L27.4685 23.8085L27.6668 23.8166C28.007 24.1946 28.1831 24.6033 28.3038 25.0906C28.3852 25.4189 28.3685 25.7791 28.3683 26.1147C28.3681 26.4096 28.3718 26.7061 28.3612 27.0008L27.9692 27.006C27.7566 27.0365 27.5179 27.0156 27.3022 27.0151L27.3029 23.8058Z"
          fill="#886676"
        />
        <path
          id="Vector_261"
          d="M27.452 27.0058C27.4617 26.2317 27.4527 25.4561 27.452 24.6819C27.4518 24.4962 27.4499 24.3105 27.448 24.1247C27.4471 24.0316 27.4302 23.9037 27.4629 23.8174L27.4711 23.8437C27.5015 23.9337 27.5681 24.0225 27.616 24.1048C27.6831 24.2204 27.7419 24.346 27.7839 24.4729C28.0476 25.2692 27.9482 26.1627 27.9613 26.9907C27.9093 27.0068 27.8452 27 27.7905 27.0009C27.6776 27.0027 27.5648 27.0043 27.452 27.0058Z"
          fill="#A99D9F"
        />
        <path
          id="Vector_262"
          d="M27.9692 27.006L28.3611 27.0008C28.3509 27.0606 28.3462 27.1146 28.3067 27.1635L28.2412 27.1897L28.2452 27.2184C28.2502 27.2687 28.2227 27.3218 28.1894 27.358C28.143 27.4088 28.0558 27.3914 28.0503 27.4546L28.0613 27.5959C28.0792 27.6743 28.0869 27.7381 28.0743 27.8184L28.0721 28.0479C28.0763 28.1058 28.081 28.1604 28.0733 28.2181L28.0729 28.4111C28.0761 28.4783 28.0767 28.5418 28.0693 28.6087C28.0669 28.6717 28.0615 28.736 28.0675 28.7988L27.6667 28.8023C27.6546 28.8216 27.6428 28.8386 27.6351 28.8602L27.6487 28.9671C27.7155 29.0127 27.9638 28.984 28.0549 28.9839L28.053 29.1642L27.6435 29.1641L27.6437 34.1595L27.3976 34.1621L26.5529 34.1633C26.5323 34.2727 26.5403 34.3923 26.54 34.5037L26.3499 34.4954C26.1591 34.476 25.8634 34.4564 25.6857 34.5292L25.7029 34.6724L25.1773 34.6662L23.834 33.4026L23.7981 33.3708C23.7961 33.3684 23.7707 33.3334 23.7686 33.3276C23.7487 33.2738 23.7664 33.1091 23.7657 33.0439C23.7613 32.675 23.7587 32.306 23.7496 31.9373C23.7671 31.2479 23.7512 30.5536 23.7517 29.8638C23.7518 29.716 23.7534 29.568 23.7509 29.4202C23.7492 29.316 23.7379 29.2076 23.7541 29.1045C23.799 29.0529 23.8041 28.984 23.8509 28.9373C23.9112 28.8771 24.0353 28.8956 24.1149 28.8951L24.2951 28.8959L24.9186 28.8983L24.945 27.4073C24.9173 27.3007 24.8662 27.2457 24.794 27.1657L24.7975 27.0131L25.5346 27.0156L26.5689 27.0158L26.752 27.0159L27.3021 27.0151C27.5178 27.0156 27.7565 27.0365 27.9692 27.006Z"
          fill="url(#paint18_linear_11_402)"
        />
        <path
          id="Vector_263"
          d="M25.0117 28.062L25.3052 28.0646L25.3056 28.2275L25.0243 28.224L24.9893 28.1661C24.9912 28.1248 24.9935 28.1002 25.0117 28.062Z"
          fill="#250C28"
        />
        <path
          id="Vector_264"
          d="M25.0256 28.827L25.3256 28.819L25.3257 28.9952L25.0225 28.995C25.0054 28.9352 25.0094 28.8863 25.0256 28.827Z"
          fill="#250C28"
        />
        <path
          id="Vector_265"
          d="M25.0181 28.4394L25.313 28.4384C25.3446 28.4754 25.3323 28.5478 25.3321 28.5974C25.2477 28.625 25.1136 28.6068 25.0229 28.6055C25.0101 28.5482 25.0139 28.4977 25.0181 28.4394Z"
          fill="#250C28"
        />
        <path
          id="Vector_266"
          d="M26.5446 34.1601L26.5529 34.1633C26.5324 34.2727 26.5404 34.3923 26.5401 34.5037L26.3499 34.4954C26.1591 34.476 25.8634 34.4565 25.6857 34.5292L25.6622 34.1616L26.5446 34.1601Z"
          fill="#1B1536"
        />
        <path
          id="Vector_267"
          d="M25.6005 30.4615L25.7671 30.4644C25.8103 30.5331 25.7827 30.7929 25.7826 30.8823C25.7823 31.3075 25.7819 31.7327 25.7816 32.1579L25.6015 32.1597L25.6005 30.4615Z"
          fill="#130B24"
        />
        <path
          id="Vector_268"
          d="M26.1058 30.468L26.2966 30.4667L26.299 32.1597L26.1059 32.1606L26.1058 30.468Z"
          fill="#130B24"
        />
        <path
          id="Vector_269"
          d="M27.9692 27.006L28.3611 27.0008C28.3509 27.0606 28.3462 27.1146 28.3068 27.1635L28.2412 27.1897L28.2452 27.2184C28.2502 27.2687 28.2227 27.3218 28.1894 27.358C28.143 27.4088 28.0559 27.3914 28.0503 27.4546L28.0614 27.5959C28.0793 27.6743 28.0869 27.7381 28.0743 27.8184L27.6446 27.821L27.643 27.6418L27.648 27.4353C27.6427 27.3982 27.64 27.3702 27.6213 27.337L27.2886 27.3246L27.2885 29.6708C27.2307 29.7733 27.1101 29.9349 26.9932 29.9676C26.9398 29.9825 26.906 29.9955 26.8569 30.0195C26.8372 30.0292 26.8088 30.0293 26.7873 30.0314L26.778 30.0081C26.7176 29.9909 26.6427 29.9981 26.5795 29.9971L26.5724 30.001L26.5801 30.0345C26.4932 30.0574 26.3955 30.0499 26.3059 30.0504C26.2095 30.0509 26.1043 30.0582 26.0093 30.0422C25.8587 30.017 25.7116 29.8447 25.6314 29.7264L25.6149 27.3333L25.3206 27.3343C25.2768 27.3787 25.323 27.4218 25.2751 27.4545L25.0231 27.4527L25.0228 27.6704L25.3124 27.6684C25.3123 27.7219 25.3277 27.7944 25.2903 27.833C25.2032 27.8325 25.1112 27.8386 25.0257 27.8213L25.0102 27.79L24.9724 27.7802C24.9389 27.6726 24.968 27.5478 24.95 27.4363L24.945 27.4073C24.9173 27.3007 24.8662 27.2457 24.7941 27.1657L24.7975 27.0131L25.5346 27.0156L26.5689 27.0158L26.752 27.0159L27.3022 27.0151C27.5178 27.0156 27.7565 27.0365 27.9692 27.006Z"
          fill="#130B24"
        />
        <path
          id="Vector_270"
          d="M27.7246 27.4268L28.0418 27.4229C28.0433 27.484 28.04 27.5493 28.0488 27.6096L28.0225 27.6364L27.7051 27.6366L27.643 27.6418L27.648 27.4353L27.7246 27.4268Z"
          fill="#434D6A"
        />
        <path
          id="Vector_271"
          d="M27.648 27.4353L27.7246 27.4268L27.696 27.4584L27.7012 27.4834C27.7105 27.5331 27.7064 27.5863 27.7051 27.6366L27.643 27.6418L27.648 27.4353Z"
          fill="#434D6A"
        />
        <path
          id="Vector_272"
          d="M26.1742 28.562L26.5509 28.5621L26.5508 28.7994L26.1719 28.7989C26.1819 28.7233 26.1745 28.6388 26.1742 28.562Z"
          fill="#528295"
        />
        <path
          id="Vector_273"
          d="M26.1675 28.9366L26.5525 28.9351L26.5547 29.181L26.1773 29.1812C26.178 29.0988 26.1788 29.0185 26.1675 28.9366Z"
          fill="#528295"
        />
        <path
          id="Vector_274"
          d="M26.0979 27.3337L26.5586 27.3439L26.5583 27.8174L26.2715 27.813C26.236 27.8083 26.1992 27.8061 26.167 27.7893L26.1531 27.7802L26.1455 27.7952L26.1368 27.7801C26.1168 27.7472 26.1134 27.7292 26.1131 27.6916C26.1128 27.6512 26.1094 27.6145 26.103 27.5747L26.1004 27.5594L26.0979 27.3337Z"
          fill="#5F112B"
        />
        <path
          id="Vector_275"
          d="M26.2715 27.813L26.5583 27.8174L26.557 28.0558L26.5545 28.196L26.5534 28.4275L26.1684 28.4266C26.1844 28.352 26.1749 28.264 26.1742 28.1875L26.1497 28.1584C26.1498 28.1119 26.1511 28.0937 26.1776 28.053C26.1779 27.9859 26.1646 27.882 26.192 27.8215L26.2715 27.813Z"
          fill="#528295"
        />
        <path
          id="Vector_276"
          d="M26.1776 28.053L26.557 28.0558L26.5545 28.196C26.4317 28.1772 26.2986 28.1872 26.1742 28.1875L26.1497 28.1584C26.1498 28.1119 26.1511 28.0937 26.1776 28.053Z"
          fill="#250C28"
        />
        <path
          id="Vector_277"
          d="M26.2715 27.813L26.5583 27.8174L26.557 28.0558L26.1776 28.053C26.1779 27.9859 26.1646 27.882 26.192 27.8215L26.2715 27.813Z"
          fill="#528295"
        />
        <path
          id="Vector_278"
          d="M26.1005 27.5594L26.103 27.5747C26.1094 27.6145 26.1129 27.6513 26.1132 27.6916C26.1135 27.7292 26.1168 27.7472 26.1368 27.7802L26.1455 27.7952L26.1531 27.7802L26.167 27.7893C26.1992 27.8061 26.236 27.8083 26.2716 27.813L26.1921 27.8215C26.1646 27.882 26.1779 27.9859 26.1776 28.053C26.1511 28.0937 26.1498 28.1119 26.1497 28.1585L26.1743 28.1875C26.1749 28.264 26.1844 28.352 26.1684 28.4266C26.157 28.4736 26.1485 28.5179 26.1742 28.562C26.1745 28.6388 26.1819 28.7233 26.1719 28.7989C26.152 28.8327 26.1468 28.8722 26.1578 28.9106L26.1676 28.9366C26.1788 29.0185 26.178 29.0988 26.1773 29.1812L26.5548 29.181C26.5652 29.3689 26.5661 29.5565 26.5678 29.7446C26.5684 29.8173 26.5545 29.9321 26.5795 29.9971L26.5724 30.001L26.0917 29.9975L26.1005 27.5594Z"
          fill="#420D27"
        />
        <path
          id="Vector_279"
          d="M26.9363 27.3206L27.2886 27.3246L27.2885 29.6708C27.2307 29.7733 27.1101 29.9349 26.9932 29.9676C26.9398 29.9825 26.906 29.9955 26.8569 30.0195C26.8372 30.0292 26.8088 30.0293 26.7873 30.0314L26.778 30.0081C26.8237 29.9928 26.8717 29.9806 26.9057 29.9445C26.9295 29.9193 26.9311 29.9109 26.9353 29.8765C26.9447 29.7977 26.9375 29.7071 26.938 29.6271C26.9391 29.4552 26.9394 29.2832 26.9395 29.1113C26.9398 28.5144 26.938 27.9175 26.9363 27.3206Z"
          fill="#528295"
        />
        <path
          id="Vector_280"
          d="M25.6149 27.3333L26.0979 27.3337L26.1005 27.5594L26.0917 29.9975L26.5724 30.001L26.5802 30.0345C26.4932 30.0574 26.3955 30.0499 26.3059 30.0504C26.2095 30.0509 26.1044 30.0582 26.0093 30.0422C25.8587 30.017 25.7117 29.8447 25.6314 29.7264L25.6149 27.3333Z"
          fill="#67C6CE"
        />
        <path
          id="Vector_281"
          d="M27.2886 27.3246L27.6213 27.337C27.64 27.3702 27.6427 27.3982 27.648 27.4353L27.643 27.6418L27.6446 27.8211L28.0743 27.8184L28.0721 28.0479C28.0763 28.1058 28.081 28.1604 28.0733 28.2181L28.0729 28.4111C28.0761 28.4783 28.0767 28.5418 28.0693 28.6087C28.0669 28.6717 28.0615 28.736 28.0675 28.7988L27.6667 28.8023C27.6547 28.8216 27.6428 28.8386 27.6352 28.8602L27.6487 28.9671C27.7155 29.0127 27.9638 28.984 28.0549 28.9839L28.053 29.1642L27.6435 29.1641L27.6437 34.1595L27.3976 34.1621L26.5529 34.1633L26.5446 34.1601C26.5742 34.0689 26.5535 33.9041 26.5536 33.8039C26.5542 33.4467 26.554 33.0895 26.5551 32.7323C26.5555 32.5589 26.5288 32.3227 26.5805 32.1598C26.6022 31.9645 26.5889 31.758 26.5883 31.5615C26.5871 31.1961 26.5857 30.8308 26.5842 30.4654C26.5682 30.3321 26.5633 30.1678 26.5801 30.0345L26.5724 30.001L26.5795 29.9971C26.6426 29.9981 26.7176 29.9909 26.778 30.0081L26.7873 30.0314C26.8088 30.0293 26.8372 30.0292 26.8569 30.0195C26.906 29.9955 26.9398 29.9825 26.9932 29.9676C27.1101 29.9349 27.2307 29.7733 27.2885 29.6708L27.2886 27.3246Z"
          fill="#47667E"
        />
        <path
          id="Vector_282"
          d="M27.6511 28.0505L28.0721 28.0479C28.0764 28.1058 28.081 28.1604 28.0733 28.2181L27.6489 28.2224L27.6511 28.0505Z"
          fill="#130B24"
        />
        <path
          id="Vector_283"
          d="M27.7766 28.4067L28.0729 28.4111C28.0761 28.4783 28.0767 28.5418 28.0694 28.6087L27.6486 28.6188C27.6485 28.5552 27.6382 28.4721 27.6633 28.4134L27.7766 28.4067Z"
          fill="#130B24"
        />
        <path
          id="Vector_284"
          d="M27.1525 30.4378L27.3395 30.4371L27.3413 32.1671L27.156 32.1663L27.1525 30.4378Z"
          fill="#130B24"
        />
        <path
          id="Vector_285"
          d="M26.5842 30.4654L26.8116 30.4559L26.811 32.1632L26.5805 32.1598C26.6022 31.9645 26.5889 31.758 26.5883 31.5615C26.5871 31.1961 26.5857 30.8308 26.5842 30.4654Z"
          fill="#130B24"
        />
        <path
          id="Vector_286"
          d="M24.945 27.4073L24.95 27.4363C24.968 27.5478 24.9389 27.6726 24.9724 27.7802L25.0101 27.79L25.0257 27.8213L25.0116 28.062C24.9935 28.1002 24.9912 28.1248 24.9892 28.1661L25.0243 28.224L25.0181 28.4394C25.0139 28.4977 25.01 28.5482 25.0229 28.6055L25.0271 28.7034L25.0256 28.827C25.0094 28.8863 25.0054 28.9352 25.0224 28.995L25.0307 29.1922L25.2903 29.1885L25.3122 29.2104L25.3088 29.3361L25.2955 29.6305L25.2945 34.1615L25.6621 34.1615L25.6857 34.5292L25.7029 34.6724L25.1773 34.6662L23.834 33.4026L23.7981 33.3708C23.7961 33.3684 23.7707 33.3334 23.7686 33.3276C23.7487 33.2738 23.7664 33.1091 23.7657 33.0439C23.7613 32.675 23.7587 32.306 23.7496 31.9373C23.7671 31.2479 23.7512 30.5536 23.7517 29.8638C23.7518 29.716 23.7534 29.568 23.7509 29.4202C23.7492 29.316 23.7379 29.2076 23.7541 29.1045C23.799 29.0529 23.8041 28.984 23.8509 28.9373C23.9112 28.8771 24.0353 28.8956 24.1149 28.8951L24.2951 28.8959L24.9186 28.8983L24.945 27.4073Z"
          fill="#5F112B"
        />
        <path
          id="Vector_287"
          d="M25.3088 29.3361L25.2955 29.6305C25.2385 29.5869 25.1913 29.5514 25.1511 29.4905C25.1494 29.4425 25.137 29.391 25.1651 29.3514L25.3088 29.3361Z"
          fill="#528295"
        />
        <path
          id="Vector_288"
          d="M24.945 27.4073L24.95 27.4363C24.968 27.5478 24.9389 27.6726 24.9724 27.7802L25.0102 27.79L25.0257 27.8213L25.0117 28.062C24.9935 28.1002 24.9912 28.1248 24.9893 28.1661L25.0243 28.224L25.0181 28.4394C25.0139 28.4977 25.0101 28.5482 25.0229 28.6055L25.0271 28.7034L24.9925 28.6101C24.9791 28.566 24.9967 28.5202 24.9726 28.4763L24.9877 28.4536L24.9914 28.3628L24.9924 28.294C24.9924 28.2694 24.987 28.2581 24.9756 28.2372L24.9514 28.2594C24.954 28.3526 24.9596 28.4473 24.9568 28.5403C24.9539 28.6392 24.9242 28.7978 24.959 28.8871L24.9506 28.9033C24.9259 28.9677 24.942 29.0727 24.942 29.1423C24.942 29.3478 24.942 29.5531 24.9424 29.7585C24.9426 29.8428 24.95 29.936 24.9406 30.0194C24.9376 30.0458 24.9268 30.0679 24.9265 30.0952C24.9187 30.716 24.931 31.3373 24.9263 31.9583C24.926 32.0095 24.9119 32.0584 24.9112 32.1099C24.9095 32.2385 24.9102 32.3671 24.9101 32.4956C24.9101 32.5457 24.9187 32.6008 24.8944 32.646L24.8948 32.4056L24.9187 28.8983L24.945 27.4073Z"
          fill="#420D27"
        />
        <path
          id="Vector_289"
          d="M24.3014 32.404L24.8948 32.4056L24.8944 32.646L24.8928 32.6592C24.9161 32.8268 24.9024 33.0128 24.9024 33.1828C24.7638 33.1818 24.625 33.1795 24.4865 33.1814C24.4176 33.1824 24.335 33.1952 24.2686 33.1795C24.2193 33.1923 24.1769 33.2063 24.1311 33.229L24.126 33.2151C24.1127 33.1666 24.1186 33.104 24.1182 33.0531C24.1174 32.9348 24.0963 32.7452 24.1482 32.6429L24.142 32.4062L24.3014 32.404Z"
          fill="#434D6A"
        />
        <path
          id="Vector_290"
          d="M24.1482 32.6429L24.1636 32.649L24.1897 32.6551C24.2209 32.6622 24.2503 32.6644 24.2823 32.6661C24.3038 32.7066 24.2953 32.7567 24.2948 32.8013C24.2934 32.9187 24.2918 33.0361 24.2898 33.1536L24.2686 33.1795C24.2193 33.1923 24.1769 33.2063 24.1311 33.229L24.126 33.2151C24.1127 33.1666 24.1186 33.104 24.1182 33.0531C24.1174 32.9348 24.0963 32.7452 24.1482 32.6429Z"
          fill="#797388"
        />
        <path
          id="Vector_291"
          d="M24.3014 32.404L24.8948 32.4056L24.8944 32.646L24.8928 32.6592L24.1636 32.6489L24.1482 32.6429L24.142 32.4062L24.3014 32.404Z"
          fill="#130B24"
        />
        <path
          id="Vector_292"
          d="M24.2952 28.896L24.9186 28.8983L24.8948 32.4056L24.3014 32.404L24.2952 28.896Z"
          fill="#434D6A"
        />
        <path
          id="Vector_293"
          d="M24.2951 28.8959L24.3014 32.404L24.142 32.4061L24.1482 32.6428C24.0963 32.7452 24.1173 32.9347 24.1182 33.0531C24.1186 33.104 24.1127 33.1666 24.126 33.215L24.1311 33.2289C24.0552 33.3052 23.9357 33.3696 23.834 33.4026L23.7981 33.3708C23.7961 33.3684 23.7707 33.3334 23.7686 33.3276C23.7487 33.2738 23.7664 33.1091 23.7657 33.0439C23.7613 32.675 23.7587 32.306 23.7496 31.9373C23.7671 31.2479 23.7512 30.5536 23.7517 29.8638C23.7518 29.716 23.7534 29.568 23.7509 29.4202C23.7492 29.316 23.7379 29.2076 23.7541 29.1045C23.799 29.0529 23.8041 28.984 23.8509 28.9373C23.9112 28.8771 24.0353 28.8956 24.1149 28.8951L24.2951 28.8959Z"
          fill="#47667E"
        />
        <path
          id="Vector_294"
          d="M24.2952 28.8959L24.3015 32.404L24.1421 32.4061C24.0922 32.3397 24.1192 31.67 24.1189 31.5428C24.1174 30.6603 24.1098 29.7775 24.115 28.8952L24.2952 28.8959Z"
          fill="#528295"
        />
        <path
          id="Vector_295"
          d="M28.4459 28.8642L28.4392 29.1384C28.4336 29.1565 28.428 29.1701 28.4288 29.1892L28.0537 29.6091L28.0399 29.3081C28.1566 29.1514 28.3125 29.0078 28.4459 28.8642Z"
          fill="#56334E"
        />
        <path
          id="Vector_296"
          d="M28.3203 31.363L28.3025 31.3447L28.3695 31.2757C28.3997 31.2484 28.3946 31.2247 28.4009 31.1858L28.3814 31.1737L28.3066 31.2067C28.245 31.3119 28.1426 31.4364 28.0527 31.5189L28.0084 31.509L27.9848 31.4734C27.9692 31.4549 27.957 31.4503 27.9475 31.4267C27.9349 31.3956 27.9079 31.365 27.8988 31.3347L27.894 31.3069L27.8788 31.2918C27.8808 31.2643 27.8852 31.2424 27.8938 31.2162H27.9317C27.9536 31.2212 27.9691 31.2284 27.9922 31.2314C28.021 31.2121 28.0102 31.2235 28.0282 31.1965C28.0549 31.1567 28.0926 31.126 28.1059 31.0798C28.0672 31.0592 28.04 31.0306 28.0047 31.0065L27.98 30.9914C27.962 30.9644 27.9571 30.9544 27.9571 30.9208C27.9571 30.8435 27.942 30.7539 27.962 30.6788H27.9733L27.9842 30.766L27.9992 30.6863L28.0369 30.6961C28.1384 30.84 28.2289 31.0013 28.4165 31.0355L28.436 31.0387L28.4234 31.1117C28.4245 31.1622 28.4287 31.2145 28.4225 31.2645L28.3203 31.363Z"
          fill="#130B24"
        />
        <path
          id="Vector_297"
          d="M28.11 31.1248C28.1652 31.1505 28.2157 31.1914 28.2658 31.2261L28.1473 31.3661C28.1231 31.3978 28.1008 31.4186 28.07 31.4431C28.0693 31.3838 28.039 31.2694 28.0543 31.2161C28.062 31.1896 28.0948 31.1497 28.11 31.1248Z"
          fill="#B90822"
        />
        <path
          id="Vector_298"
          d="M27.9841 30.766L27.9992 30.6863L28.0369 30.6961C28.1384 30.84 28.2288 31.0013 28.4165 31.0355L28.436 31.0387L28.4233 31.1117C28.3872 31.1329 28.3585 31.1474 28.3176 31.1587C28.201 31.1022 28.1003 31.038 27.9916 30.9677L27.9841 30.766Z"
          fill="#88051B"
        />
        <path
          id="Vector_299"
          d="M31.6483 18.3757L32.5257 18.3581L32.3174 18.7946L31.7569 18.81L31.6157 18.5129L31.6483 18.3757Z"
          fill="#5D5670"
        />
        <path
          id="Vector_300"
          d="M28.0537 29.6091L28.4288 29.1892L28.4219 30.724C28.419 30.7671 28.4349 30.7916 28.4549 30.8278L28.4084 30.7969L28.3836 30.8225C28.4421 30.8951 28.4305 30.947 28.436 31.0387L28.4165 31.0356C28.2288 31.0013 28.1384 30.84 28.0369 30.6961L28.0596 30.6747C28.0434 30.5529 28.0539 30.4196 28.0539 30.2964C28.0539 30.0673 28.0537 29.8382 28.0537 29.6091Z"
          fill="#420D27"
        />
        <path
          id="Vector_301"
          d="M28.4225 31.2645L28.4272 31.3565L28.4319 32.4564L28.4307 34.3326C28.3257 34.2753 28.2367 34.2067 28.1247 34.1612C28.0901 33.9565 28.1073 33.7205 28.1044 33.512C28.0977 33.0209 28.1048 32.5255 28.0832 32.0349C28.0819 32.0061 28.073 31.9917 28.0513 31.9736L28.04 31.9653L28.0501 31.9333L28.0541 31.6816L28.3202 31.363L28.4225 31.2645Z"
          fill="#420D27"
        />
        <path
          id="Vector_302"
          d="M28.4225 31.2645L28.4272 31.3565C28.4234 31.3955 28.4252 31.4603 28.4134 31.4961C28.4064 31.5175 28.3457 31.5717 28.3268 31.5946C28.2348 31.7061 28.1418 31.8224 28.0597 31.9413L28.0501 31.9333L28.054 31.6816L28.3202 31.363L28.4225 31.2645Z"
          fill="#5F112B"
        />
        <path
          id="Vector_303"
          d="M29.6647 19.7469C29.9709 19.54 30.2752 19.33 30.579 19.1196C30.8477 18.9335 31.1354 18.6885 31.4436 18.5779L30.8726 20.1274C30.7065 20.2008 30.527 20.2606 30.3703 20.3515L30.3528 20.3615L30.3423 20.3677C30.1792 20.5048 30.0061 20.6364 29.8651 20.797C29.8284 20.7069 29.8187 20.6025 29.8041 20.5068C29.773 20.3028 29.7513 20.0994 29.7664 19.8927L29.7505 19.8784L29.6647 19.7469Z"
          fill="#ECE7E0"
        />
        <path
          id="Vector_304"
          d="M29.7664 19.8927C29.9179 19.8868 30.0888 19.7668 30.2367 19.7165C30.3053 19.9242 30.318 20.1513 30.3423 20.3677C30.1791 20.5048 30.006 20.6364 29.8651 20.797C29.8283 20.7069 29.8187 20.6025 29.8041 20.5068C29.773 20.3028 29.7513 20.0994 29.7664 19.8927Z"
          fill="#E2D4CA"
        />
        <path
          id="Vector_305"
          d="M29.5217 19.8493L29.6648 19.7469L29.7505 19.8784L29.7664 19.8927C29.7514 20.0994 29.773 20.3028 29.8041 20.5068C29.8187 20.6025 29.8284 20.7069 29.8652 20.797C29.6279 21.1461 29.5356 21.4991 29.6154 21.9176C29.7003 22.3635 29.968 22.7187 30.3393 22.9688C30.4677 23.0552 30.612 23.1407 30.7538 23.2028L30.8073 23.2358L31.025 23.5175L31.3348 23.8747L31.5013 24.0821L31.0224 24.0918L30.7245 24.1138C30.5624 23.889 30.3588 23.6969 30.1712 23.4939C29.9216 23.2239 29.6829 22.9477 29.4255 22.6843L29.4275 19.9144L29.5217 19.8493Z"
          fill="url(#paint19_linear_11_402)"
        />
        <path
          id="Vector_306"
          d="M29.5217 19.8493L29.6647 19.7469L29.7505 19.8784L29.5217 19.8493Z"
          fill="#E2D4CA"
        />
        <path
          id="Vector_307"
          d="M31.025 23.5175L31.3347 23.8747L31.5013 24.0821L31.0224 24.0918C31.0123 23.894 30.9936 23.7157 31.025 23.5175Z"
          fill="#5D5670"
        />
        <path
          id="Vector_308"
          d="M30.8726 20.1275C30.9984 20.121 31.12 20.105 31.2466 20.108C31.5429 20.115 31.8008 20.1974 32.0531 20.3495C32.0178 20.4326 31.9822 20.5156 31.9448 20.5978C31.9245 20.6424 31.8912 20.6983 31.8829 20.7466C31.8603 20.8782 31.8789 21.0291 31.8694 21.1642L31.7536 21.0151C31.6051 20.8047 31.3802 20.6958 31.131 20.6548C31.0021 20.6335 30.858 20.6354 30.7319 20.67L30.7043 20.6773C30.4357 20.7506 30.2334 20.9334 30.0975 21.1729C29.9749 21.389 29.9223 21.6958 29.9918 21.9373C30.0755 22.2286 30.27 22.4376 30.5342 22.5777L30.572 22.5972C30.5763 22.7117 30.5849 22.8095 30.6198 22.9188L30.6272 22.9424C30.6563 23.0328 30.7035 23.1226 30.7537 23.2028C30.612 23.1407 30.4677 23.0552 30.3393 22.9688C29.968 22.7187 29.7003 22.3635 29.6153 21.9176C29.5356 21.4991 29.6279 21.1461 29.8652 20.797C30.0061 20.6364 30.1792 20.5048 30.3424 20.3677L30.3528 20.3615L30.3704 20.3515C30.527 20.2606 30.7065 20.2008 30.8726 20.1275Z"
          fill="#ED3131"
        />
        <path
          id="Vector_309"
          d="M32.9298 16.5485L32.9722 16.57C33.0272 16.566 33.0891 16.5648 33.1415 16.5472C33.2475 16.5118 33.3454 16.4461 33.4531 16.4074L32.5506 18.3074L32.5257 18.3581L31.6483 18.3757L31.6157 18.5128C31.5471 18.3701 31.471 18.2481 31.377 18.1207C31.3958 18.0686 31.3878 18.0014 31.3871 17.9463C31.3859 17.8435 31.3828 17.7423 31.3946 17.6399L31.3964 17.3044C31.43 17.1999 31.4761 17.0899 31.5367 16.9983L31.549 16.98C31.6866 16.7705 31.9148 16.6065 32.1604 16.5527C32.3081 16.5204 32.8122 16.4717 32.9298 16.5485Z"
          fill="url(#paint20_linear_11_402)"
        />
        <path
          id="Vector_310"
          d="M31.6612 18.3321L32.5506 18.3074L32.5257 18.3581L31.6483 18.3757L31.6612 18.3321Z"
          fill="#473250"
        />
        <path
          id="Vector_311"
          d="M32.14 17.5847C32.0825 17.661 31.9987 17.7827 31.905 17.802C31.8768 17.7818 31.8495 17.7629 31.8293 17.7342C31.761 17.6369 31.7531 17.426 31.7808 17.3119L31.7886 17.2827C31.8135 17.1829 31.8651 17.1185 31.9387 17.0494C32.1234 16.8759 32.5179 16.8716 32.7561 16.8812C32.7337 16.9359 32.7012 16.9832 32.669 17.0324C32.5826 17.0677 32.5235 17.1548 32.4633 17.2241L32.2506 17.4487L32.167 17.544L32.14 17.5847Z"
          fill="#5D5670"
        />
        <path
          id="Vector_312"
          d="M32.14 17.5847C32.0744 17.5627 32.0272 17.4975 31.9807 17.4481L31.9819 17.4265C32.0204 17.4155 32.0423 17.4155 32.0791 17.4337C32.1395 17.4637 32.1482 17.4841 32.167 17.544L32.14 17.5847Z"
          fill="#56334E"
        />
        <path
          id="Vector_313"
          d="M32.2506 17.4487C32.2492 17.4139 32.2525 17.3915 32.2632 17.3584C32.2985 17.2499 32.2589 17.0546 32.3079 16.9724C32.3525 16.9619 32.3698 16.9648 32.4121 16.982C32.4207 16.9916 32.4548 17.0231 32.4574 17.033C32.4687 17.0757 32.4534 17.1486 32.4595 17.1967L32.4633 17.2241L32.2506 17.4487Z"
          fill="#56334E"
        />
        <path
          id="Vector_314"
          d="M31.3964 17.3044C31.4301 17.1999 31.4761 17.0899 31.5367 16.9983L31.549 16.98C31.6866 16.7705 31.9148 16.6065 32.1604 16.5527C32.3081 16.5204 32.8122 16.4717 32.9298 16.5485L32.8518 16.6907C32.683 16.6999 32.5107 16.7025 32.344 16.732C32.0914 16.7767 31.8651 16.8743 31.7133 17.0912C31.5937 17.262 31.5696 17.4465 31.6084 17.6469C31.629 17.7535 31.682 17.8509 31.7372 17.9431C31.7341 18.0427 31.7298 18.1314 31.7003 18.2272C31.6902 18.2639 31.6825 18.2999 31.6612 18.3321L31.6483 18.3757L31.6157 18.5129C31.5471 18.3701 31.471 18.2481 31.377 18.1207C31.3958 18.0687 31.3878 18.0014 31.3871 17.9463C31.3859 17.8435 31.3828 17.7423 31.3946 17.6399L31.3964 17.3044Z"
          fill="#9D9BA7"
        />
        <path
          id="Vector_315"
          d="M31.3946 17.6399C31.4577 17.7934 31.5117 18.018 31.6384 18.1337C31.6679 18.1607 31.6824 18.1922 31.7003 18.2272C31.6902 18.2639 31.6825 18.2999 31.6612 18.332L31.6483 18.3757L31.6157 18.5128C31.5471 18.3701 31.471 18.2481 31.377 18.1207C31.3958 18.0686 31.3878 18.0014 31.3871 17.9463C31.3859 17.8435 31.3828 17.7423 31.3946 17.6399Z"
          fill="#797388"
        />
        <path
          id="Vector_316"
          d="M31.8529 24.4682L31.8648 24.4673L31.8546 25.6792C31.7759 25.7275 31.7098 25.786 31.6409 25.8469L31.6391 25.86L28.4539 29.1616L28.4392 29.1384L28.446 28.8642L30.6441 26.5815L30.6485 24.4716L31.4676 24.4665L31.582 24.4694L31.8529 24.4682Z"
          fill="url(#paint21_linear_11_402)"
        />
        <path
          id="Vector_317"
          d="M31.4676 24.4665L31.582 24.4694C31.5824 24.6488 31.5956 24.8236 31.607 25.0025C31.6133 25.1013 31.6386 25.2213 31.5937 25.3118C31.5592 25.1983 31.5553 25.0733 31.5388 24.9563C31.5157 24.7928 31.488 24.6305 31.4676 24.4665Z"
          fill="#56334E"
        />
        <path
          id="Vector_318"
          d="M31.8529 24.4682L31.8648 24.4673L31.8545 25.6792C31.7759 25.7275 31.7098 25.786 31.6409 25.8469L31.5937 25.3118C31.6386 25.2213 31.6133 25.1013 31.607 25.0025C31.5956 24.8236 31.5825 24.6488 31.582 24.4694L31.8529 24.4682Z"
          fill="#473250"
        />
        <path
          id="Vector_319"
          d="M30.572 22.5972L30.5342 22.5777C30.2699 22.4376 30.0755 22.2286 29.9917 21.9373C29.9223 21.6958 29.9748 21.3889 30.0975 21.1729C30.2334 20.9334 30.4356 20.7506 30.7043 20.6773L30.7319 20.67C30.858 20.6354 31.002 20.6335 31.131 20.6548C31.3802 20.6958 31.6051 20.8047 31.7535 21.0151L31.8693 21.1642L31.8743 21.1956L31.861 21.2086L31.8436 21.2316C31.7842 21.2453 31.7846 21.2643 31.7526 21.3142C31.77 21.3704 31.7877 21.4241 31.8095 21.4786C31.8272 21.5226 31.8193 21.5628 31.8086 21.6076L31.8127 21.6317L31.8361 21.6572L31.8188 21.7254L31.8388 21.7556C31.8338 21.7752 31.83 21.79 31.8204 21.8079L31.8287 21.8295C31.8382 21.873 31.8381 21.9005 31.8382 21.9448L31.8402 21.9661C31.8418 22.0063 31.8256 22.0432 31.8173 22.0819C31.7857 22.2304 31.6132 22.4149 31.4925 22.4983L31.4572 22.5189C31.2569 22.6399 30.9882 22.7175 30.7538 22.6566L30.7168 22.6452L30.572 22.5972Z"
          fill="#FBFAFB"
        />
        <path
          id="Vector_320"
          d="M30.8847 21.8366C30.9049 21.7877 30.9072 21.7687 30.9514 21.7376C31.0182 21.7486 31.0131 21.7491 31.0501 21.8002C30.995 21.8173 30.9416 21.8275 30.8847 21.8366Z"
          fill="#1B347B"
        />
        <path
          id="Vector_321"
          d="M30.3823 21.1649C30.4146 21.1778 30.4387 21.1965 30.4519 21.2304C30.4713 21.2806 30.4404 21.307 30.4149 21.3466C30.3847 21.3325 30.3682 21.3118 30.346 21.2877C30.3377 21.2281 30.3534 21.2161 30.3823 21.1649Z"
          fill="#47667E"
        />
        <path
          id="Vector_322"
          d="M30.4716 21.3149C30.4964 21.3279 30.5177 21.3453 30.5401 21.3621C30.5546 21.416 30.5343 21.4467 30.5165 21.4988C30.4724 21.4801 30.4558 21.4766 30.426 21.4377C30.4277 21.3775 30.4402 21.3646 30.4716 21.3149Z"
          fill="#1B347B"
        />
        <path
          id="Vector_323"
          d="M30.6384 21.2377L30.6292 21.2617C30.608 21.2987 30.5964 21.3056 30.5579 21.3136L30.5131 21.2864C30.4817 21.2567 30.4912 21.2359 30.4973 21.1984C30.5183 21.1849 30.5314 21.1751 30.5571 21.173C30.5835 21.1708 30.6105 21.2088 30.6294 21.2269L30.6384 21.2377Z"
          fill="#1B347B"
        />
        <path
          id="Vector_324"
          d="M30.8847 21.8366C30.9416 21.8275 30.995 21.8173 31.0501 21.8002C31.044 21.8418 31.0397 21.884 31.0271 21.9242C30.9806 21.9334 30.9498 21.9398 30.903 21.925C30.886 21.8906 30.8785 21.8751 30.8847 21.8366Z"
          fill="#47667E"
        />
        <path
          id="Vector_325"
          d="M30.6294 21.2269L30.6157 21.1501C30.6408 21.1207 30.674 21.1121 30.7092 21.099C30.7371 21.1284 30.7491 21.1531 30.7455 21.1956C30.7435 21.2188 30.7327 21.244 30.7243 21.2657C30.6826 21.2736 30.6738 21.2593 30.6384 21.2377L30.6294 21.2269Z"
          fill="#1B347B"
        />
        <path
          id="Vector_326"
          d="M30.9196 21.0569C30.9539 21.064 30.9793 21.0734 31.0104 21.0896C31.0305 21.1429 31.0231 21.1866 31.017 21.2423L30.9312 21.2298C30.8992 21.1776 30.9155 21.1171 30.9196 21.0569Z"
          fill="#1B347B"
        />
        <path
          id="Vector_327"
          d="M31.3576 21.1464C31.3359 21.1228 31.3181 21.1039 31.3051 21.0745C31.3169 21.0331 31.3261 21.0141 31.3568 20.9836L31.3904 20.991C31.4249 21.0052 31.4488 21.033 31.4619 21.0669L31.4306 21.1338L31.3857 21.1564L31.3576 21.1464Z"
          fill="#1B347B"
        />
        <path
          id="Vector_328"
          d="M30.0624 21.5158L30.1275 21.5437C30.1403 21.597 30.1442 21.6404 30.1402 21.6951C30.1062 21.7145 30.075 21.7196 30.0371 21.7262C30.0328 21.6589 30.0266 21.5743 30.0624 21.5158Z"
          fill="#0F1758"
        />
        <path
          id="Vector_329"
          d="M31.2455 21.139C31.2882 21.1318 31.3061 21.1387 31.345 21.1538L31.3496 21.1705C31.361 21.2232 31.358 21.2562 31.3299 21.3008C31.2895 21.3086 31.2845 21.3096 31.2466 21.2945C31.2111 21.2396 31.2331 21.2002 31.2455 21.139Z"
          fill="#1B347B"
        />
        <path
          id="Vector_330"
          d="M31.1751 21.3149C31.2105 21.3207 31.2393 21.3312 31.2725 21.344C31.313 21.4026 31.3047 21.4166 31.3012 21.4857C31.2589 21.4894 31.2251 21.4959 31.1861 21.4748C31.162 21.4276 31.1735 21.3678 31.1751 21.3149Z"
          fill="#1B347B"
        />
        <path
          id="Vector_331"
          d="M30.6431 21.314L30.7092 21.3385C30.7158 21.3545 30.7258 21.3746 30.7273 21.3923C30.7312 21.4381 30.7149 21.4569 30.6846 21.4873C30.6401 21.4802 30.6065 21.483 30.5727 21.4522C30.5813 21.3735 30.5871 21.3709 30.6431 21.314Z"
          fill="#1B347B"
        />
        <path
          id="Vector_332"
          d="M30.7372 21.9676C30.7961 21.9736 30.8066 21.9652 30.8454 22.0127C30.8529 22.0649 30.8564 22.091 30.8302 22.1378C30.784 22.1335 30.7526 22.1316 30.7133 22.1038C30.6975 22.0439 30.7149 22.0241 30.7372 21.9676Z"
          fill="#1B347B"
        />
        <path
          id="Vector_333"
          d="M31.4327 20.838L31.4522 20.8451C31.4986 20.8631 31.5578 20.8991 31.5776 20.9458L31.5153 21.0223C31.4712 21.0136 31.4159 20.9745 31.3904 20.9384L31.4327 20.838Z"
          fill="#1B347B"
        />
        <path
          id="Vector_334"
          d="M30.2842 21.3192C30.3282 21.3403 30.3643 21.355 30.3845 21.3999C30.3777 21.4506 30.3648 21.469 30.3348 21.5082C30.2924 21.4926 30.249 21.4773 30.2109 21.4529C30.2286 21.4028 30.2548 21.3632 30.2842 21.3192Z"
          fill="#1B347B"
        />
        <path
          id="Vector_335"
          d="M31.1128 21.0064C31.1628 20.9676 31.1442 20.9261 31.1936 20.9037C31.2404 20.92 31.263 20.9227 31.2958 20.9609C31.2874 21.0148 31.2731 21.0476 31.2452 21.0941L31.1255 21.0303L31.0952 21.0511L31.0819 21.029L31.1128 21.0064Z"
          fill="#1B347B"
        />
        <path
          id="Vector_336"
          d="M30.5679 21.9526C30.6262 21.9619 30.6289 21.9574 30.6688 22.0054C30.6755 22.0759 30.6709 22.1103 30.6333 22.1708C30.5887 22.1432 30.5596 22.1161 30.5253 22.0765C30.5207 22.0242 30.5422 21.9954 30.5679 21.9526Z"
          fill="#1B347B"
        />
        <path
          id="Vector_337"
          d="M31.0791 20.985C31.0243 21.0192 31.0202 21.0135 30.959 21.0055C30.9149 20.9663 30.9198 20.9421 30.9094 20.8853C30.9407 20.8551 31.0036 20.8607 31.0476 20.8572L31.0939 20.9004L31.0791 20.985Z"
          fill="#1B347B"
        />
        <path
          id="Vector_338"
          d="M31.0419 21.5195C31.0846 21.5215 31.1142 21.5162 31.1509 21.5399C31.1637 21.6169 31.1629 21.6339 31.1365 21.7072C31.1061 21.705 31.0785 21.7043 31.0496 21.694C31.0302 21.6871 31.0236 21.6769 31.0165 21.6572C30.9976 21.6046 31.0219 21.5665 31.0419 21.5195Z"
          fill="#1B347B"
        />
        <path
          id="Vector_339"
          d="M30.8452 21.5122C30.8954 21.5194 30.9255 21.5143 30.9616 21.5513C30.9726 21.6096 30.9682 21.6387 30.948 21.6942L30.8421 21.6981L30.8223 21.6648C30.8163 21.6049 30.8232 21.5679 30.8452 21.5122Z"
          fill="#47667E"
        />
        <path
          id="Vector_340"
          d="M31.2054 22.231C31.2251 22.2325 31.2295 22.2423 31.2437 22.2551C31.2533 22.2962 31.2667 22.334 31.2542 22.3756L31.1574 22.415C31.131 22.4105 31.1244 22.4084 31.1028 22.3954L31.099 22.2854C31.1268 22.2449 31.1594 22.2451 31.2054 22.231Z"
          fill="#0F1758"
        />
        <path
          id="Vector_341"
          d="M31.3715 21.328L31.4736 21.3374C31.5259 21.379 31.522 21.3972 31.5375 21.4604L31.5161 21.4848C31.457 21.4948 31.4285 21.5109 31.3753 21.4807C31.3565 21.4222 31.3598 21.3879 31.3715 21.328Z"
          fill="#1B347B"
        />
        <path
          id="Vector_342"
          d="M30.4957 22.116C30.5424 22.1292 30.5716 22.1717 30.6033 22.2063C30.6189 22.2556 30.598 22.3092 30.5857 22.3578C30.5327 22.3335 30.4818 22.3147 30.4424 22.2703C30.4383 22.2105 30.4683 22.1671 30.4957 22.116Z"
          fill="#0F1758"
        />
        <path
          id="Vector_343"
          d="M30.9128 21.9659L30.956 21.9928C30.959 22.0236 30.9611 22.0459 30.9758 22.0735C31.006 22.0573 30.9879 22.0076 31.0271 21.9758L31.0683 21.9827L31.115 22.0491C31.1067 22.0793 31.0964 22.1057 31.0832 22.134L31.0498 22.1452C30.9987 22.1361 30.9554 22.1287 30.9095 22.1038C30.8862 22.0458 30.8989 22.0255 30.9128 21.9659Z"
          fill="#0F1758"
        />
        <path
          id="Vector_344"
          d="M31.8127 21.6317C31.8104 21.6721 31.8098 21.6737 31.7839 21.7048C31.7391 21.7041 31.6958 21.71 31.6592 21.6799L31.6529 21.5513L31.6998 21.5L31.789 21.5198L31.8086 21.6076L31.8127 21.6317Z"
          fill="#0F1758"
        />
        <path
          id="Vector_345"
          d="M30.3795 21.5012C30.438 21.5063 30.4726 21.5115 30.5149 21.5539C30.5251 21.615 30.5251 21.6415 30.4969 21.6973C30.4637 21.7027 30.4354 21.7084 30.4019 21.7008C30.3819 21.6963 30.3829 21.6981 30.3737 21.6807C30.3404 21.6182 30.358 21.5642 30.3795 21.5012Z"
          fill="#1B347B"
        />
        <path
          id="Vector_346"
          d="M30.6851 21.741L30.7611 21.7556C30.7757 21.7819 30.7881 21.8055 30.8079 21.8283L30.8203 21.8415C30.8206 21.8612 30.8209 21.8753 30.8283 21.8941L30.8341 21.907L30.8048 21.932C30.7591 21.9419 30.7229 21.9427 30.6765 21.9392L30.6459 21.8983C30.6384 21.8363 30.6598 21.7968 30.6851 21.741Z"
          fill="#0F1758"
        />
        <path
          id="Vector_347"
          d="M31.3352 22.0792C31.3117 22.1086 31.2919 22.1356 31.2554 22.1491C31.2185 22.1629 31.1932 22.1387 31.1592 22.1222C31.1346 22.0754 31.1476 22.0491 31.1555 21.9978C31.1966 21.9625 31.1994 21.9649 31.2541 21.9626C31.3077 21.9976 31.3103 22.0162 31.3358 22.0732L31.3352 22.0792Z"
          fill="#0F1758"
        />
        <path
          id="Vector_348"
          d="M30.5235 21.71C30.5368 21.7196 30.5578 21.7328 30.5679 21.7465C30.5909 21.7778 30.6057 21.8225 30.598 21.8616C30.5875 21.9152 30.5509 21.9292 30.5101 21.9572L30.4674 21.9218C30.4334 21.8877 30.4323 21.8611 30.4294 21.8162C30.4448 21.7631 30.4817 21.7417 30.5235 21.71Z"
          fill="#1B347B"
        />
        <path
          id="Vector_349"
          d="M31.2493 21.7465C31.2942 21.7458 31.3401 21.7391 31.38 21.7632C31.3975 21.8277 31.3936 21.88 31.3862 21.9459L31.3147 21.9426C31.2715 21.937 31.2624 21.9308 31.2372 21.8958C31.2292 21.8396 31.2338 21.801 31.2493 21.7465Z"
          fill="#0F1758"
        />
        <path
          id="Vector_350"
          d="M31.3416 22.1312L31.3598 22.1206L31.459 22.2173C31.4588 22.2533 31.4659 22.2408 31.4454 22.2612C31.3989 22.3073 31.3683 22.3387 31.2996 22.3389C31.2673 22.2867 31.2586 22.2559 31.2612 22.1946L31.3416 22.1312Z"
          fill="#0F1758"
        />
        <path
          id="Vector_351"
          d="M30.654 22.2429C30.7161 22.278 30.7796 22.2425 30.8382 22.2854L30.8346 22.4234C30.7671 22.4193 30.6703 22.4071 30.6184 22.3612L30.654 22.2429Z"
          fill="#0F1758"
        />
        <path
          id="Vector_352"
          d="M30.8747 22.2632C30.9347 22.2612 30.9989 22.2538 31.0574 22.2686C31.0712 22.3164 31.0629 22.3668 31.0594 22.4158C31.0001 22.4224 30.9259 22.4376 30.8737 22.4094L30.8747 22.2632Z"
          fill="#0F1758"
        />
        <path
          id="Vector_353"
          d="M30.4033 21.9524L30.4438 21.9636C30.488 22.0103 30.4859 22.0132 30.4919 22.0735C30.4714 22.1105 30.4435 22.129 30.4102 22.1535L30.3954 22.1643C30.4086 22.1982 30.4105 22.2235 30.4134 22.2591C30.3569 22.2375 30.3328 22.1909 30.2999 22.1428C30.3268 22.0701 30.3592 22.0153 30.4033 21.9524Z"
          fill="#0F1758"
        />
        <path
          id="Vector_354"
          d="M31.8287 21.8295L31.8095 21.8918C31.7624 21.9294 31.7208 21.9168 31.6629 21.9154L31.6431 21.8918C31.644 21.8388 31.6403 21.789 31.6649 21.7405C31.7151 21.7211 31.7457 21.7076 31.7991 21.7199L31.8205 21.8079L31.8287 21.8295Z"
          fill="#0F1758"
        />
        <path
          id="Vector_355"
          d="M31.2981 21.4997C31.3284 21.5035 31.3449 21.5125 31.3707 21.5286C31.3914 21.5709 31.4062 21.6274 31.3908 21.6739C31.3825 21.6989 31.3505 21.7038 31.3281 21.7139C31.2885 21.7125 31.2592 21.7119 31.2217 21.6974C31.2165 21.68 31.2094 21.6607 31.2091 21.6421C31.2079 21.5621 31.2414 21.5485 31.2981 21.4997Z"
          fill="#1B347B"
        />
        <path
          id="Vector_356"
          d="M30.2573 21.7313L30.3308 21.7298C30.3603 21.7569 30.3776 21.7931 30.3889 21.8313C30.3993 21.8668 30.4036 21.8843 30.3838 21.9171L30.268 21.9394C30.2037 21.8916 30.196 21.8282 30.1786 21.7556L30.1946 21.7414L30.2074 21.7906L30.2294 21.8032L30.2573 21.7313Z"
          fill="#0F1758"
        />
        <path
          id="Vector_357"
          d="M31.434 21.7484C31.4884 21.7431 31.5402 21.7449 31.5947 21.7476C31.6262 21.7893 31.609 21.8743 31.6074 21.9274C31.5516 21.9312 31.4991 21.9319 31.4434 21.9267C31.4157 21.88 31.4311 21.8015 31.434 21.7484Z"
          fill="#0F1758"
        />
        <path
          id="Vector_358"
          d="M31.6026 20.9675C31.6827 21.0007 31.752 21.1123 31.7895 21.188C31.7747 21.2065 31.7646 21.2213 31.7546 21.243C31.7406 21.2736 31.7508 21.256 31.7286 21.2871L31.6976 21.2557C31.6738 21.2272 31.6483 21.2011 31.6361 21.1653C31.6593 21.1434 31.6778 21.124 31.6951 21.0972L31.678 21.0834C31.6553 21.107 31.6424 21.1228 31.6098 21.1307L31.5479 21.0745C31.5435 21.027 31.5748 21.0046 31.6026 20.9675Z"
          fill="#1B347B"
        />
        <path
          id="Vector_359"
          d="M31.4981 21.4997C31.5385 21.502 31.5652 21.5013 31.5979 21.5286C31.6291 21.5819 31.6238 21.6272 31.622 21.6875L31.5817 21.7177C31.5286 21.7115 31.4792 21.7158 31.4383 21.6799C31.4347 21.6609 31.4294 21.6391 31.4305 21.6194C31.434 21.5575 31.4565 21.5404 31.4981 21.4997Z"
          fill="#0F1758"
        />
        <path
          id="Vector_360"
          d="M31.5415 22.3656C31.5389 22.3234 31.5193 22.3055 31.4963 22.2712C31.4995 22.2498 31.4996 22.2412 31.5084 22.2194C31.5216 22.1866 31.5546 22.1547 31.5872 22.1427C31.6232 22.1575 31.6535 22.1709 31.6933 22.1651L31.7199 22.1606L31.7547 22.1529C31.7091 22.2284 31.6669 22.2964 31.6064 22.3611L31.5889 22.38L31.5782 22.3912L31.5415 22.3656Z"
          fill="#0F1758"
        />
        <path
          id="Vector_361"
          d="M31.7199 22.1606C31.674 22.1441 31.6231 22.1362 31.5943 22.0962C31.5989 22.0506 31.6169 22.0089 31.6326 21.9661C31.6881 21.9422 31.7505 21.9396 31.8089 21.9524C31.8096 22.0288 31.791 22.086 31.7547 22.1529L31.7199 22.1606Z"
          fill="#0F1758"
        />
        <path
          id="Vector_362"
          d="M30.7901 20.8709L30.8667 20.8748C30.8542 20.9342 30.8623 20.97 30.8228 21.0184L30.7471 21.0234C30.722 21.0005 30.7029 20.9771 30.6817 20.9509L30.6567 20.9685L30.672 21.0424L30.68 21.0591C30.6521 21.0833 30.6485 21.0929 30.6109 21.0994C30.5892 21.0679 30.5752 21.0335 30.5599 20.9988C30.6091 20.926 30.7115 20.9007 30.7901 20.8709Z"
          fill="#1B347B"
        />
        <path
          id="Vector_363"
          d="M30.6035 22.4023C30.6619 22.4163 30.7624 22.4243 30.7956 22.4746L30.7881 22.627C30.7064 22.6158 30.6391 22.5937 30.5655 22.5573L30.6035 22.4023Z"
          fill="#0F1758"
        />
        <path
          id="Vector_364"
          d="M31.3358 22.0732L31.3828 21.9922C31.4488 21.9551 31.502 21.9559 31.5758 21.9651C31.5899 22.0009 31.5839 22.0361 31.5812 22.0735C31.5526 22.1205 31.5272 22.146 31.4812 22.1761L31.399 22.1147L31.3598 22.1206L31.3416 22.1312L31.3352 22.0791L31.3358 22.0732Z"
          fill="#1B347B"
        />
        <path
          id="Vector_365"
          d="M30.0342 21.7404L30.1265 21.7483C30.1441 21.7766 30.1508 21.7762 30.1469 21.8108L30.1433 21.8644C30.1772 21.8813 30.1838 21.8818 30.2017 21.9145C30.1766 21.9429 30.1291 21.9515 30.1189 21.9701C30.1481 21.9855 30.1667 21.983 30.199 21.9804C30.2281 22.0113 30.2437 22.0361 30.2621 22.0735L30.212 22.1189L30.2361 22.144L30.2022 22.1884L30.1756 22.1946C30.0857 22.0708 30.0405 21.8917 30.0342 21.7404Z"
          fill="#0F1758"
        />
        <path
          id="Vector_366"
          d="M30.236 22.144L30.3459 22.2492C30.3679 22.2693 30.3753 22.2778 30.3846 22.3053C30.4661 22.3103 30.4996 22.3513 30.5663 22.3938L30.5414 22.5507C30.4201 22.4626 30.2643 22.363 30.1963 22.2249L30.2248 22.211L30.2022 22.1884L30.236 22.144Z"
          fill="#1B347B"
        />
        <path
          id="Vector_367"
          d="M31.4379 21.1385C31.4788 21.1322 31.5119 21.1174 31.5479 21.1448C31.6598 21.2299 31.7628 21.3834 31.789 21.5198L31.6999 21.5L31.6916 21.4832L31.6326 21.5L31.5928 21.468C31.5764 21.4234 31.5705 21.3944 31.5702 21.3469L31.6326 21.2869L31.6175 21.2647C31.582 21.2739 31.5627 21.2918 31.5342 21.3136L31.4661 21.3022C31.4118 21.2573 31.4025 21.2613 31.3947 21.188L31.4379 21.1385Z"
          fill="#0F1758"
        />
        <path
          id="Vector_368"
          d="M30.4048 20.9207C30.4247 20.9488 30.4452 20.9749 30.4593 21.0064C30.4262 21.056 30.3986 21.1063 30.346 21.1374L30.2854 21.1231L30.2785 21.1371L30.3209 21.1804C30.2973 21.2573 30.2364 21.3328 30.1946 21.4039L30.1467 21.3923L30.1756 21.4529C30.1682 21.4718 30.1672 21.4918 30.1472 21.5003C30.1193 21.5121 30.0912 21.5083 30.0616 21.5075L30.0539 21.468C30.128 21.2364 30.2253 21.0868 30.4048 20.9207Z"
          fill="#1B347B"
        />
        <path
          id="Vector_369"
          d="M31.2823 22.4076C31.3393 22.3701 31.4075 22.3124 31.4736 22.296L31.5415 22.3656L31.5781 22.3912L31.4421 22.5028C31.3211 22.566 31.2177 22.6151 31.0801 22.6259C31.0314 22.6297 31.0088 22.6463 30.9566 22.6336L30.9363 22.593C30.9275 22.6123 30.9277 22.6261 30.9063 22.6342C30.8755 22.6457 30.8496 22.638 30.8181 22.6331C30.8198 22.5719 30.808 22.5082 30.8454 22.4589L31.0814 22.4578L31.0871 22.6033C31.1116 22.572 31.0937 22.5013 31.1064 22.4576C31.1489 22.4371 31.1932 22.4293 31.239 22.4196C31.2699 22.4488 31.282 22.4933 31.2977 22.532L31.3142 22.5276L31.2823 22.4076Z"
          fill="#0F1758"
        />
        <path
          id="Vector_370"
          d="M28.4392 29.1384L28.4539 29.1616L31.6391 25.86C31.6469 26.5863 31.6425 27.313 31.6434 28.0394C31.6438 28.3763 31.6183 28.739 31.6502 29.0727C31.6533 29.1042 31.6612 29.1234 31.6768 29.1503L28.432 32.4564L28.4273 31.3565L28.4225 31.2645C28.4287 31.2145 28.4245 31.1622 28.4234 31.1117L28.436 31.0387C28.4306 30.947 28.4422 30.8951 28.3837 30.8225L28.4085 30.7968L28.455 30.8278C28.4349 30.7916 28.419 30.7671 28.4219 30.724L28.4288 29.1892C28.4281 29.1701 28.4336 29.1565 28.4392 29.1384Z"
          fill="#473250"
        />
        <path
          id="Vector_371"
          d="M28.4219 30.724L28.4993 30.6564C28.5496 30.6762 28.5975 30.743 28.6346 30.7826C28.5947 30.8307 28.5507 30.8987 28.4955 30.9285C28.4722 30.8962 28.458 30.868 28.4549 30.8278C28.4349 30.7916 28.419 30.7671 28.4219 30.724Z"
          fill="#F3B275"
        />
        <path
          id="Vector_372"
          d="M28.7535 30.3302L28.9316 30.5021L28.8073 30.6228C28.7423 30.5818 28.6929 30.5206 28.641 30.4645L28.7535 30.3302Z"
          fill="#FFBF14"
        />
        <path
          id="Vector_373"
          d="M29.0644 30.039C29.1251 30.059 29.1943 30.1491 29.2412 30.1954C29.1912 30.2312 29.1471 30.275 29.1019 30.3166C29.049 30.2581 28.988 30.2098 28.9273 30.1599L29.0644 30.039Z"
          fill="#FFBF14"
        />
        <path
          id="Vector_374"
          d="M30.3653 28.7092C30.4204 28.7768 30.4896 28.8334 30.5541 28.8919L30.4291 29.0166L30.2354 28.8341L30.3653 28.7092Z"
          fill="#FFBF14"
        />
        <path
          id="Vector_375"
          d="M29.7118 29.3625L29.9013 29.5512L29.7764 29.6683C29.7174 29.6384 29.6406 29.5386 29.592 29.4889L29.7118 29.3625Z"
          fill="#FFBF14"
        />
        <path
          id="Vector_376"
          d="M30.6857 28.377L30.8649 28.5817L30.7425 28.7015C30.6786 28.6533 30.6195 28.57 30.566 28.5089L30.6857 28.377Z"
          fill="#FFBF14"
        />
        <path
          id="Vector_377"
          d="M31.0005 28.0556C31.0682 28.1043 31.1314 28.1852 31.1904 28.2456L31.0761 28.3805L30.8707 28.175L31.0005 28.0556Z"
          fill="#FFBF14"
        />
        <path
          id="Vector_378"
          d="M30.0498 29.0416C30.1091 29.0802 30.1725 29.1738 30.221 29.2287L30.0904 29.3633L29.897 29.1734L30.0498 29.0416Z"
          fill="#FFBF14"
        />
        <path
          id="Vector_379"
          d="M29.3942 29.6794L29.59 29.8775L29.4496 30.0014L29.256 29.8153L29.3942 29.6794Z"
          fill="#FFBF14"
        />
        <path
          id="Vector_380"
          d="M33.2101 37.8342L33.2231 37.8399L34.4652 39.8973L34.1475 39.8988C34.0154 39.6286 33.8286 39.3806 33.6647 39.1294C33.3853 38.7012 33.1046 38.2733 32.8389 37.8364L33.2101 37.8342Z"
          fill="#473250"
        />
        <path
          id="Vector_381"
          d="M32.7784 33.6633C32.7308 33.6615 32.6669 33.6709 32.6328 33.6379C32.6421 33.3241 32.6101 30.8148 32.6467 30.7523L32.7254 30.7493L33.083 30.7584L33.0622 33.4062L32.7773 33.4155L32.7784 33.6633Z"
          fill="#FBFAFB"
        />
        <path
          id="Vector_382"
          d="M34.3371 37.8454L34.3445 37.8507L34.883 39.9007L34.8721 39.9147C34.7728 39.9145 34.5469 39.9418 34.4652 39.8973L33.2231 37.8399L34.3371 37.8454Z"
          fill="#8E8796"
        />
        <path
          id="Vector_383"
          d="M32.5914 36.7643C32.9296 36.765 33.2678 36.7656 33.606 36.7665C33.7721 36.7669 33.9552 36.752 34.1192 36.775L34.1295 36.7778L34.257 36.7789L34.2543 37.2927L34.2159 37.3013L34.3371 37.8454L33.2231 37.8399L33.2101 37.8342L32.8389 37.8364C32.7507 37.6932 32.5908 37.4774 32.5861 37.3076L32.5914 36.7643Z"
          fill="#ED3131"
        />
        <path
          id="Vector_384"
          d="M34.1295 36.7778L34.257 36.7789L34.2543 37.2927L34.2159 37.3013L34.1237 37.303L34.1295 36.7778Z"
          fill="#420D27"
        />
        <path
          id="Vector_385"
          d="M32.5914 36.7643C32.9296 36.765 33.2678 36.7656 33.606 36.7665C33.7721 36.7669 33.9552 36.752 34.1192 36.775L32.879 36.7743C32.8833 36.9338 32.9078 37.1299 32.8826 37.2859C32.8308 37.3029 32.7764 37.3017 32.7224 37.3037L32.5861 37.3076L32.5914 36.7643Z"
          fill="#F56D3B"
        />
        <path
          id="Vector_386"
          d="M34.1237 37.303L34.2159 37.3013L34.3371 37.8453L33.2231 37.8399L33.2101 37.8342L32.8389 37.8364C32.7507 37.6932 32.5908 37.4774 32.5861 37.3076L32.7224 37.3037L32.8853 37.3055L34.1237 37.303Z"
          fill="#473250"
        />
        <path
          id="Vector_387"
          d="M32.7224 37.3037L32.8853 37.3055L33.2101 37.8342L32.8389 37.8364C32.7507 37.6932 32.5908 37.4774 32.5861 37.3076L32.7224 37.3037Z"
          fill="#1B1536"
        />
        <path
          id="Vector_388"
          d="M32.7239 30.741C32.9252 30.7412 33.1646 30.7674 33.3612 30.7357L33.4217 30.762L33.4313 31.6896C33.5017 31.6516 33.6814 31.6666 33.7663 31.6637L34.2139 32.2294L34.1973 33.3883C34.1182 33.3681 34.0472 33.3841 33.9686 33.3975C33.6746 33.4319 33.3593 33.4011 33.0622 33.4062L33.083 30.7584L32.7254 30.7493L32.7239 30.741Z"
          fill="#ECE7E0"
        />
        <path
          id="Vector_389"
          d="M33.7663 31.6637L34.2138 32.2294L34.1973 33.3883C34.1181 33.3681 34.0472 33.3841 33.9686 33.3975L33.9681 32.408C33.7769 32.1982 33.5487 31.9481 33.4313 31.6896C33.5016 31.6516 33.6813 31.6666 33.7663 31.6637Z"
          fill="#ED3131"
        />
        <path
          id="Vector_390"
          d="M33.9912 27.7309C34.0346 27.8064 34.0068 28.0722 34.0069 28.1671C34.0076 28.6845 34.0069 29.2018 34.0067 29.7192C34.0066 29.9795 34.0065 30.2399 34.0062 30.5003C34.0058 30.7806 33.9846 31.1379 34.088 31.3997C34.1708 31.6093 34.2873 31.781 34.4509 31.9361C34.5062 31.9884 34.5792 32.0404 34.624 32.1013C34.8049 31.9735 34.9711 31.7954 35.1358 31.6462L35.139 32.2105C35.4031 32.209 35.6516 32.2029 35.9111 32.1469C35.9061 32.2819 35.908 32.417 35.9087 32.552C35.9089 32.5962 35.8995 32.6644 35.9188 32.7039C35.9199 33.2164 35.922 33.7289 35.9221 34.2413C35.9222 34.424 35.9214 34.6066 35.9218 34.7893C35.922 34.8975 35.9093 35.018 35.9474 35.12C36.0597 35.4216 36.1176 35.7493 36.1975 36.0612L36.2093 36.0894C36.2602 36.214 36.298 36.3393 36.3552 36.4624C36.4048 36.5691 36.4716 36.6696 36.5126 36.7792L35.6183 36.7785L35.1229 36.7783L35.0068 36.7795L34.257 36.7789L34.1295 36.7778L34.1192 36.775C33.9552 36.752 33.772 36.7669 33.606 36.7665C33.2678 36.7656 32.9296 36.7649 32.5914 36.7643L32.5924 36.5328C32.6083 35.7999 32.6147 35.0662 32.6206 34.3332C32.6219 34.1752 32.6224 34.0173 32.6229 33.8593C32.6231 33.8229 32.6129 33.7367 32.6234 33.7061C32.6274 33.6942 32.639 33.6864 32.6467 33.6765L32.7777 33.6769L32.7784 33.6633L32.7774 33.4155L33.0622 33.4062C33.3593 33.4011 33.6746 33.4319 33.9686 33.3975C34.0472 33.3841 34.1182 33.3681 34.1973 33.3883L34.2139 32.2294L33.7663 31.6637C33.7367 31.5356 33.7442 31.407 33.7437 31.2763C33.743 31.065 33.7429 30.8538 33.743 30.6425C33.8313 30.6319 33.9075 30.6135 33.9922 30.5856L33.9912 27.7309Z"
          fill="#ECE7E0"
        />
        <path
          id="Vector_391"
          d="M35.1174 35.7044L35.8408 35.7037L35.7452 35.7268L35.7393 35.7573L35.6053 35.7667L35.0817 35.7672L35.0228 35.7334C34.9688 35.7598 34.9635 35.7663 34.9326 35.8181L34.882 35.8388C34.8389 35.8204 34.8086 35.8033 34.7733 35.7722L34.7848 35.721L34.7949 35.7052L35.1174 35.7044Z"
          fill="#C7A7A3"
        />
        <path
          id="Vector_392"
          d="M34.7848 35.721C34.8328 35.7214 34.9895 35.7093 35.0228 35.7334C34.9688 35.7598 34.9635 35.7663 34.9326 35.8181L34.882 35.8388C34.8389 35.8204 34.8086 35.8033 34.7733 35.7722L34.7848 35.721Z"
          fill="#B1969E"
        />
        <path
          id="Vector_393"
          d="M35.8408 35.7037L36.0772 35.7026L36.0711 35.9089L36.1009 36.188C36.0565 36.2099 36.0266 36.2025 35.9777 36.2002L35.964 36.1964L35.9501 36.1091L35.937 35.7758C35.8298 35.7874 35.7127 35.7769 35.6053 35.7667L35.7393 35.7573L35.7451 35.7268L35.8408 35.7037Z"
          fill="#A99D9F"
        />
        <path
          id="Vector_394"
          d="M35.937 35.7758L35.9693 35.7685L36.0052 35.7925C36.0047 35.9216 36.0159 36.0774 35.9777 36.2002L35.964 36.1964L35.9501 36.1091L35.937 35.7758Z"
          fill="#FBFAFB"
        />
        <path
          id="Vector_395"
          d="M34.9326 35.8181C34.9635 35.7663 34.9688 35.7598 35.0227 35.7334L35.0817 35.7672L35.6053 35.7667C35.7126 35.7769 35.8298 35.7874 35.937 35.7758L35.9501 36.1091C35.9475 36.1415 35.9436 36.1657 35.9314 36.1958C35.7256 36.2033 35.5189 36.2021 35.313 36.2031C35.2513 36.2035 35.1317 36.2194 35.0798 36.1885L35.0766 36.0848C35.0115 35.9961 34.9814 35.9143 34.9326 35.8181Z"
          fill="#250C28"
        />
        <path
          id="Vector_396"
          d="M34.9326 35.8181C34.9635 35.7663 34.9688 35.7598 35.0227 35.7334L35.0817 35.7672L35.0766 36.0848C35.0115 35.9961 34.9814 35.9143 34.9326 35.8181Z"
          fill="#ECE7E0"
        />
        <path
          id="Vector_397"
          d="M36.0711 35.9088L36.128 36.0195C36.1298 35.9894 36.1327 35.9879 36.1185 35.9597C36.0882 35.8996 36.0839 35.8182 36.1017 35.7533L36.1168 35.8306C36.1203 35.8481 36.1259 35.8615 36.1319 35.8781C36.1523 35.9345 36.152 36.0238 36.1975 36.0612L36.2092 36.0894C36.2602 36.214 36.2979 36.3393 36.3552 36.4624C36.4048 36.569 36.4716 36.6696 36.5125 36.7792L35.6183 36.7785L35.1228 36.7783L35.0068 36.7794C34.9234 36.4991 34.9169 36.154 34.9083 35.863L34.882 35.8388L34.9326 35.8181C34.9814 35.9143 35.0115 35.9961 35.0766 36.0848L35.0798 36.1885C35.1317 36.2194 35.2513 36.2035 35.313 36.2031C35.5189 36.2021 35.7256 36.2033 35.9314 36.1958C35.9436 36.1657 35.9475 36.1415 35.9501 36.1091L35.964 36.1964L35.9777 36.2002C36.0266 36.2025 36.0565 36.2099 36.1009 36.188L36.0711 35.9088Z"
          fill="#E2D4CA"
        />
        <path
          id="Vector_398"
          d="M34.624 32.1013C34.8049 31.9735 34.971 31.7954 35.1358 31.6462L35.1389 32.2105L35.1173 35.7044L34.7949 35.7052C34.7718 35.484 34.7899 35.2448 34.789 35.0218C34.7871 34.549 34.7771 34.0763 34.776 33.6033C34.7754 33.3346 34.7984 33.0487 34.772 32.7827C34.7496 32.5576 34.6857 32.3187 34.624 32.1013Z"
          fill="#FBFAFB"
        />
        <path
          id="Vector_399"
          d="M33.9912 27.7309C34.0346 27.8064 34.0068 28.0722 34.0069 28.1671C34.0076 28.6845 34.0069 29.2018 34.0067 29.7192C34.0067 29.9795 34.0065 30.2399 34.0062 30.5003C34.0058 30.7806 33.9846 31.1379 34.088 31.3997C34.1708 31.6093 34.2873 31.781 34.4509 31.9361C34.5062 31.9884 34.5792 32.0404 34.6241 32.1013C34.6857 32.3187 34.7496 32.5576 34.772 32.7827C34.7984 33.0487 34.7755 33.3346 34.7761 33.6033C34.7771 34.0763 34.7872 34.549 34.789 35.0218C34.7899 35.2448 34.7718 35.4841 34.7949 35.7052L34.7848 35.721L34.7733 35.7722C34.8086 35.8033 34.8389 35.8204 34.882 35.8388L34.9083 35.863C34.9169 36.154 34.9234 36.4991 35.0068 36.7795L34.257 36.7789L34.1295 36.7778L34.1192 36.775C33.9552 36.752 33.772 36.7669 33.606 36.7665C33.2678 36.7656 32.9296 36.7649 32.5914 36.7643L32.5924 36.5328L34.1571 36.5372L34.181 33.6827L34.1973 33.3883L34.2139 32.2293L33.7663 31.6637C33.7367 31.5356 33.7442 31.407 33.7437 31.2763C33.743 31.065 33.7429 30.8537 33.743 30.6425C33.8313 30.6318 33.9075 30.6135 33.9922 30.5856L33.9912 27.7309Z"
          fill="#ECE7E0"
        />
        <path
          id="Vector_400"
          d="M33.9686 33.3975C34.0472 33.3841 34.1181 33.3681 34.1973 33.3883L34.1809 33.6827L34.157 36.5372L32.5924 36.5328C32.6083 35.7999 32.6147 35.0663 32.6206 34.3332C32.6219 34.1752 32.6224 34.0173 32.6229 33.8593C32.623 33.823 32.6129 33.7367 32.6233 33.7061C32.6274 33.6942 32.6389 33.6864 32.6467 33.6765L32.7777 33.6769L32.7784 33.6633L32.7774 33.4155L33.0622 33.4062C33.3592 33.4011 33.6746 33.4319 33.9686 33.3975Z"
          fill="#67C6CE"
        />
        <path
          id="Vector_401"
          d="M32.837 36.0883L33.9565 36.0937L33.9553 36.3285L32.8359 36.3367L32.837 36.0883Z"
          fill="#250C28"
        />
        <path
          id="Vector_402"
          d="M33.9686 33.3975C34.0472 33.3841 34.1181 33.3681 34.1973 33.3883L34.1809 33.6827C34.0311 33.6658 33.8675 33.679 33.7162 33.679C33.4034 33.6791 33.0906 33.6787 32.7777 33.6769L32.7784 33.6633L32.7773 33.4155L33.0622 33.4062C33.3592 33.4011 33.6746 33.4319 33.9686 33.3975Z"
          fill="#8E8796"
        />
        <path
          id="Vector_403"
          d="M32.8368 33.9923C33.1014 33.9907 33.3661 33.9893 33.6308 33.9884C33.7242 33.9881 33.864 33.9694 33.9486 34.0005C33.971 34.1405 33.958 34.2916 33.9538 34.4331L32.8368 34.4328L32.837 34.2771L32.8368 33.9923Z"
          fill="#130B24"
        />
        <path
          id="Vector_404"
          d="M33.9486 34.0005C33.971 34.1405 33.958 34.2916 33.9538 34.4331L32.8368 34.4328L32.837 34.2771L33.9447 34.2817L33.9486 34.0005Z"
          fill="#32AEBE"
        />
        <path
          id="Vector_405"
          d="M32.8463 35.2778L33.958 35.2724L33.9601 35.5226L33.9564 35.6719L33.9597 35.9457L33.9565 36.0937L32.837 36.0883L32.8376 35.9451L32.8358 35.6734C32.8325 35.5596 32.8249 35.4439 32.8373 35.3306L32.8463 35.2778Z"
          fill="#130B24"
        />
        <path
          id="Vector_406"
          d="M32.8376 35.9451L33.9597 35.9457L33.9565 36.0937L32.837 36.0883L32.8376 35.9451Z"
          fill="#32AEBE"
        />
        <path
          id="Vector_407"
          d="M32.8463 35.2778L33.958 35.2724L33.9601 35.5226L33.9564 35.6719L32.8358 35.6734C32.8325 35.5596 32.8249 35.4439 32.8373 35.3306L32.8463 35.2778Z"
          fill="#130B24"
        />
        <path
          id="Vector_408"
          d="M32.8372 35.3306L32.8445 35.5234L33.9601 35.5226L33.9564 35.6719L32.8358 35.6734C32.8325 35.5596 32.8249 35.4439 32.8372 35.3306Z"
          fill="#32AEBE"
        />
        <path
          id="Vector_409"
          d="M32.8368 34.4328L33.9538 34.4331L33.9576 34.6947L33.957 34.8416C33.9565 34.9317 33.9509 35.0246 33.9625 35.1141C33.9693 35.1701 33.9669 35.2167 33.958 35.2723L32.8463 35.2778C32.8344 35.2248 32.839 35.1656 32.8388 35.1114L32.8388 34.8477L32.8372 34.6906L32.8368 34.4328Z"
          fill="#250C28"
        />
        <path
          id="Vector_410"
          d="M33.9625 35.1141C33.9693 35.1701 33.9669 35.2167 33.958 35.2724L32.8463 35.2778C32.8344 35.2248 32.839 35.1656 32.8388 35.1114L33.9625 35.1141Z"
          fill="#32AEBE"
        />
        <path
          id="Vector_411"
          d="M32.8368 34.4328L33.9538 34.4331L33.9576 34.6947L33.957 34.8416L32.8388 34.8477L32.8372 34.6906L32.8368 34.4328Z"
          fill="#130B24"
        />
        <path
          id="Vector_412"
          d="M32.8372 34.6906L33.9576 34.6947L33.957 34.8416L32.8388 34.8477L32.8372 34.6906Z"
          fill="#32AEBE"
        />
        <path
          id="Vector_413"
          d="M34.7653 16.1782L34.9724 16.1814C34.9673 16.2206 34.9631 16.2406 34.9479 16.2761L34.9328 16.3215L34.8799 16.4805L34.8119 16.6849C34.8004 16.7192 34.7837 16.7481 34.7738 16.7833L34.6455 17.1688C34.634 17.2033 34.6173 17.2324 34.6073 17.2676L34.5688 17.382C34.5608 17.4059 34.5539 17.4256 34.5597 17.4504C34.565 17.554 34.4997 17.6931 34.4696 17.794C34.3546 18.1796 34.2324 18.5631 34.1166 18.9485C34.0644 19.1225 33.9835 19.3175 33.971 19.5003C33.9329 20.0589 33.9559 20.6332 33.9551 21.1933C33.9539 22.0561 33.9416 22.9207 33.9608 23.7832C33.9644 23.9456 33.9812 24.1066 33.9864 24.2683C34 24.6881 33.9879 25.1122 33.9873 25.5324C33.9862 26.2652 33.9884 26.998 33.9913 27.7309L33.9922 30.5856C33.9075 30.6135 33.8313 30.6319 33.743 30.6425C33.7429 30.8538 33.743 31.065 33.7437 31.2763C33.7442 31.407 33.7367 31.5356 33.7663 31.6637C33.6814 31.6666 33.5017 31.6516 33.4313 31.6896L33.4217 30.762L33.3612 30.7357C33.1646 30.7674 32.9252 30.7412 32.7239 30.7411L32.6392 30.7365C32.6341 30.7298 32.6265 30.7245 32.624 30.7166C32.6023 30.6499 32.6228 30.4915 32.6224 30.417C32.6205 30.0526 32.6182 29.6883 32.6157 29.324C32.6051 27.7296 32.6128 26.1349 32.6095 24.5405C32.6078 23.7282 32.6231 22.906 32.5892 22.0946C32.5699 21.9577 32.5798 21.8095 32.5789 21.6712C32.5774 21.4496 32.5718 21.2271 32.5811 21.0057L33.5076 18.536L33.5077 18.5519C33.5074 18.6036 33.5013 18.6359 33.4817 18.6836L33.6437 18.7337C33.709 18.75 33.772 18.7802 33.835 18.804L33.8313 18.7813L33.8501 18.7586L33.8464 18.7358L33.8652 18.7131L33.8644 18.6921L33.904 18.6569L34.7653 16.1782Z"
          fill="#FBFAFB"
        />
        <path
          id="Vector_414"
          d="M33.5076 18.536L33.5077 18.5519C33.5074 18.6036 33.5013 18.6359 33.4817 18.6836L33.6437 18.7337C33.709 18.75 33.772 18.7802 33.835 18.804L33.8313 18.7813L33.8501 18.7585L33.8464 18.7358L33.8653 18.7131L33.8644 18.6921L33.904 18.6569C33.7781 19.0771 33.6301 19.492 33.4991 19.9112C33.4611 20.033 33.3969 20.1718 33.3764 20.2967C33.3493 20.4616 33.3663 20.6553 33.3656 20.8228C33.3639 21.2468 33.3746 21.673 33.3653 22.0967L33.3528 22.0838C33.1787 22.0843 33.0046 22.0849 32.8304 22.0858C32.7583 22.0861 32.6569 22.0744 32.5892 22.0946C32.5699 21.9577 32.5798 21.8095 32.5789 21.6712C32.5774 21.4496 32.5718 21.2271 32.5811 21.0057L33.5076 18.536Z"
          fill="url(#paint22_linear_11_402)"
        />
        <path
          id="Vector_415"
          d="M32.5811 21.0057L33.3507 21.0038L33.3528 22.0838C33.1787 22.0843 33.0046 22.0849 32.8304 22.0858C32.7583 22.0862 32.6569 22.0744 32.5892 22.0946C32.5699 21.9577 32.5798 21.8095 32.5789 21.6712C32.5774 21.4496 32.5718 21.2271 32.5811 21.0057Z"
          fill="#797388"
        />
        <path
          id="Vector_416"
          d="M32.9627 21.4244C32.9834 21.4268 33.0055 21.4283 33.0252 21.4362C33.0653 21.4522 33.0979 21.4886 33.1163 21.5268C33.1366 21.569 33.1449 21.6138 33.1268 21.6582C33.1053 21.711 33.0697 21.7314 33.0195 21.7532L32.9988 21.7447C32.9916 21.7186 32.9857 21.7022 32.9722 21.6782L32.9462 21.6951L32.9366 21.7446L32.9041 21.7421C32.8478 21.6773 32.8474 21.6348 32.8504 21.5513C32.8781 21.4992 32.92 21.4641 32.9627 21.4244Z"
          fill="#250C28"
        />
        <path
          id="Vector_417"
          d="M34.5597 17.4504C34.565 17.554 34.4997 17.6931 34.4696 17.794C34.3546 18.1796 34.2324 18.5631 34.1166 18.9485C34.0644 19.1225 33.9835 19.3175 33.971 19.5003C33.9329 20.0589 33.9559 20.6332 33.9551 21.1933C33.9539 22.0561 33.9416 22.9207 33.9608 23.7832C33.9644 23.9456 33.9812 24.1066 33.9864 24.2683C34 24.6881 33.9879 25.1122 33.9873 25.5324C33.9862 26.2652 33.9884 26.998 33.9913 27.7309L33.9922 30.5856C33.9075 30.6135 33.8313 30.6319 33.743 30.6425C33.7429 30.8538 33.743 31.065 33.7437 31.2763C33.7442 31.407 33.7367 31.5356 33.7663 31.6637C33.6814 31.6666 33.5017 31.6516 33.4313 31.6896L33.4217 30.762L33.3612 30.7357L33.3677 30.6954L33.5708 30.6642C33.5863 30.4025 33.5792 30.1363 33.5797 29.874C33.5806 29.3754 33.5774 28.8768 33.5805 28.3782C33.5914 26.5957 33.5896 24.8135 33.5913 23.031C33.5918 22.4651 33.592 21.8992 33.5932 21.3333C33.5938 21.0562 33.5707 20.752 33.6039 20.478C33.6201 20.3439 33.6709 20.2109 33.713 20.083C33.7826 19.8711 33.8559 19.6601 33.9224 19.4473C34.0751 18.9586 34.2187 18.4687 34.3783 17.9819C34.4349 17.8093 34.477 17.6114 34.5597 17.4504Z"
          fill="#C7A7A3"
        />
        <path
          id="Vector_418"
          d="M33.3528 22.0838L33.3654 22.0967L33.3677 30.6954L33.3612 30.7357C33.1646 30.7674 32.9252 30.7412 32.7239 30.7411L32.6392 30.7365C32.6341 30.7298 32.6265 30.7245 32.624 30.7166C32.6023 30.6499 32.6228 30.4915 32.6224 30.417C32.6205 30.0526 32.6182 29.6883 32.6158 29.324C32.6051 27.7296 32.6128 26.1349 32.6095 24.5405C32.6078 23.7282 32.6231 22.906 32.5892 22.0946C32.6569 22.0744 32.7583 22.0862 32.8305 22.0858C33.0046 22.0849 33.1787 22.0843 33.3528 22.0838Z"
          fill="#1B1536"
        />
        <path
          id="Vector_419"
          d="M32.7279 23.9124L33.2087 23.9131L33.2111 24.6821L32.7278 24.6813L32.7279 23.9124Z"
          fill="#ED3131"
        />
        <path
          id="Vector_420"
          d="M32.7306 25.8056L33.2121 25.8074L33.2093 26.6424L32.7312 26.6419L32.7306 25.8056Z"
          fill="#ED3131"
        />
        <path
          id="Vector_421"
          d="M32.7175 27.8767L33.2024 27.8759L33.2034 28.7096L32.7196 28.7091L32.7175 27.8767Z"
          fill="#ED3131"
        />
        <path
          id="Vector_422"
          d="M32.7268 24.8038L33.2142 24.8057L33.2141 25.6785L32.7286 25.6783L32.7268 24.8038Z"
          fill="#D31D22"
        />
        <path
          id="Vector_423"
          d="M32.7305 26.7773L33.2011 26.7808L33.2035 27.7264C33.0594 27.7495 32.8776 27.732 32.7297 27.7325L32.7305 26.7773Z"
          fill="#ED3131"
        />
        <path
          id="Vector_424"
          d="M32.7266 22.7689L33.2117 22.772L33.2055 23.777L32.7283 23.7781L32.7266 22.7689Z"
          fill="#ED3131"
        />
        <path
          id="Vector_425"
          d="M32.7178 28.8609L33.21 28.8619L33.2075 29.8592L32.7229 29.8596L32.7178 28.8609Z"
          fill="#ED3131"
        />
        <path
          id="Vector_426"
          d="M31.0727 30.433C31.0886 30.4548 31.0947 30.4792 31.1037 30.5046C31.0243 30.6077 30.9176 30.7269 30.8157 30.807C30.7926 30.7908 30.765 30.7803 30.7579 30.7524C30.8743 30.6606 30.9724 30.5418 31.0727 30.433Z"
          fill="#8E8796"
        />
        <path
          id="Vector_427"
          d="M29.7762 31.8065C29.8074 31.8181 29.8182 31.8352 29.8409 31.8594C29.8324 31.9042 29.7896 31.9334 29.758 31.9658C29.6768 32.0492 29.5963 32.1332 29.5158 32.2172C29.4801 32.202 29.4671 32.1996 29.4413 32.1697L29.7762 31.8065Z"
          fill="#8E8796"
        />
        <path
          id="Vector_428"
          d="M34.4301 15.1689L34.7171 15.1772L34.6491 15.3106C34.628 15.3595 34.5916 15.3979 34.5806 15.4512C34.6211 15.4639 34.6615 15.465 34.7036 15.4685L34.6994 15.4816L34.2604 15.4783C34.2804 15.3876 34.3758 15.2455 34.4301 15.1689Z"
          fill="#1B1536"
        />
        <path
          id="Vector_429"
          d="M31.8672 23.694L31.8647 24.4673L31.8529 24.4682L31.8585 24.0618L31.5013 24.0821L31.3347 23.8747L31.6508 23.864C31.7335 23.8218 31.799 23.7558 31.8672 23.694Z"
          fill="#420D27"
        />
        <path
          id="Vector_430"
          d="M32.4221 20.4724L33.7668 17.245L33.7794 17.2676L32.4798 20.5394L32.4694 20.4999C32.4686 20.4812 32.4757 20.4751 32.4862 20.4602C32.5043 20.4342 32.5003 20.4511 32.4955 20.416L32.4796 20.4118L32.4448 20.4729L32.4221 20.4724Z"
          fill="#7B7777"
        />
        <path
          id="Vector_431"
          d="M31.8488 30.2192C31.8926 30.2502 31.9314 30.2987 31.9693 30.3373L29.748 32.6086C29.7021 32.5887 29.666 32.5483 29.6291 32.5146L31.8488 30.2192Z"
          fill="#8E8796"
        />
        <path
          id="Vector_432"
          d="M30.8073 23.2358C31.2254 23.2318 31.528 23.2296 31.8689 22.9506L31.8672 23.694C31.799 23.7558 31.7335 23.8218 31.6508 23.864L31.3347 23.8747L31.025 23.5175L30.8073 23.2358Z"
          fill="#130B24"
        />
        <path
          id="Vector_433"
          d="M31.1899 37.7963L33.8797 39.8647C33.8344 39.91 33.7761 39.9004 33.7139 39.9009C33.5932 39.902 33.4133 39.8702 33.3031 39.9173C33.2391 39.8694 33.1816 39.7994 33.1259 39.7418C32.9879 39.5992 32.857 39.4506 32.7225 39.3049C32.322 38.8711 31.8987 38.42 31.4375 38.0502C31.3533 37.9826 31.2119 37.9073 31.1899 37.7963Z"
          fill="url(#paint23_linear_11_402)"
        />
        <path
          id="Vector_434"
          d="M31.6409 25.8469C31.7097 25.786 31.7759 25.7275 31.8545 25.6792L31.8552 28.9387L31.6768 29.1503C31.6612 29.1234 31.6532 29.1042 31.6502 29.0727C31.6183 28.739 31.6438 28.3763 31.6434 28.0394C31.6425 27.313 31.6468 26.5863 31.6391 25.86L31.6409 25.8469Z"
          fill="#420D27"
        />
        <path
          id="Vector_435"
          d="M31.7526 21.3142C31.7847 21.2643 31.7842 21.2453 31.8437 21.2316C31.8618 21.4048 31.87 21.6144 31.8567 21.7878C31.8509 21.8643 31.8443 21.941 31.859 22.0164C31.8794 22.1209 31.8674 22.2554 31.8679 22.3625C31.8688 22.5574 31.8773 22.7561 31.8689 22.9506C31.528 23.2296 31.2254 23.2318 30.8073 23.2358L30.7538 23.2028C30.7035 23.1225 30.6563 23.0328 30.6272 22.9424L30.6198 22.9188C30.5849 22.8095 30.5764 22.7117 30.572 22.5972L30.7168 22.6452L30.7538 22.6566C30.9882 22.7175 31.257 22.6399 31.4572 22.5189L31.4925 22.4982C31.6133 22.4149 31.7857 22.2304 31.8174 22.0819C31.8256 22.0431 31.8418 22.0063 31.8403 21.9661L31.8383 21.9448C31.8382 21.9005 31.8383 21.873 31.8287 21.8294L31.8205 21.8079C31.8301 21.79 31.8339 21.7752 31.8388 21.7556L31.8189 21.7253L31.8362 21.6572L31.8128 21.6317L31.8086 21.6076C31.8194 21.5628 31.8272 21.5226 31.8096 21.4786C31.7877 21.4241 31.7701 21.3704 31.7526 21.3142Z"
          fill="#5F112B"
        />
        <path
          id="Vector_436"
          d="M34.5029 15.7983L35.4693 15.7967L35.4588 16.174L35.4419 16.1796L35.2789 16.1778L34.9724 16.1814L34.7653 16.1782L33.904 18.6569L33.8644 18.6921L33.8652 18.7131L33.8464 18.7358L33.8501 18.7585L33.8312 18.7812L33.8349 18.8039C33.772 18.7802 33.709 18.75 33.6436 18.7337L33.4817 18.6836C33.5013 18.6359 33.5074 18.6036 33.5077 18.5519L33.5075 18.536L34.5029 15.7983Z"
          fill="#F56D3B"
        />
        <path
          id="Vector_437"
          d="M32.2403 30.9043L32.1353 37.818L32.1301 37.96L32.353 38.162L32.3258 38.1636C32.2228 38.0966 32.1245 37.9941 32.0292 37.9142C31.8133 37.7331 31.5959 37.5557 31.3837 37.3698C31.0885 37.1115 30.7754 36.8732 30.4709 36.6267C30.1836 36.3942 29.9045 36.1515 29.6075 35.9311C29.5056 35.8556 29.4045 35.7786 29.3013 35.705C29.2273 35.6522 29.0945 35.5709 29.0505 35.4897L29.0431 35.471C29.0076 35.391 29.0171 35.3082 29.0176 35.2222C29.0183 35.0984 29.0191 34.9747 29.0193 34.8509C29.02 34.5226 29.0201 34.1943 29.0188 33.8659C29.0173 33.4938 29.005 33.1222 29.002 32.7501C29.1745 32.7494 29.3409 32.7351 29.5071 32.7874C29.6148 32.786 29.73 32.7923 29.8365 32.7785L30.4169 32.7778L32.2403 30.9043Z"
          fill="#E2D4CA"
        />
        <path
          id="Vector_438"
          d="M29.971 33.9022L30.034 33.8617L31.8705 35.612L31.5682 35.6128C31.4422 35.4303 31.268 35.2691 31.1141 35.1102C30.7328 34.7164 30.3114 34.3318 29.971 33.9022Z"
          fill="#9D9BA7"
        />
        <path
          id="Vector_439"
          d="M32.1301 37.96C31.4158 37.3744 30.7153 36.773 29.9936 36.1961C29.8495 36.0808 29.7038 35.9647 29.5548 35.8558C29.418 35.7558 29.2218 35.6489 29.1199 35.5159C29.113 35.475 29.1099 35.449 29.1185 35.4075C29.2023 35.4207 29.3187 35.5153 29.3905 35.5638C29.921 35.9223 30.3969 36.3639 30.8866 36.7752C31.1814 37.0228 31.4807 37.2656 31.7784 37.5098C31.8516 37.5699 31.9248 37.6298 31.9928 37.6958C32.0243 37.7263 32.0717 37.7884 32.1089 37.8082L32.1353 37.818L32.1301 37.96Z"
          fill="#9D9BA7"
        />
        <path
          id="Vector_440"
          d="M30.4747 35.1937C30.5638 35.1885 30.6396 35.1884 30.7215 35.2297C30.8318 35.2853 30.9275 35.3885 30.9633 35.5079C31.0028 35.6398 30.9908 35.7872 30.9249 35.9087C30.8534 36.0408 30.7505 36.1048 30.6093 36.1444C30.4971 36.1457 30.4049 36.1329 30.3042 36.0787C30.2081 36.0269 30.1012 35.9234 30.0747 35.8152C30.0424 35.6837 30.0714 35.517 30.145 35.4044C30.2269 35.2791 30.332 35.224 30.4747 35.1937Z"
          fill="#8E8796"
        />
        <path
          id="Vector_441"
          d="M30.4464 35.3746C30.5096 35.3676 30.5875 35.3589 30.6485 35.3799C30.7256 35.4064 30.7942 35.4722 30.8274 35.5461C30.8627 35.6244 30.8642 35.7298 30.834 35.8101C30.7922 35.921 30.7154 35.9753 30.6108 36.0203C30.5566 36.0249 30.4969 36.0338 30.444 36.0177C30.3597 35.992 30.2807 35.9385 30.2397 35.8579C30.1962 35.7726 30.1966 35.6699 30.2275 35.5807C30.2645 35.4739 30.3493 35.4204 30.4464 35.3746Z"
          fill="#250C28"
        />
        <path
          id="Vector_442"
          d="M30.4734 35.5366L30.5296 35.5355C30.5792 35.5366 30.6097 35.5529 30.6421 35.5897C30.6725 35.6242 30.6843 35.6898 30.6769 35.7347C30.6675 35.7912 30.6312 35.8179 30.5891 35.8517C30.5335 35.8574 30.4877 35.854 30.4425 35.8165C30.4066 35.7866 30.3834 35.7291 30.3851 35.6825C30.3876 35.6171 30.4277 35.5778 30.4734 35.5366Z"
          fill="#8E8796"
        />
        <path
          id="Vector_443"
          d="M31.454 36.0873C31.5321 36.0935 31.5991 36.1009 31.6704 36.1356C31.8018 36.1997 31.8942 36.313 31.939 36.4511L31.9468 36.4761C31.9574 36.509 31.9672 36.5401 31.9719 36.5745C31.9878 36.6914 31.9671 36.8175 31.8924 36.9114C31.8027 37.0239 31.6864 37.0503 31.5516 37.0642C31.4345 37.0508 31.338 37.0298 31.2392 36.9611C31.1334 36.8876 31.0402 36.782 31.0212 36.6502C31.0017 36.5159 31.0317 36.3715 31.113 36.2623C31.1971 36.1492 31.3213 36.1091 31.454 36.0873Z"
          fill="#8E8796"
        />
        <path
          id="Vector_444"
          d="M31.3984 36.2514C31.4602 36.2481 31.536 36.2411 31.595 36.2626C31.6766 36.2922 31.7455 36.3691 31.7772 36.4488C31.8076 36.5253 31.8102 36.6349 31.7751 36.7107C31.7328 36.8022 31.6524 36.8528 31.562 36.8878C31.4969 36.8976 31.4342 36.8998 31.3705 36.8795C31.2883 36.8533 31.2203 36.7888 31.1843 36.7113C31.1453 36.6273 31.1484 36.5382 31.1821 36.4534C31.2246 36.3464 31.2969 36.2974 31.3984 36.2514Z"
          fill="#1B1536"
        />
        <path
          id="Vector_445"
          d="M31.4084 36.4156C31.4727 36.4148 31.5491 36.4056 31.5962 36.4594C31.6362 36.5052 31.6497 36.5522 31.6402 36.6123C31.6319 36.6644 31.5814 36.6984 31.5422 36.7271L31.5117 36.731C31.4582 36.7369 31.4115 36.7229 31.372 36.6856C31.3373 36.6529 31.3195 36.6084 31.3209 36.5609C31.3231 36.4903 31.3595 36.4608 31.4084 36.4156Z"
          fill="#797388"
        />
        <path
          id="Vector_446"
          d="M29.6317 34.3466C29.7107 34.3507 29.7782 34.3557 29.8499 34.3916C29.9678 34.4506 30.06 34.5576 30.0972 34.6844C30.1326 34.8048 30.1109 34.9379 30.0494 35.0457C29.9633 35.1964 29.8218 35.2749 29.6592 35.3162C29.553 35.3138 29.4532 35.3123 29.3595 35.254C29.2539 35.1883 29.1774 35.0678 29.1559 34.946C29.1306 34.8023 29.1461 34.6619 29.2368 34.5429C29.3397 34.4076 29.4709 34.3644 29.6317 34.3466Z"
          fill="#8E8796"
        />
        <path
          id="Vector_447"
          d="M29.5624 34.5098C29.6222 34.5074 29.6818 34.5147 29.7372 34.5381C29.813 34.5702 29.8791 34.6335 29.9096 34.7106C29.9419 34.7927 29.9468 34.9033 29.9088 34.9839C29.8562 35.0956 29.761 35.1414 29.6495 35.1766C29.5836 35.177 29.5284 35.1792 29.467 35.1525C29.3793 35.1145 29.3117 35.0429 29.2802 34.9523C29.2497 34.8643 29.2591 34.766 29.3028 34.6843C29.3583 34.5804 29.4545 34.5386 29.5624 34.5098Z"
          fill="#250C28"
        />
        <path
          id="Vector_448"
          d="M29.5484 34.7017C29.5892 34.7076 29.6378 34.7117 29.6707 34.7385C29.7155 34.7749 29.7279 34.8244 29.7317 34.8792C29.7031 34.9512 29.6906 34.9638 29.6301 35.0131C29.581 35.009 29.5322 35.0099 29.4943 34.9736C29.443 34.9244 29.448 34.8761 29.4471 34.811C29.4728 34.7556 29.4981 34.7354 29.5484 34.7017Z"
          fill="#8E8796"
        />
        <path
          id="Vector_449"
          d="M29.5071 32.7874C29.6148 32.786 29.73 32.7923 29.8365 32.7785C29.9815 32.8517 30.1518 32.9529 30.1997 33.1228C30.2162 33.1815 30.2096 33.2556 30.2095 33.3167C30.2092 33.46 30.2271 33.6263 30.1436 33.751C30.1163 33.7917 30.0742 33.8337 30.034 33.8617L29.971 33.9022L29.9527 33.9112C29.809 33.977 29.5584 33.9619 29.415 33.9028C29.3065 33.858 29.196 33.7477 29.1538 33.6384C29.0927 33.4803 29.0875 33.1903 29.1631 33.0394C29.2288 32.9085 29.3723 32.8284 29.5071 32.7874Z"
          fill="#8E8796"
        />
        <path
          id="Vector_450"
          d="M29.5203 33.0445C29.5745 33.0368 29.6261 33.0315 29.6809 33.0368C29.7881 33.047 29.8798 33.0954 29.9439 33.1838C29.9973 33.2574 30.0119 33.3707 29.9957 33.4583L29.9915 33.479C29.9878 33.4975 29.9846 33.5155 29.9779 33.5333C29.9374 33.6419 29.8542 33.69 29.7529 33.7319C29.6752 33.7458 29.5954 33.7523 29.5189 33.728C29.4339 33.701 29.3626 33.6459 29.3231 33.5652C29.2749 33.4668 29.2759 33.3538 29.3125 33.252C29.3514 33.1435 29.4205 33.0945 29.5203 33.0445Z"
          fill="#1B1536"
        />
        <path
          id="Vector_451"
          d="M29.5774 33.2506C29.6338 33.25 29.6954 33.248 29.7363 33.2942C29.7755 33.3385 29.781 33.3913 29.7728 33.4473C29.7646 33.5024 29.7241 33.5341 29.6835 33.5673C29.6346 33.5677 29.5924 33.5695 29.5513 33.5377C29.509 33.505 29.4855 33.4568 29.4848 33.4033C29.4837 33.3278 29.5247 33.2958 29.5774 33.2506Z"
          fill="#8E8796"
        />
        <path
          id="Vector_452"
          d="M31.2494 32.789C31.3931 32.7805 31.5785 32.7777 31.7062 32.8517C31.8476 32.9336 31.9303 33.07 31.9657 33.227C32.0027 33.3913 31.9915 33.5835 31.8979 33.7277C31.8149 33.8554 31.6953 33.9008 31.5531 33.9301C31.4112 33.9417 31.1686 33.9639 31.0432 33.898C30.9516 33.8499 30.8807 33.7515 30.852 33.6531L30.8469 33.6344L30.8356 33.5924C30.7976 33.4228 30.8175 33.1432 30.9147 32.9985C30.9988 32.8731 31.1043 32.8134 31.2494 32.789Z"
          fill="#8E8796"
        />
        <path
          id="Vector_453"
          d="M31.2946 32.9976C31.3627 32.9936 31.4446 32.9856 31.5096 33.0077C31.6173 33.0445 31.7075 33.128 31.7514 33.233C31.7829 33.3083 31.7875 33.4067 31.755 33.4824C31.7061 33.5962 31.628 33.6442 31.5185 33.6886C31.4239 33.7 31.3135 33.7055 31.2233 33.6697C31.1498 33.6405 31.0859 33.5814 31.0558 33.5076C31.02 33.4198 31.0192 33.3 31.0564 33.2131C31.1053 33.0984 31.185 33.045 31.2946 32.9976Z"
          fill="#1B1536"
        />
        <path
          id="Vector_454"
          d="M31.3505 33.1916L31.3886 33.1923C31.441 33.1963 31.4971 33.2116 31.53 33.2556C31.5598 33.2956 31.5704 33.3412 31.563 33.3904C31.552 33.4633 31.5108 33.4977 31.4525 33.5367L31.4144 33.5387C31.3635 33.5376 31.3195 33.5187 31.285 33.4811C31.2368 33.4286 31.2434 33.3717 31.248 33.3049C31.2737 33.2526 31.3051 33.2274 31.3505 33.1916Z"
          fill="#8E8796"
        />
        <path
          id="Vector_455"
          d="M35.4588 16.174L35.9693 16.1772L36.0298 16.1791L36.2278 16.1823C36.2847 16.3463 36.3412 16.5105 36.3945 16.6757C36.4246 16.769 36.4465 16.8749 36.4909 16.9621C36.5595 17.2242 36.6542 17.4818 36.7386 17.7393C36.8575 18.1022 36.9714 18.4667 37.0912 18.8293C37.2327 19.2578 37.4045 19.6966 37.4814 20.1421C37.4959 20.2266 37.5193 20.3286 37.5104 20.4138L37.5268 20.9936L37.5428 22.0761L37.5697 30.6667C37.578 30.6932 37.5758 30.7134 37.6021 30.7268C37.6326 30.7423 37.6556 30.741 37.689 30.7421L37.6895 30.7528C37.6584 30.8304 37.6724 30.9349 37.6724 31.0177C37.6724 31.2281 37.69 31.4521 37.6718 31.661C37.5527 31.6632 37.418 31.6782 37.3014 31.6545C37.2618 31.6774 37.2438 31.7053 37.2176 31.742C37.0738 31.9437 36.9399 32.1133 36.7634 32.2887L36.7681 33.4961L36.7717 36.6451L36.7688 36.7768L36.681 36.7781L36.5125 36.7792C36.4716 36.6696 36.4048 36.5691 36.3552 36.4624C36.2979 36.3393 36.2602 36.214 36.2092 36.0894L36.1975 36.0612C36.1175 35.7493 36.0597 35.4216 35.9473 35.12C35.9093 35.018 35.922 34.8975 35.9218 34.7893C35.9214 34.6066 35.9221 34.424 35.9221 34.2413C35.9219 33.7289 35.9199 33.2164 35.9188 32.7039C35.8995 32.6644 35.9089 32.5962 35.9087 32.552C35.9079 32.417 35.906 32.2819 35.9111 32.1469C35.6516 32.2029 35.4031 32.209 35.1389 32.2105L35.1358 31.6462C34.971 31.7954 34.8049 31.9735 34.624 32.1013C34.5792 32.0404 34.5061 31.9884 34.4509 31.9361C34.2872 31.781 34.1708 31.6093 34.088 31.3997C33.9846 31.1379 34.0058 30.7807 34.0062 30.5003C34.0065 30.2399 34.0066 29.9796 34.0067 29.7192C34.0069 29.2018 34.0076 28.6845 34.0069 28.1671C34.0067 28.0722 34.0346 27.8064 33.9912 27.7309C33.9884 26.998 33.9862 26.2652 33.9872 25.5324C33.9879 25.1122 34 24.6881 33.9864 24.2683C33.9811 24.1066 33.9643 23.9456 33.9607 23.7832C33.9416 22.9207 33.9539 22.0561 33.9551 21.1933C33.9559 20.6332 33.9329 20.0588 33.971 19.5002C33.9835 19.3175 34.0644 19.1225 34.1166 18.9485C34.2323 18.5631 34.3546 18.1796 34.4695 17.794C34.4996 17.6931 34.565 17.554 34.5596 17.4504C34.5539 17.4255 34.5608 17.4059 34.5688 17.382L34.6073 17.2676C34.6173 17.2324 34.6339 17.2033 34.6454 17.1688L34.7737 16.7833C34.7837 16.7481 34.8004 16.7192 34.8119 16.6849L34.8799 16.4805L34.9328 16.3215L34.9479 16.2761C34.963 16.2406 34.9673 16.2206 34.9724 16.1814L35.2789 16.1779L35.4419 16.1796L35.4588 16.174Z"
          fill="#F8F5EC"
        />
        <path
          id="Vector_456"
          d="M35.4844 26.1041C35.4184 26.0896 35.3618 26.0685 35.3147 26.0179C35.2492 25.9478 35.2365 25.8926 35.2426 25.7971C35.247 25.7293 35.2807 25.6617 35.3335 25.6182C35.4 25.5634 35.4615 25.5627 35.5444 25.5672C35.4701 25.7351 35.46 25.9221 35.4844 26.1041Z"
          fill="#ED3131"
        />
        <path
          id="Vector_457"
          d="M35.3102 16.2361L35.4431 16.2388C35.442 16.8293 35.441 17.4198 35.4403 18.0102C35.4402 18.1761 35.44 18.3419 35.4397 18.5078C35.4396 18.5946 35.4477 18.691 35.4345 18.7766L35.4034 18.8172C35.294 18.8489 35.1322 18.8294 35.0164 18.8304L35.0127 18.8171C34.9872 18.7024 35.0002 18.5608 35.0003 18.4428C35.0007 17.8815 35.0454 17.3386 35.1175 16.7823C35.1333 16.6606 35.1502 16.5409 35.1721 16.4201C35.1829 16.3605 35.1885 16.2937 35.2201 16.2411L35.3102 16.2361Z"
          fill="#ECE7E0"
        />
        <path
          id="Vector_458"
          d="M35.5022 26.4258C35.8305 26.4468 36.097 26.5396 36.3208 26.7916C36.4607 26.9491 36.5429 27.1165 36.5966 27.3195C36.6097 27.4467 36.6206 27.5676 36.6135 27.6957L36.6121 27.7253L36.611 27.743C36.5325 28.0671 36.356 28.3495 36.0676 28.5288C35.9027 28.6315 35.7233 28.6776 35.5311 28.6934C35.2867 28.6986 35.0477 28.638 34.8492 28.4918C34.6037 28.3109 34.4452 28.0767 34.4011 27.7713C34.3549 27.452 34.4355 27.1291 34.6324 26.8723C34.8599 26.5754 35.1428 26.4703 35.5022 26.4258Z"
          fill="#1B1536"
        />
        <path
          id="Vector_459"
          d="M35.469 28.3829L35.3667 28.3751C35.1571 28.3497 34.9713 28.2312 34.8446 28.0643C34.7156 27.8945 34.6645 27.6867 34.6926 27.4763L34.6968 27.447C34.719 27.2812 34.7868 27.1212 34.8954 26.9929C35.0523 26.8077 35.2462 26.7381 35.4838 26.7206L35.4804 26.8758L35.4704 27.972L35.4747 28.2211L35.4636 28.2255L35.469 28.3829Z"
          fill="#FBFAFB"
        />
        <path
          id="Vector_460"
          d="M34.8695 27.3742L34.8816 27.3952C34.9072 27.4427 34.9112 27.5064 34.9212 27.559C34.956 27.7433 35.0557 27.8696 35.2334 27.9317C35.3096 27.9583 35.3906 27.964 35.4704 27.972L35.4747 28.2211L35.4636 28.2255L35.3005 28.2032C35.1621 28.1672 35.0154 28.0332 34.9434 27.9134C34.841 27.743 34.8231 27.5653 34.8695 27.3742Z"
          fill="#32AEBE"
        />
        <path
          id="Vector_461"
          d="M34.8695 27.3742C34.885 27.2774 34.9323 27.1832 34.9944 27.1073C35.1217 26.9519 35.2899 26.8999 35.4804 26.8758L35.4704 27.972C35.3906 27.964 35.3096 27.9582 35.2334 27.9317C35.0557 27.8696 34.956 27.7432 34.9211 27.559C34.9112 27.5064 34.9072 27.4427 34.8816 27.3952L34.8695 27.3742Z"
          fill="#65ECF7"
        />
        <path
          id="Vector_462"
          d="M35.4837 26.7206C35.5856 26.7309 35.6827 26.7451 35.7806 26.777C36.0106 26.8868 36.1652 27.0243 36.25 27.2696C36.3244 27.4849 36.2997 27.7525 36.1978 27.9531C36.099 28.1476 35.9327 28.2873 35.7237 28.3501C35.6425 28.3746 35.5534 28.3817 35.469 28.3829L35.4636 28.2255L35.4747 28.2211L35.4704 27.972L35.4804 26.8758L35.4837 26.7206Z"
          fill="#65ECF7"
        />
        <path
          id="Vector_463"
          d="M35.8871 27.0177C36.0296 27.1536 36.1328 27.2981 36.139 27.5025C36.1449 27.7005 36.0898 27.8803 35.9519 28.0254C35.8146 28.1699 35.6661 28.2118 35.4747 28.2211L35.4704 27.972L35.5827 27.9522C35.6951 27.9297 35.793 27.8644 35.8543 27.7665C35.9822 27.5624 35.9339 27.2416 35.8871 27.0177Z"
          fill="#47667E"
        />
        <path
          id="Vector_464"
          d="M35.4804 26.8758C35.5769 26.8881 35.6623 26.9032 35.7542 26.9358L35.8871 27.0177C35.9339 27.2416 35.9822 27.5624 35.8543 27.7665C35.793 27.8644 35.6951 27.9297 35.5827 27.9522L35.4704 27.972L35.4804 26.8758Z"
          fill="#67C6CE"
        />
        <path
          id="Vector_465"
          d="M34.6965 29.6544L34.7384 29.6118C34.9418 29.4195 35.237 29.2988 35.5186 29.3058C35.813 29.2908 36.1061 29.4039 36.3231 29.6023C36.4479 29.7165 36.5443 29.849 36.6308 29.9935C36.7004 30.1578 36.7474 30.3154 36.7587 30.4945C36.7289 30.8109 36.5538 31.1076 36.3098 31.3096C36.1924 31.4068 36.0603 31.4659 35.9181 31.5167C35.8394 31.5446 35.7541 31.5642 35.671 31.5724L35.5194 31.5843C35.2284 31.5912 34.9326 31.4565 34.7257 31.2563C34.5058 31.0434 34.3851 30.744 34.3803 30.4395C34.3757 30.1451 34.4959 29.8651 34.6965 29.6544Z"
          fill="#F56D3B"
        />
        <path
          id="Vector_466"
          d="M35.121 29.5898C35.1545 29.5922 35.1817 29.6056 35.2124 29.6182C35.2304 29.6379 35.2492 29.6562 35.2566 29.6828C35.2708 29.7345 35.2619 29.7971 35.2386 29.8444L35.2298 29.8613C35.1646 29.9901 35.0641 30.0733 34.9315 30.1265C34.9087 30.1213 34.8839 30.116 34.8643 30.1024C34.8332 30.081 34.8011 30.0345 34.7927 29.9976C34.7771 29.9298 34.7882 29.8614 34.8232 29.802C34.8905 29.6876 34.9968 29.6252 35.121 29.5898Z"
          fill="#F3B275"
        />
        <path
          id="Vector_467"
          d="M35.5186 29.3058C35.813 29.2908 36.1061 29.4039 36.3231 29.6023C36.4479 29.7165 36.5443 29.849 36.6308 29.9935C36.7004 30.1578 36.7474 30.3154 36.7587 30.4945C36.7289 30.8109 36.5538 31.1076 36.3098 31.3096C36.1924 31.4068 36.0603 31.4659 35.9181 31.5167C35.8394 31.5446 35.7541 31.5642 35.671 31.5724L35.5194 31.5843C35.2284 31.5912 34.9326 31.4565 34.7257 31.2563C34.5058 31.0434 34.3851 30.744 34.3803 30.4395C34.3757 30.1451 34.4959 29.8651 34.6965 29.6544L34.6978 29.7024L34.6356 29.8156C34.5462 29.9937 34.4986 30.1897 34.5657 30.3845L34.5735 30.4062C34.62 30.5423 34.693 30.6652 34.8045 30.7584C34.9852 30.9097 35.1919 30.9599 35.4223 30.9342C35.659 30.9078 35.8632 30.7863 36.0108 30.6012C36.1701 30.4012 36.2276 30.1747 36.1954 29.9219C36.1615 29.6555 35.964 29.4642 35.7118 29.3909C35.6565 29.3748 35.5669 29.3745 35.5227 29.3401L35.5186 29.3058Z"
          fill="#D31D22"
        />
        <path
          id="Vector_468"
          d="M37.5104 20.4138L37.5268 20.9936L37.5429 22.0761L37.5697 30.6667C37.5781 30.6932 37.5758 30.7134 37.6022 30.7268C37.6326 30.7423 37.6556 30.741 37.689 30.7421L37.6895 30.7528C37.6585 30.8304 37.6725 30.9349 37.6724 31.0177C37.6724 31.2281 37.69 31.4521 37.6718 31.661C37.5527 31.6632 37.4181 31.6782 37.3015 31.6545C37.2618 31.6774 37.2438 31.7053 37.2176 31.742C37.0738 31.9437 36.9399 32.1133 36.7634 32.2887L36.7682 33.4961L36.7717 36.6451L36.7688 36.7768L36.6811 36.7781L36.5126 36.7792C36.4716 36.6696 36.4048 36.5691 36.3552 36.4624C36.298 36.3393 36.2602 36.214 36.2093 36.0894L36.1975 36.0612C36.1176 35.7493 36.0597 35.4216 35.9474 35.12C35.9094 35.018 35.922 34.8975 35.9218 34.7893C35.9215 34.6066 35.9222 34.424 35.9221 34.2413C35.922 33.7289 35.9199 33.2164 35.9188 32.7039C35.8995 32.6644 35.909 32.5962 35.9087 32.552C35.908 32.417 35.9061 32.2819 35.9111 32.1469L35.9182 31.5167C36.0604 31.4659 36.1925 31.4068 36.3098 31.3096C36.5538 31.1076 36.7289 30.811 36.7587 30.4945C36.7474 30.3154 36.7005 30.1578 36.6309 29.9935C36.5443 29.849 36.4479 29.7165 36.3231 29.6023C36.1061 29.4039 35.813 29.2908 35.5187 29.3058C35.5395 29.2355 35.5321 29.1582 35.5322 29.0852C35.5322 28.9546 35.5317 28.824 35.5311 28.6934C35.7233 28.6776 35.9027 28.6315 36.0677 28.5288C36.356 28.3495 36.5326 28.0671 36.6111 27.743L36.6121 27.7253L36.6135 27.6957C36.6207 27.5676 36.6097 27.4467 36.5966 27.3195C36.5429 27.1165 36.4608 26.9491 36.3209 26.7916C36.097 26.5396 35.8305 26.4468 35.5022 26.4258L35.4999 26.1124L35.4844 26.1041C35.46 25.9221 35.4702 25.7351 35.5444 25.5672L35.6261 25.5891C36.05 25.4529 36.3671 25.1251 36.6512 24.7946L36.7905 24.397C36.8126 24.2757 36.8388 24.151 36.8968 24.0413C36.9084 24.0194 36.9213 23.9974 36.9258 23.9728C36.9337 23.9296 36.9396 23.8663 36.9163 23.8275L36.8926 23.8445C36.8941 23.8883 36.9017 23.9447 36.8817 23.9847C36.8652 24.0177 36.8725 23.9883 36.8654 24.0235L36.8623 24.0413C36.8476 24.0866 36.8519 24.0484 36.8484 24.094L36.8472 24.1169H36.8321C36.8445 24.037 36.8523 23.959 36.8517 23.878C36.8513 23.8334 36.8393 23.7561 36.8549 23.7148C36.8724 23.6679 36.911 23.6285 36.9326 23.5838C36.9477 23.5523 36.9426 23.5257 36.9683 23.4963L36.9721 23.8905L36.9961 22.1204L36.9955 21.0077L37.4318 21.0099C37.4327 21.155 37.4103 21.3462 37.45 21.4842L37.4336 20.5486C37.4404 20.5283 37.4351 20.5379 37.45 20.5202L37.4702 21.1307L37.5094 21.1351C37.511 21.1235 37.5149 21.1007 37.5132 21.0896C37.4892 20.9324 37.4817 20.7294 37.4944 20.5674L37.4981 20.5447C37.497 20.498 37.4934 20.4787 37.5058 20.4309L37.5104 20.4138Z"
          fill="#C7A7A3"
        />
        <path
          id="Vector_469"
          d="M36.7587 30.4945C36.8493 30.5294 36.9211 30.5739 37.0007 30.6288C36.9648 31.1147 36.8761 31.4744 36.4958 31.8011C36.3132 31.958 36.1377 32.0469 35.9177 32.1381C35.9194 32.3188 35.9418 32.5263 35.9188 32.7039C35.8995 32.6644 35.909 32.5962 35.9087 32.552C35.908 32.417 35.9061 32.2819 35.9111 32.1469L35.9182 31.5167C36.0604 31.4659 36.1925 31.4068 36.3098 31.3096C36.5538 31.1076 36.7289 30.811 36.7587 30.4945Z"
          fill="#E2D4CA"
        />
        <path
          id="Vector_470"
          d="M36.6111 27.743C36.6288 27.7699 36.636 27.784 36.6373 27.8171C36.6561 28.2929 36.6339 28.7772 36.6362 29.2541C36.637 29.4172 36.6378 29.5803 36.6401 29.7435C36.641 29.8107 36.6527 29.899 36.6423 29.9646L36.6309 29.9935C36.5443 29.849 36.4479 29.7165 36.3231 29.6024C36.1061 29.4039 35.813 29.2908 35.5187 29.3058C35.5395 29.2355 35.5321 29.1582 35.5322 29.0852C35.5322 28.9546 35.5317 28.824 35.5312 28.6934C35.7233 28.6776 35.9027 28.6315 36.0677 28.5289C36.356 28.3495 36.5326 28.0671 36.6111 27.743Z"
          fill="#E2D4CA"
        />
        <path
          id="Vector_471"
          d="M35.6261 25.5891C36.05 25.4529 36.3671 25.1251 36.6512 24.7946C36.6238 25.3592 36.6345 25.9279 36.6352 26.4931C36.6354 26.664 36.6359 26.8349 36.6371 27.0058C36.6377 27.0987 36.65 27.21 36.6239 27.299L36.5966 27.3195C36.5429 27.1165 36.4608 26.9491 36.3209 26.7916C36.097 26.5396 35.8305 26.4468 35.5022 26.4258L35.4999 26.1124L35.4844 26.1041C35.46 25.9221 35.4702 25.7351 35.5444 25.5672L35.6261 25.5891Z"
          fill="#E2D4CA"
        />
        <path
          id="Vector_472"
          d="M35.5444 25.5672L35.6261 25.5891C35.7069 25.668 35.7581 25.7279 35.7579 25.8484C35.7578 25.9237 35.7312 25.9927 35.6741 26.0432C35.6232 26.0882 35.5648 26.1006 35.4999 26.1124L35.4844 26.1041C35.46 25.9221 35.4702 25.7351 35.5444 25.5672Z"
          fill="#D31D22"
        />
        <path
          id="Vector_473"
          d="M37.5104 20.4138L37.5268 20.9936L37.5429 22.0761L37.5697 30.6667C37.578 30.6932 37.5758 30.7134 37.6022 30.7268C37.6326 30.7423 37.6556 30.741 37.689 30.7421L37.6895 30.7528C37.6584 30.8304 37.6725 30.9349 37.6724 31.0177C37.6724 31.2281 37.69 31.4521 37.6718 31.661C37.5527 31.6632 37.418 31.6782 37.3015 31.6545C37.334 31.5771 37.3176 31.441 37.3176 31.3574C37.3176 31.1221 37.3171 30.8868 37.3167 30.6514L37.0122 30.6295L36.996 22.1204L36.9954 21.0076L37.4318 21.0099C37.4327 21.155 37.4102 21.3462 37.45 21.4842L37.4335 20.5486C37.4403 20.5283 37.4351 20.5379 37.4499 20.5202L37.4702 21.1307L37.5094 21.1351C37.511 21.1235 37.5149 21.1007 37.5132 21.0896C37.4892 20.9324 37.4817 20.7294 37.4944 20.5674L37.498 20.5447C37.4969 20.498 37.4934 20.4787 37.5058 20.4309L37.5104 20.4138Z"
          fill="#797388"
        />
        <path
          id="Vector_474"
          d="M37.5104 20.4138L37.5268 20.9936L37.5429 22.0761L37.5697 30.6667C37.5316 30.6646 37.5301 30.666 37.5019 30.6409L37.45 21.4842L37.4335 20.5486C37.4403 20.5283 37.4351 20.5379 37.4499 20.5202L37.4702 21.1307L37.5094 21.1351C37.511 21.1235 37.5149 21.1007 37.5132 21.0896C37.4891 20.9324 37.4817 20.7294 37.4944 20.5674L37.498 20.5447C37.4969 20.498 37.4934 20.4787 37.5058 20.4309L37.5104 20.4138Z"
          fill="url(#paint24_linear_11_402)"
        />
        <path
          id="Vector_475"
          d="M35.4588 16.174L35.9693 16.1772L36.0298 16.1791L36.2279 16.1823C36.2847 16.3463 36.3412 16.5105 36.3945 16.6757C36.4246 16.769 36.4466 16.8749 36.4909 16.9621C36.5595 17.2242 36.6542 17.4818 36.7387 17.7393C36.8576 18.1022 36.9714 18.4667 37.0912 18.8293C37.2328 19.2578 37.4045 19.6966 37.4814 20.1421C37.496 20.2266 37.5194 20.3286 37.5104 20.4138L37.5058 20.4309C37.4934 20.4787 37.4969 20.498 37.4981 20.5447L37.4944 20.5674C37.4817 20.7294 37.4892 20.9324 37.5132 21.0896C37.5149 21.1007 37.511 21.1235 37.5094 21.1351L37.4702 21.1307L37.45 20.5202C37.4351 20.5379 37.4403 20.5283 37.4336 20.5486L37.45 21.4842C37.4102 21.3462 37.4327 21.155 37.4318 21.0099L36.9954 21.0077L36.996 22.1204L36.9721 23.8905L36.9683 23.4963C36.9426 23.5257 36.9477 23.5523 36.9326 23.5838C36.911 23.6285 36.8724 23.6679 36.8548 23.7148C36.8393 23.7561 36.8513 23.8334 36.8516 23.878C36.8522 23.959 36.8445 24.037 36.832 24.1169H36.8472L36.8484 24.094C36.8519 24.0484 36.8475 24.0866 36.8623 24.0413L36.8654 24.0235C36.8724 23.9883 36.8652 24.0177 36.8817 23.9847C36.9017 23.9447 36.8941 23.8883 36.8926 23.8445L36.9163 23.8275C36.9395 23.8663 36.9336 23.9296 36.9257 23.9728C36.9213 23.9974 36.9084 24.0194 36.8968 24.0413C36.8388 24.151 36.8126 24.2757 36.7905 24.397L36.7381 24.3608C36.6802 24.5361 36.5796 24.6991 36.4519 24.8323C36.2137 25.0808 35.8525 25.2465 35.5053 25.2493C35.1503 25.2522 34.8239 25.125 34.5716 24.8748C34.3736 24.6785 34.2327 24.4113 34.1772 24.1386C34.1377 23.9441 34.1527 23.7372 34.1526 23.5395C34.1525 23.2492 34.1526 22.9588 34.1526 22.6685C34.1529 21.5925 34.1529 20.5165 34.1513 19.4405C34.2447 19.3761 34.3193 19.2827 34.3936 19.1982C34.4976 19.08 34.6029 18.9631 34.6948 18.835L35.0164 18.8304C35.1322 18.8294 35.2941 18.8489 35.4034 18.8172L35.4345 18.7766C35.4477 18.691 35.4396 18.5946 35.4398 18.5078C35.44 18.3419 35.4402 18.1761 35.4404 18.0102C35.4411 17.4198 35.442 16.8293 35.4431 16.2388L35.3103 16.2361L35.4319 16.2199L35.4419 16.1796L35.4588 16.174Z"
          fill="#130B24"
        />
        <path
          id="Vector_476"
          d="M34.7841 19.083C34.9553 19.0784 35.1744 19.0548 35.3402 19.0932L35.3088 19.1672C35.1585 19.1885 35.0027 19.1721 34.8511 19.1799C34.8239 19.1508 34.8048 19.1168 34.7841 19.083Z"
          fill="#ED3131"
        />
        <path
          id="Vector_477"
          d="M34.3609 19.6087C34.3663 19.5787 34.739 19.1164 34.784 19.083C34.8047 19.1168 34.8239 19.1508 34.851 19.1799L34.5006 19.614C34.4424 19.6296 34.4174 19.6307 34.3609 19.6087Z"
          fill="#D31D22"
        />
        <path
          id="Vector_478"
          d="M36.1305 19.1766L35.7574 19.1743C35.7348 19.1447 35.7351 19.1367 35.731 19.0991C35.7727 19.0704 35.8186 19.081 35.8688 19.081C35.9909 19.0809 36.1131 19.0795 36.2352 19.0825C36.3022 19.2063 36.4052 19.3115 36.4967 19.4176C36.5338 19.4606 36.5993 19.5226 36.6184 19.5759C36.6227 19.588 36.615 19.6384 36.6126 19.6534C36.5736 19.6467 36.5417 19.6336 36.5058 19.6181L36.1305 19.1766Z"
          fill="#D31D22"
        />
        <path
          id="Vector_479"
          d="M36.3504 22.5787L36.4158 22.5983C36.4281 22.6416 36.4485 22.6928 36.4463 22.7381C36.4274 22.7504 36.4246 22.7537 36.4007 22.7615C36.3488 22.7784 36.2528 22.7652 36.1952 22.7654C36.0713 22.7659 35.9475 22.7662 35.8237 22.7665C35.7704 22.7666 35.7055 22.7788 35.6626 22.7471L35.6616 22.7244C35.6615 22.6739 35.6692 22.6362 35.7056 22.5989C35.9142 22.5652 36.1386 22.5985 36.3504 22.5787Z"
          fill="#F3B275"
        />
        <path
          id="Vector_480"
          d="M36.3583 20.7385C36.4342 20.774 36.4337 20.7785 36.4695 20.855L36.4611 20.9247C36.3134 20.9498 36.1414 20.9342 35.9909 20.9345C35.8945 20.9347 35.7685 20.9498 35.6766 20.9231L35.6684 20.8737C35.6862 20.8036 35.7108 20.79 35.7682 20.755C35.9589 20.752 36.1716 20.7725 36.3583 20.7385Z"
          fill="#F3B275"
        />
        <path
          id="Vector_481"
          d="M36.4423 23.9756C36.4869 24.0567 36.464 24.213 36.4715 24.3092C36.3375 24.6086 36.1273 24.8172 35.8175 24.9347C35.7435 24.9628 35.6702 24.9845 35.5917 24.9964L35.611 24.9016L35.7579 24.8239L35.7898 24.8085C35.8858 24.7645 35.9979 24.7142 36.0678 24.6327L36.1031 24.6106C36.3135 24.4558 36.3991 24.2234 36.4423 23.9756Z"
          fill="#D31D22"
        />
        <path
          id="Vector_482"
          d="M36.5569 22.7786L36.5738 22.7723C36.5906 22.7379 36.5968 22.6998 36.6051 22.6626C36.6055 22.9446 36.6059 23.2265 36.6053 23.5085C36.6048 23.693 36.6197 23.9024 36.5761 24.0826C36.5568 24.1626 36.5158 24.2406 36.4715 24.3092C36.464 24.213 36.4868 24.0567 36.4422 23.9756L36.4325 23.9353C36.4706 23.8727 36.4541 22.9941 36.4561 22.8606C36.4882 22.8091 36.5042 22.8052 36.5569 22.7786Z"
          fill="#420D27"
        />
        <path
          id="Vector_483"
          d="M34.3609 19.6087C34.4174 19.6307 34.4424 19.6296 34.5006 19.614L34.5001 20.7519C34.4592 20.7923 34.4419 20.8154 34.4404 20.8741L34.4415 20.9226L34.5018 20.9308L34.4983 22.5808L34.4609 22.6279L34.3787 22.6273L34.3782 20.9139C34.376 20.6267 34.3759 20.3395 34.3756 20.0522C34.3754 19.915 34.3959 19.741 34.3609 19.6087Z"
          fill="#9F2B44"
        />
        <path
          id="Vector_484"
          d="M36.5058 19.6181C36.5417 19.6336 36.5736 19.6467 36.6126 19.6534C36.5936 19.9088 36.6069 20.1742 36.6066 20.4307C36.6059 20.9296 36.6057 21.4284 36.6075 21.9272C36.608 22.0853 36.6086 22.2434 36.6093 22.4015C36.6096 22.486 36.6179 22.5797 36.6051 22.6626C36.5968 22.6998 36.5907 22.7379 36.5739 22.7723L36.557 22.7786L36.545 22.7453C36.5073 22.7293 36.4858 22.7333 36.4463 22.7381C36.4485 22.6928 36.4281 22.6416 36.4158 22.5983L36.3504 22.5787L36.3471 21.0355C36.4037 21.0374 36.494 21.053 36.5417 21.0208C36.5447 20.9869 36.5434 20.9696 36.5299 20.9382L36.4611 20.9247L36.4695 20.855C36.4338 20.7785 36.4343 20.774 36.3584 20.7385C36.3497 20.5415 36.3579 20.3409 36.3585 20.1436C36.359 20.0018 36.3391 19.823 36.3834 19.6878C36.409 19.7608 36.3857 19.8004 36.3817 19.8711C36.3695 20.084 36.3843 20.3015 36.3847 20.5144C36.3848 20.5768 36.3646 20.6748 36.3931 20.7302L36.4309 20.7265C36.4713 20.7523 36.4724 20.7574 36.4913 20.802L36.5066 20.8022L36.5068 20.7415C36.4784 20.6989 36.492 20.6175 36.4921 20.566C36.4925 20.4012 36.4926 20.2365 36.4926 20.0717C36.4927 20.0076 36.5043 19.9183 36.4841 19.8575L36.4765 19.8408C36.5064 19.7958 36.5004 19.6767 36.5058 19.6181Z"
          fill="url(#paint25_linear_11_402)"
        />
        <path
          id="Vector_485"
          d="M35.7543 19.2793L36.05 19.2809C36.1751 19.3985 36.2993 19.5378 36.3834 19.6878C36.339 19.823 36.3589 20.0018 36.3585 20.1436C36.3578 20.3409 36.3497 20.5415 36.3583 20.7385C36.1716 20.7725 35.9589 20.752 35.7682 20.755L35.7543 19.2793Z"
          fill="#5F112B"
        />
        <path
          id="Vector_486"
          d="M35.7736 21.0307L36.3471 21.0355L36.3504 22.5787C36.1386 22.5985 35.9142 22.5652 35.7056 22.5989L35.7714 22.5748C35.8082 22.5153 35.7776 22.2762 35.777 22.1971C35.7741 21.8083 35.7742 21.4195 35.7736 21.0307Z"
          fill="#5F112B"
        />
        <path
          id="Vector_487"
          d="M35.7741 22.8839L36.3474 22.8815C36.3485 23.1315 36.3599 23.3808 36.3627 23.6306C36.3645 23.7907 36.3718 23.9588 36.3276 24.1142L36.32 24.1396C36.2946 24.2262 36.262 24.3069 36.2189 24.3862C36.1814 24.4551 36.0674 24.5584 36.0678 24.6327C35.9979 24.7142 35.8858 24.7645 35.7898 24.8085L35.7579 24.8239L35.7741 22.8839Z"
          fill="#5F112B"
        />
        <path
          id="Vector_488"
          d="M35.4345 18.7766L35.634 18.7888L35.636 18.8041C35.6086 18.8078 35.5834 18.81 35.5571 18.8187L35.553 20.8923C35.5604 21.8485 35.5548 22.8051 35.5572 23.7614C35.5578 24.0253 35.5585 24.2892 35.5594 24.5532C35.5599 24.7009 35.5498 24.8601 35.5703 25.006L35.3937 25.0056L35.3928 24.9088L35.4069 19.0893L35.4034 18.8172L35.4345 18.7766Z"
          fill="#FBFAFB"
        />
        <path
          id="Vector_489"
          d="M35.4588 16.174L35.9693 16.1772L36.0298 16.1791L36.2279 16.1823C36.2847 16.3463 36.3412 16.5105 36.3945 16.6757C36.4246 16.769 36.4466 16.8749 36.4909 16.9621C36.5595 17.2242 36.6542 17.4818 36.7386 17.7393C36.8576 18.1022 36.9714 18.4667 37.0912 18.8293C37.2328 19.2578 37.4045 19.6966 37.4814 20.1421C37.496 20.2266 37.5194 20.3286 37.5104 20.4138L37.5058 20.4309C37.4934 20.4787 37.4969 20.498 37.498 20.5447L37.4944 20.5674C37.4817 20.7294 37.4891 20.9324 37.5132 21.0896C37.5149 21.1007 37.511 21.1235 37.5094 21.1351L37.4702 21.1307L37.4499 20.5202C37.4351 20.5379 37.4403 20.5283 37.4335 20.5486L37.45 21.4842C37.4102 21.3462 37.4327 21.155 37.4318 21.0099L36.9954 21.0077L36.996 22.1204L36.972 23.8905L36.9683 23.4963C36.9425 23.5257 36.9477 23.5523 36.9325 23.5838C36.911 23.6285 36.8724 23.6679 36.8548 23.7148C36.8393 23.7561 36.8513 23.8334 36.8516 23.878C36.8522 23.959 36.8445 24.037 36.832 24.1169H36.8472L36.8483 24.094C36.8519 24.0484 36.8475 24.0866 36.8623 24.0413L36.8654 24.0235C36.8724 23.9883 36.8652 24.0177 36.8817 23.9847C36.9017 23.9447 36.8941 23.8883 36.8926 23.8445L36.9163 23.8275C36.9395 23.8663 36.9336 23.9296 36.9257 23.9728C36.9212 23.9974 36.9083 24.0194 36.8968 24.0413C36.8388 24.151 36.8126 24.2757 36.7905 24.397L36.7381 24.3608C36.7753 24.2498 36.8081 24.14 36.8186 24.0227C36.8352 23.8365 36.8273 23.6435 36.8278 23.4566C36.8286 23.1338 36.8283 22.8111 36.8283 22.4884C36.8281 21.4674 36.8279 20.4465 36.8213 19.4256L36.2581 18.8238L35.5572 18.8187C35.5834 18.81 35.6086 18.8078 35.636 18.8041L35.634 18.7888L35.4345 18.7766C35.4477 18.691 35.4396 18.5946 35.4398 18.5078C35.44 18.3419 35.4402 18.1761 35.4404 18.0102C35.4411 17.4198 35.442 16.8293 35.4431 16.2388L35.3102 16.2361L35.4319 16.2199L35.4419 16.1796L35.4588 16.174Z"
          fill="url(#paint26_linear_11_402)"
        />
        <path
          id="Vector_490"
          d="M35.4588 16.174L35.9693 16.1772L35.9968 16.2004L35.9844 16.2171L35.4431 16.2388L35.3102 16.2361L35.4319 16.2199L35.4419 16.1796L35.4588 16.174Z"
          fill="#FBFAFB"
        />
        <path
          id="Vector_491"
          d="M36.9642 19.3308L36.9829 19.3285L36.9872 19.3641L37.0235 19.3414L37.0294 19.3653C37.0562 19.462 37.1341 19.559 37.1813 19.648C37.3264 19.9214 37.402 20.2071 37.4233 20.5149C37.4249 20.5392 37.4221 20.5302 37.4335 20.5486L37.45 21.4842C37.4102 21.3462 37.4327 21.155 37.4318 21.0099L36.9954 21.0077C36.9955 20.6515 36.9952 20.2954 36.9912 19.9393C36.9889 19.7389 36.9993 19.5285 36.9642 19.3308Z"
          fill="#8E8796"
        />
        <path
          id="Vector_492"
          d="M36.0298 16.1791L36.2279 16.1823C36.2847 16.3463 36.3412 16.5105 36.3946 16.6757C36.4246 16.769 36.4466 16.8749 36.4909 16.9621C36.5595 17.2242 36.6542 17.4818 36.7387 17.7393C36.8576 18.1022 36.9714 18.4666 37.0912 18.8293C37.2328 19.2578 37.4045 19.6966 37.4814 20.1421C37.496 20.2266 37.5194 20.3286 37.5104 20.4138L37.5058 20.4309C37.4935 20.4787 37.497 20.498 37.4981 20.5447L37.4944 20.5674C37.4817 20.7294 37.4892 20.9324 37.5132 21.0896C37.5149 21.1007 37.511 21.1235 37.5094 21.1351L37.4702 21.1307L37.45 20.5202C37.4351 20.5379 37.4403 20.5283 37.4336 20.5486C37.4222 20.5301 37.425 20.5392 37.4233 20.5149C37.4021 20.2071 37.3264 19.9214 37.1813 19.648C37.1341 19.559 37.0562 19.462 37.0295 19.3653L37.0235 19.3414L36.9872 19.3641L36.9829 19.3285L36.9643 19.3308C36.8996 19.191 36.8685 19.0098 36.8263 18.8599C36.7616 18.6302 36.6926 18.4016 36.6246 18.173C36.4767 17.6757 36.3154 17.1821 36.1669 16.6848C36.1204 16.5294 36.0346 16.3397 36.0298 16.1791Z"
          fill="url(#paint27_linear_11_402)"
        />
        <path
          id="Vector_493"
          d="M35.3402 19.0932L35.4069 19.0893L35.3929 24.9088L35.3938 25.0056C35.1256 24.9516 34.8905 24.859 34.6927 24.6629C34.3404 24.3136 34.3796 23.8488 34.3791 23.3947C34.3788 23.1389 34.3787 22.8831 34.3788 22.6272L34.4609 22.6279L34.4983 22.5808L34.5018 20.9308L34.4415 20.9226L34.4404 20.8741C34.4419 20.8154 34.4592 20.7923 34.5001 20.7519L34.5006 19.614L34.8511 19.1799C35.0027 19.1721 35.1585 19.1885 35.3089 19.1672L35.3402 19.0932Z"
          fill="#250C28"
        />
        <path
          id="Vector_494"
          d="M34.6426 20.7498C34.8383 20.7502 35.0666 20.7307 35.2566 20.7755L35.2578 20.908C35.218 20.9458 35.1071 20.9297 35.0502 20.9298C34.8674 20.9302 34.6846 20.9305 34.5018 20.9308L34.4415 20.9226L34.4404 20.8741C34.4419 20.8154 34.4592 20.7923 34.5001 20.7519L34.6426 20.7498Z"
          fill="#F3B275"
        />
        <path
          id="Vector_495"
          d="M34.6563 22.5819C34.8358 22.582 35.0726 22.5544 35.2444 22.5953C35.2717 22.6586 35.271 22.6985 35.2607 22.7662L34.497 22.7725C34.498 23.0097 34.4991 23.247 34.5005 23.4842C34.5029 23.9079 34.495 24.2665 34.818 24.5845C34.8798 24.6454 34.9494 24.6952 35.0255 24.7365C35.1099 24.7975 35.2111 24.8392 35.3073 24.8783L35.3929 24.9088L35.3938 25.0056C35.1256 24.9516 34.8905 24.859 34.6927 24.6629C34.3404 24.3136 34.3796 23.8488 34.3791 23.3947C34.3788 23.1389 34.3787 22.8831 34.3788 22.6273L34.4609 22.628L34.4983 22.5808L34.6563 22.5819Z"
          fill="#D31D22"
        />
        <path
          id="Vector_496"
          d="M34.6563 22.5819C34.8358 22.582 35.0726 22.5544 35.2443 22.5953C35.2717 22.6586 35.271 22.6985 35.2607 22.7662L34.4783 22.7588C34.4482 22.7116 34.4583 22.6829 34.4609 22.6279L34.4983 22.5808L34.6563 22.5819Z"
          fill="#F3B275"
        />
        <path
          id="Vector_497"
          d="M34.9632 19.2813L35.2704 19.2808L35.2566 20.7755C35.0666 20.7307 34.8383 20.7502 34.6426 20.7498L34.64 19.6549C34.7373 19.5213 34.8442 19.3961 34.9632 19.2813Z"
          fill="#5F112B"
        />
        <path
          id="Vector_498"
          d="M34.6526 21.0211L35.2564 21.0227L35.2443 22.5952C35.0726 22.5543 34.8358 22.582 34.6563 22.5819L34.6526 21.0211Z"
          fill="#5F112B"
        />
        <path
          id="Vector_499"
          d="M34.6564 22.8969L35.2671 22.8995C35.274 23.0491 35.2743 23.2121 35.3037 23.358C35.3117 23.3979 35.3002 23.437 35.2912 23.476C35.2658 23.5859 35.2782 23.7148 35.2786 23.8284C35.2788 23.8751 35.2709 23.9396 35.2804 23.9845C35.2854 24.0077 35.2957 24.0202 35.2962 24.0454C35.2979 24.1438 35.2953 24.2427 35.2951 24.3412C35.295 24.3887 35.2872 24.4449 35.3032 24.4897C35.3184 24.5323 35.3083 24.5862 35.3061 24.6316C35.302 24.7148 35.3028 24.7952 35.3072 24.8783C35.211 24.8392 35.1098 24.7975 35.0255 24.7365C35.0129 24.6426 34.9134 24.593 34.8557 24.5243C34.768 24.4197 34.693 24.3049 34.6643 24.1699L34.6603 24.1527C34.6307 24.0121 34.6469 23.838 34.6477 23.6935C34.649 23.4281 34.6482 23.1622 34.6564 22.8969Z"
          fill="#5F112B"
        />
        <path
          id="Vector_500"
          d="M39.2478 30.5453L39.0644 30.3145C39.0421 30.2808 39.0383 30.2888 39.0466 30.2473C39.1279 30.2386 39.18 30.2931 39.2404 30.3409L39.2588 30.3645C39.2646 30.4295 39.2707 30.4829 39.2478 30.5453Z"
          fill="#473250"
        />
        <path
          id="Vector_501"
          d="M39.2786 33.8356C39.2026 33.7817 39.1278 33.7099 39.0888 33.6239L39.0799 33.6033C39.0186 33.4646 39.0105 33.2789 39.0617 33.135L39.0689 33.1157C39.1084 33.0014 39.1627 32.9383 39.257 32.8661L39.2517 32.889C39.2399 32.9358 39.2084 32.9757 39.188 33.0193C39.0925 33.2239 39.0389 33.3896 39.1393 33.6077L39.1501 33.6314C39.1849 33.7055 39.2382 33.7564 39.2899 33.818L39.2786 33.8356Z"
          fill="#434D6A"
        />
        <path
          id="Vector_502"
          d="M39.4124 35.9352L39.4089 36.1272L39.4051 36.1478C39.2818 36.26 39.1766 36.382 39.1661 36.5569C39.1602 36.6566 39.2098 36.7733 39.2782 36.8454C39.3249 36.8947 39.3781 36.9222 39.428 36.9632L39.4458 36.9844L39.3843 37.0017C39.2862 36.9619 39.207 36.9174 39.1368 36.8355C39.0541 36.7389 39.0221 36.6103 39.0346 36.486C39.06 36.2331 39.2281 36.0862 39.4124 35.9352Z"
          fill="url(#paint28_linear_11_402)"
        />
        <path
          id="Vector_503"
          d="M39.0907 23.2687C39.1165 23.413 39.1031 23.5757 39.1036 23.7228C39.1043 23.9931 39.1047 24.2633 39.1049 24.5336L39.4787 24.533L39.4784 25.8244L39.1029 25.4638C39.1017 25.6426 39.1256 25.867 39.0899 26.0398L39.0907 23.2687Z"
          fill="#1B1536"
        />
        <path
          id="Vector_504"
          d="M36.4844 15.1726C36.5603 15.2619 36.6213 15.3703 36.6875 15.4674L34.7036 15.4685C34.6615 15.465 34.6211 15.4639 34.5806 15.4512C34.5916 15.398 34.628 15.3595 34.6491 15.3106L34.7171 15.1772L36.4844 15.1726Z"
          fill="#130B24"
        />
        <path
          id="Vector_505"
          d="M35.4704 14.3395L35.8704 14.3396C36.0225 14.4337 36.1073 14.6088 36.2029 14.7548C36.2949 14.8953 36.3894 15.0341 36.4845 15.1726L34.7172 15.1772L34.7294 15.1655L35.4711 15.1647L35.4704 14.3395Z"
          fill="#797388"
        />
        <path
          id="Vector_506"
          d="M35.0488 14.3072C35.0782 14.3255 35.1045 14.3428 35.137 14.3551C35.2414 14.3287 35.3627 14.339 35.4703 14.3395L35.471 15.1647L34.7294 15.1655L34.7171 15.1772L34.4301 15.1689L34.702 14.6938C34.7917 14.5559 34.8985 14.3852 35.0488 14.3072Z"
          fill="#9D9BA7"
        />
        <path
          id="Vector_507"
          d="M35.0488 14.3072C35.0782 14.3255 35.1045 14.3428 35.137 14.3551C35.1318 14.514 34.986 14.7047 34.9099 14.8457C34.8531 14.9507 34.8041 15.0734 34.7294 15.1655L34.7171 15.1772L34.4301 15.1689L34.702 14.6938C34.7917 14.5559 34.8985 14.3852 35.0488 14.3072Z"
          fill="#B3BDCA"
        />
        <path
          id="Vector_508"
          d="M35.4694 15.7967L36.4861 15.7886C36.5032 15.8504 36.5176 15.9111 36.5477 15.9682C36.5951 16.1858 36.6887 16.4065 36.7662 16.6159C36.7963 16.697 36.8389 16.7877 36.8562 16.8723C36.8665 16.9571 36.8759 17.0173 36.9153 17.0937L36.8827 17.136L36.8621 17.1228L36.8371 17.1199L36.8166 17.1056C36.7598 17.137 36.7494 17.1592 36.7187 17.2149L36.705 17.2367C36.6904 17.2611 36.6839 17.282 36.6766 17.3091L36.6554 17.3165C36.5487 17.2234 36.5911 17.0538 36.4909 16.9621C36.4466 16.8749 36.4246 16.769 36.3946 16.6757C36.3412 16.5105 36.2848 16.3463 36.2279 16.1823L36.0298 16.1791L35.9693 16.1772L35.4588 16.174L35.4694 15.7967Z"
          fill="#D31D22"
        />
        <path
          id="Vector_509"
          d="M35.8766 13.8898L35.8722 14.0961C36.175 14.2292 36.3876 14.4883 36.6348 14.6981C36.9042 14.9824 37.1777 15.301 37.3953 15.6257C37.5197 15.8114 37.6222 16.0096 37.7411 16.1985L37.4999 16.176C37.3669 16.1506 37.208 16.1633 37.0716 16.16C37.0207 16.0543 36.7742 15.5065 36.6876 15.4674C36.6214 15.3703 36.5603 15.2619 36.4845 15.1726C36.3894 15.0341 36.2949 14.8953 36.2029 14.7548C36.1073 14.6089 36.0225 14.4337 35.8704 14.3396C35.8534 14.2011 35.8515 14.0267 35.8766 13.8898Z"
          fill="#88051B"
        />
        <path
          id="Vector_510"
          d="M36.5477 15.9682L36.5488 15.9459C36.5492 15.898 36.5366 15.8597 36.5159 15.8172C36.5505 15.7974 36.5582 15.7916 36.5975 15.7917L36.5983 15.8111C36.6018 15.8437 36.6145 15.8613 36.6278 15.8901L36.636 15.911C36.6488 15.943 36.6359 15.9131 36.6581 15.9507L36.6807 15.996L36.6931 16.0197C36.709 16.0516 36.7171 16.0845 36.7338 16.1172L36.791 16.2307C36.8095 16.2678 36.8206 16.3067 36.8397 16.3442C36.8655 16.3947 36.8862 16.4436 36.9078 16.4956C36.9226 16.5312 36.9389 16.5653 36.9532 16.6015C36.9642 16.6293 36.976 16.6502 36.9985 16.6697L36.9911 16.7L37.0062 16.7227C37.0494 16.7944 37.0741 16.8871 37.1051 16.9648C37.1349 17.0396 37.1741 17.1142 37.1954 17.1918C37.2047 17.2259 37.2277 17.2524 37.237 17.2827L37.2408 17.3129L37.2634 17.3507L37.2642 17.3735L37.3013 17.4454L37.309 17.4719C37.3214 17.5122 37.337 17.5473 37.3544 17.5855L37.536 18.0396L37.5587 18.101C37.5743 18.1478 37.5561 18.097 37.5814 18.1455C37.5892 18.1603 37.5926 18.1807 37.6003 18.197C37.6162 18.2303 37.6084 18.2118 37.6197 18.2472C37.6317 18.2852 37.6513 18.3201 37.6658 18.3574L37.6874 18.4028L37.7101 18.4633L37.7209 18.4842C37.7373 18.5171 37.7297 18.5001 37.7406 18.5353C37.7501 18.5658 37.7649 18.5802 37.7782 18.6072C37.802 18.6554 37.8019 18.7055 37.8462 18.7434L37.8412 18.7737C37.8576 18.8041 37.871 18.8326 37.8842 18.8645L37.9194 18.9416C37.9346 18.9728 37.9453 19.0065 37.9599 19.0386L38.0771 19.3138L38.2537 19.7273C38.2932 19.8321 38.3548 19.9278 38.3988 20.03C38.4674 20.1894 38.5283 20.3549 38.5925 20.5167C38.6559 20.6766 38.7261 20.8491 38.7559 21.0194L38.3842 21.0211L38.3669 21.0102L36.8562 16.8723C36.8389 16.7877 36.7962 16.697 36.7662 16.6159C36.6887 16.4065 36.595 16.1858 36.5477 15.9682Z"
          fill="#8E8796"
        />
        <path
          id="Vector_511"
          d="M36.8562 16.8723L38.3669 21.0102L37.5268 20.9936L37.5104 20.4138C37.5194 20.3286 37.496 20.2266 37.4814 20.1421C37.4045 19.6966 37.2328 19.2578 37.0912 18.8293C36.9714 18.4666 36.8575 18.1022 36.7386 17.7393C36.6542 17.4818 36.5595 17.2242 36.4909 16.9621C36.5911 17.0538 36.5486 17.2234 36.6554 17.3165L36.6766 17.3091C36.6839 17.282 36.6903 17.2611 36.7049 17.2367L36.7187 17.2149C36.7494 17.1592 36.7598 17.137 36.8166 17.1056L36.837 17.1199L36.8621 17.1228L36.8827 17.1359L36.9153 17.0937C36.8759 17.0173 36.8665 16.9571 36.8562 16.8723Z"
          fill="url(#paint29_linear_11_402)"
        />
        <path
          id="Vector_512"
          d="M39.1029 25.4638L39.4784 25.8244L39.673 26.0305C39.6702 26.2665 39.664 26.5024 39.6622 26.7384C39.6615 26.8323 39.6811 26.9824 39.6514 27.0697C39.6229 27.6676 39.6454 28.2768 39.648 28.8758C39.6485 29.0116 39.6509 29.1475 39.6535 29.2833C39.6549 29.3516 39.667 29.4356 39.6436 29.5002L39.2573 29.1173C39.2121 29.0574 39.1466 29.0067 39.0912 28.9559L39.0899 26.0398C39.1256 25.867 39.1017 25.6426 39.1029 25.4638Z"
          fill="#130B24"
        />
        <path
          id="Vector_513"
          d="M37.5268 20.9936L38.3669 21.0102L38.3842 21.0211L38.7559 21.0194L38.8414 32.9041C38.8431 33.0506 38.8386 33.2185 38.8609 33.3615C38.8953 33.5819 38.8922 33.8221 38.8964 34.045C38.9017 34.3252 38.9102 34.6048 38.913 34.8853C38.9186 35.4258 38.9241 35.9724 38.9436 36.5123C38.9478 36.6277 38.9636 36.7431 38.9678 36.8588C38.9776 37.1284 38.965 37.3982 38.9838 37.6677L38.961 37.6763L37.971 38.4963L38.5825 37.4383C38.5705 37.2879 38.5773 37.1341 38.5736 36.9832C38.5655 36.6485 38.5582 36.3144 38.5541 35.9795C38.54 34.8245 38.5531 33.6723 38.5618 32.5176C38.5649 32.0975 38.5665 31.6776 38.562 31.2576C38.5602 31.0851 38.5738 30.9022 38.5506 30.7317L38.4895 30.7318L38.4724 30.6598C38.4455 30.4514 38.4678 30.2139 38.4671 30.0027C38.4657 29.5468 38.4608 29.0909 38.4579 28.635C38.4469 26.9253 38.4501 25.2152 38.4542 23.5055L38.4536 22.0715L37.5428 22.0761L37.5268 20.9936Z"
          fill="#797388"
        />
        <path
          id="Vector_514"
          d="M37.5268 20.9936L38.3669 21.0102L38.3842 21.0211L38.4322 21.1307C38.4643 21.2064 38.4584 21.3107 38.4609 21.3926C38.4667 21.5893 38.4622 21.786 38.4635 21.9827C38.4656 22.3099 38.4652 22.637 38.4635 22.9643C38.4626 23.1423 38.4731 23.3285 38.4542 23.5055L38.4536 22.0715L37.5428 22.0761L37.5268 20.9936Z"
          fill="#56334E"
        />
        <path
          id="Vector_515"
          d="M37.9241 21.4288L37.958 21.4282C38.0137 21.4285 38.0484 21.4405 38.0869 21.4832C38.1186 21.5184 38.124 21.5619 38.1214 21.6073C38.1172 21.6805 38.0799 21.7063 38.0287 21.7523C37.959 21.753 37.9165 21.7513 37.8655 21.6985C37.8299 21.6617 37.8243 21.6208 37.8285 21.5718C37.8342 21.5049 37.8762 21.4705 37.9241 21.4288Z"
          fill="#130B24"
        />
        <path
          id="Vector_516"
          d="M37.5428 22.0761L38.4536 22.0715L38.4542 23.5055C38.4501 25.2152 38.4469 26.9253 38.4579 28.635C38.4609 29.0909 38.4657 29.5468 38.4672 30.0027C38.4678 30.2139 38.4455 30.4514 38.4724 30.6598L38.4592 30.7394C38.3907 30.7722 38.2214 30.74 38.1391 30.7384C37.9893 30.7355 37.8389 30.7399 37.689 30.7421C37.6556 30.741 37.6326 30.7423 37.6022 30.7268C37.5758 30.7134 37.578 30.6932 37.5697 30.6667L37.5428 22.0761Z"
          fill="#130B24"
        />
        <path
          id="Vector_517"
          d="M37.7557 25.7445L38.2555 25.7456L38.2554 26.6094L37.7556 26.61L37.7557 25.7445Z"
          fill="#D31D22"
        />
        <path
          id="Vector_518"
          d="M37.7599 27.8215L38.2547 27.822L38.2555 28.7004L37.7608 28.7013L37.7599 27.8215Z"
          fill="#D31D22"
        />
        <path
          id="Vector_519"
          d="M37.7606 28.8447L38.242 28.8458L38.2383 29.7587L37.7596 29.7658L37.7606 28.8447Z"
          fill="#ED3131"
        />
        <path
          id="Vector_520"
          d="M37.7552 23.7484L38.26 23.7496L38.2636 24.6359L37.7534 24.6353L37.7552 23.7484Z"
          fill="#D31D22"
        />
        <path
          id="Vector_521"
          d="M37.7556 22.747L38.2566 22.7465L38.2579 23.6493L37.755 23.6455L37.7556 22.747Z"
          fill="#D31D22"
        />
        <path
          id="Vector_522"
          d="M37.7545 24.7349L38.2622 24.7353L38.2597 25.6435L37.7535 25.6417L37.7545 24.7349Z"
          fill="#D31D22"
        />
        <path
          id="Vector_523"
          d="M37.7612 26.7286L38.2542 26.7294L38.2533 27.6871L37.7601 27.6864L37.7612 26.7286Z"
          fill="#ED3131"
        />
        <path
          id="Vector_524"
          d="M39.2411 29.7516C39.2406 29.6152 39.2401 29.4788 39.2404 29.3425C39.2405 29.2695 39.231 29.1859 39.2573 29.1173L39.6435 29.5002C40.3484 30.2116 41.0653 30.9108 41.7734 31.619C41.9536 31.7992 42.135 31.9783 42.3147 32.1591C42.396 32.2409 42.5223 32.343 42.5715 32.4471L42.5666 35.4667L42.2585 35.405C42.2419 35.3661 42.2444 35.3324 42.2434 35.2908C42.2394 35.3185 42.2392 35.3709 42.2283 35.3948C42.2138 35.4265 42.1255 35.4881 42.0944 35.5131C41.9593 35.6213 41.8261 35.7318 41.6874 35.8355C41.1447 36.2414 40.6058 36.6514 40.0644 37.0586C39.9344 37.1563 39.8027 37.2524 39.6736 37.3512C39.5917 37.4138 39.5038 37.4959 39.4095 37.5367L39.4062 37.3999C39.3898 37.2733 39.3997 37.1352 39.3989 37.0072L39.3843 37.0017L39.4458 36.9844L39.428 36.9632C39.3781 36.9222 39.3248 36.8947 39.2781 36.8454C39.2098 36.7733 39.1601 36.6566 39.1661 36.5569C39.1766 36.382 39.2817 36.26 39.405 36.1478L39.4089 36.1272L39.4123 35.9352L39.4049 35.9061C39.4321 35.4233 39.4102 34.9242 39.4046 34.4402C39.4032 34.327 39.3999 34.214 39.3963 34.1009C39.3941 34.0341 39.3822 33.9571 39.4028 33.8929C39.3852 33.8945 39.3788 33.8961 39.3599 33.8919C39.3315 33.8857 39.2948 33.859 39.2785 33.8356L39.2899 33.8181C39.2382 33.7564 39.1849 33.7055 39.1501 33.6314L39.1393 33.6077C39.0389 33.3897 39.0924 33.2239 39.188 33.0193C39.2084 32.9757 39.2399 32.9358 39.2517 32.889L39.2569 32.8661L39.268 32.8545C39.2279 32.7777 39.254 32.5575 39.2539 32.4664C39.2536 32.1285 39.2535 31.7907 39.2542 31.4528C39.2544 31.3619 39.273 31.2384 39.2543 31.1524C39.2398 31.0853 39.2477 31.0088 39.2482 30.9396C39.249 30.8156 39.2417 30.6847 39.2608 30.5624L39.2478 30.5453C39.2707 30.4829 39.2646 30.4295 39.2588 30.3645L39.2404 30.3409L39.2411 29.7516Z"
          fill="#ECE7E0"
        />
        <path
          id="Vector_525"
          d="M40.5976 34.0818C40.6276 34.0976 40.6183 34.0907 40.642 34.1098C40.6663 34.1294 40.6591 34.1456 40.6617 34.1753C40.5852 34.2831 40.4504 34.3799 40.3498 34.4672C40.1196 34.6671 39.882 34.8606 39.6564 35.0656L39.5889 34.9851C39.5937 34.9662 39.5988 34.9565 39.6133 34.9432C39.7265 34.839 39.8509 34.7467 39.9671 34.6458C40.18 34.4608 40.3859 34.2681 40.5976 34.0818Z"
          fill="#9D9BA7"
        />
        <path
          id="Vector_526"
          d="M39.2589 30.3645C39.7229 30.8206 40.1747 31.2914 40.6337 31.7529C40.7619 31.8817 40.8898 32.0107 41.0174 32.14C41.0681 32.1913 41.1494 32.2567 41.1873 32.3166C41.1988 32.3347 41.1989 32.3406 41.2032 32.3589C41.1769 32.3885 41.1589 32.4078 41.1233 32.4267C41.0479 32.3819 40.9758 32.2904 40.9139 32.227C40.7619 32.0717 40.6114 31.915 40.4595 31.7597C40.0648 31.3561 39.6641 30.9573 39.2609 30.5624L39.2478 30.5453C39.2707 30.4829 39.2646 30.4295 39.2589 30.3645Z"
          fill="#797388"
        />
        <path
          id="Vector_527"
          d="M39.4051 36.1478L39.4223 36.147C39.5846 36.1332 39.6977 36.0919 39.8424 36.2004C39.942 36.275 39.992 36.3999 40.0048 36.5202C40.0154 36.6192 39.9749 36.7206 39.9131 36.797C39.8065 36.929 39.6559 36.9938 39.4886 37.0054L39.399 37.0072L39.3843 37.0017L39.4459 36.9844L39.428 36.9632C39.3781 36.9222 39.3249 36.8947 39.2782 36.8454C39.2099 36.7733 39.1602 36.6566 39.1661 36.5569C39.1766 36.382 39.2818 36.26 39.4051 36.1478Z"
          fill="#8E8796"
        />
        <path
          id="Vector_528"
          d="M39.464 36.3123C39.5196 36.3056 39.5748 36.2988 39.6301 36.3116C39.7046 36.3288 39.7685 36.3835 39.8037 36.4506C39.8385 36.5172 39.8441 36.6058 39.8186 36.6766C39.7864 36.7661 39.713 36.805 39.6304 36.8394C39.5935 36.8408 39.556 36.8424 39.5195 36.8363C39.436 36.8222 39.3551 36.7689 39.3096 36.6971C39.2741 36.641 39.2627 36.582 39.2789 36.5175C39.3058 36.4108 39.3734 36.3639 39.464 36.3123Z"
          fill="#130B24"
        />
        <path
          id="Vector_529"
          d="M42.1608 32.7624L39.496 30.1187C39.4853 30.0621 39.4127 29.9971 39.372 29.9564L39.3092 29.8916C39.2903 29.878 39.2751 29.8693 39.2577 29.8539L39.2556 29.8178C39.3143 29.7909 39.5034 30.0823 39.5924 30.0935C40.2498 30.7196 40.8858 31.3684 41.53 32.0081C41.6719 32.149 41.8147 32.2886 41.9594 32.4265C42.048 32.511 42.2112 32.6352 42.2525 32.7468L42.2434 35.2908C42.2394 35.3185 42.2392 35.3709 42.2283 35.3948C42.2138 35.4265 42.1255 35.4881 42.0944 35.5131C41.9593 35.6213 41.8261 35.7318 41.6874 35.8355C41.1447 36.2414 40.6058 36.6514 40.0644 37.0586C39.9344 37.1563 39.8027 37.2524 39.6736 37.3512C39.5917 37.4138 39.5038 37.4959 39.4095 37.5367L39.4062 37.3999C39.5556 37.3391 39.7004 37.2063 39.8294 37.1085C40.1038 36.9005 40.3733 36.6862 40.6465 36.4766C41.0004 36.205 41.3607 35.9486 41.7239 35.6902C41.8739 35.5834 42.0185 35.4687 42.1704 35.365L42.1741 33.0277L42.1608 32.7624Z"
          fill="#A99D9F"
        />
        <path
          id="Vector_530"
          d="M42.1608 32.7624L39.496 30.1187C39.4853 30.0621 39.4127 29.9971 39.372 29.9564L39.3092 29.8916C39.2903 29.878 39.2751 29.8693 39.2577 29.8539L39.2556 29.8178C39.3143 29.7909 39.5034 30.0823 39.5924 30.0935C40.2498 30.7196 40.8858 31.3684 41.53 32.0081C41.6719 32.149 41.8147 32.2886 41.9594 32.4265C42.048 32.511 42.2112 32.6352 42.2525 32.7468C42.2147 32.8283 42.2169 33.0359 42.2323 33.1304C42.241 33.1834 42.2278 33.2623 42.2277 33.3189C42.2274 33.5145 42.2273 33.7102 42.2276 33.9058C42.2277 33.9987 42.2177 34.1016 42.2326 34.1924C42.2392 34.2328 42.2314 34.276 42.2358 34.3191C42.2412 34.3722 42.2488 34.4964 42.2207 34.5386V35.3635H42.213C42.1886 35.3269 42.1959 35.2812 42.1956 35.2377C42.1946 35.1199 42.198 35.002 42.1975 34.8842C42.1952 34.2862 42.2057 33.6871 42.1975 33.0893C42.197 33.054 42.1986 32.8319 42.1824 32.8281L42.1741 33.0277L42.1608 32.7624Z"
          fill="#E2D4CA"
        />
        <path
          id="Vector_531"
          d="M39.268 32.8545C39.4132 32.7605 39.5735 32.7257 39.744 32.7646C39.8879 32.7974 40.032 32.8707 40.1087 33.0022C40.2036 33.1649 40.2342 33.3513 40.1836 33.5343C40.146 33.6707 40.049 33.7912 39.9263 33.8608C39.7626 33.9536 39.5765 33.9425 39.4028 33.8929C39.3852 33.8945 39.3788 33.8961 39.3599 33.8919C39.3315 33.8857 39.2948 33.8589 39.2785 33.8356L39.2899 33.818C39.2382 33.7564 39.1849 33.7055 39.1501 33.6314L39.1393 33.6077C39.0389 33.3896 39.0924 33.2239 39.188 33.0193C39.2084 32.9757 39.2399 32.9358 39.2517 32.889L39.2569 32.8661L39.268 32.8545Z"
          fill="url(#paint30_linear_11_402)"
        />
        <path
          id="Vector_532"
          d="M39.532 32.8613C39.6421 32.855 39.7328 32.8596 39.8332 32.9112C39.9451 32.9687 40.0558 33.0542 40.0885 33.1817C40.1162 33.2895 40.1198 33.4897 40.0611 33.587C39.9857 33.7121 39.8613 33.7859 39.7253 33.8259C39.6262 33.8298 39.5331 33.8336 39.4381 33.7985C39.3313 33.7591 39.2424 33.6404 39.1978 33.5396C39.1437 33.417 39.1596 33.2702 39.2109 33.1499L39.2194 33.1309L39.2406 33.0828C39.302 32.9588 39.4056 32.9026 39.532 32.8613Z"
          fill="#A99D9F"
        />
        <path
          id="Vector_533"
          d="M39.6006 32.9665C39.6655 32.9635 39.7227 32.9697 39.7837 32.9936C39.8988 33.0387 39.9908 33.1367 40.0335 33.252C40.0635 33.333 40.0621 33.4205 40.0234 33.4985C39.9598 33.6268 39.8476 33.6896 39.7187 33.7341C39.6218 33.7428 39.5415 33.7497 39.4539 33.7005C39.3613 33.6485 39.2921 33.5541 39.2657 33.4519C39.2396 33.3511 39.2587 33.2367 39.3149 33.149C39.3842 33.0409 39.4801 32.9941 39.6006 32.9665Z"
          fill="#130B24"
        />
        <path
          id="Vector_534"
          d="M41.2875 32.681C41.4001 32.6712 41.5054 32.6888 41.6066 32.7408C41.7611 32.8203 41.9092 32.9665 41.9622 33.1347L41.968 33.1536L41.987 33.2167C42.0153 33.3599 41.9818 33.5305 41.9023 33.6522C41.7929 33.8194 41.6294 33.9206 41.4372 33.963C41.3631 33.9655 41.2862 33.9706 41.2139 33.9511C41.0393 33.9038 40.8753 33.7742 40.7893 33.6141C40.7128 33.4715 40.6927 33.2791 40.7416 33.1239L40.7493 33.1006L40.762 33.0616C40.7934 32.9763 40.8695 32.8381 40.9574 32.7992C41.0749 32.7473 41.1569 32.7 41.2875 32.681Z"
          fill="#9D9BA7"
        />
        <path
          id="Vector_535"
          d="M41.2874 32.8008C41.3438 32.799 41.4239 32.7884 41.4771 32.8084C41.6294 32.8653 41.764 32.9703 41.8226 33.1237L41.8308 33.146L41.8442 33.1838C41.8833 33.3188 41.8557 33.4924 41.7864 33.6121C41.7045 33.7537 41.5907 33.8022 41.4412 33.8447C41.3427 33.8472 41.2598 33.8425 41.1669 33.8055C41.0499 33.7588 40.9257 33.6433 40.8771 33.5254L40.8707 33.5093C40.836 33.4253 40.8281 33.2894 40.8526 33.201L40.8578 33.1839C40.8738 33.129 40.8913 33.0741 40.9218 33.0253C41.0057 32.8911 41.139 32.8347 41.2874 32.8008Z"
          fill="#E2D4CA"
        />
        <path
          id="Vector_536"
          d="M41.3161 32.9227C41.3934 32.9264 41.4661 32.9324 41.5357 32.9697C41.6261 33.0182 41.7194 33.1275 41.7434 33.2289C41.7699 33.341 41.7477 33.4703 41.6857 33.5668C41.6131 33.6799 41.5138 33.7176 41.3888 33.7424C41.2903 33.7363 41.2093 33.7286 41.1225 33.675C41.0294 33.6175 40.9543 33.5233 40.9332 33.4145L40.9299 33.3958C40.9106 33.2906 40.9312 33.1754 40.9948 33.0878C41.0748 32.9777 41.1876 32.9415 41.3161 32.9227Z"
          fill="#250C28"
        />
        <path
          id="Vector_537"
          d="M39.7549 35.6443L41.1042 34.3982C41.2142 34.3161 41.3588 34.2652 41.4969 34.2884L41.5168 34.2922C41.5619 34.3004 41.6054 34.3122 41.6474 34.3311C41.7839 34.3924 41.9118 34.5444 41.9613 34.6837L41.9685 34.7048C42.0021 34.7999 42.0091 34.9152 41.9735 35.0111L41.9658 35.0305C41.9135 35.1647 41.818 35.2581 41.7074 35.3454L40.3222 36.4377C40.2032 36.3032 40.1021 36.1542 39.9889 36.0149C39.9295 35.9419 39.8496 35.8697 39.8027 35.7896C39.6865 35.9038 39.5009 36.0012 39.4089 36.1272L39.4124 35.9352L39.4049 35.9061L39.4241 35.9256C39.5403 35.8541 39.6565 35.739 39.7549 35.6443Z"
          fill="#A99D9F"
        />
        <path
          id="Vector_538"
          d="M39.7672 35.7177L39.8216 35.6816L39.8411 35.7042L39.8331 35.7268C39.8148 35.8395 40.0592 35.9948 40.1175 36.0906C40.1531 36.1492 40.2197 36.1783 40.2393 36.2467C40.2497 36.2831 40.2383 36.2621 40.2619 36.2935C40.3098 36.2886 40.3468 36.2735 40.3875 36.2474C40.4621 36.1996 40.5219 36.1283 40.5931 36.075C40.7525 35.9555 40.9186 35.8392 41.0813 35.7238C41.1499 35.6751 41.215 35.6227 41.2293 35.5393L41.2914 35.526C41.2693 35.5535 41.2624 35.5714 41.2549 35.6057L41.2817 35.6113L41.4143 35.53C41.5022 35.4718 41.5687 35.3503 41.6682 35.3183L41.7074 35.3454L40.3222 36.4377C40.2032 36.3032 40.1021 36.1542 39.9889 36.0149C39.9296 35.9419 39.8496 35.8697 39.8027 35.7896L39.7672 35.7177Z"
          fill="#9D9BA7"
        />
        <path
          id="Vector_539"
          d="M40.6821 35.1872C40.73 35.2075 40.7552 35.2576 40.7864 35.299C40.8539 35.3887 40.9227 35.4768 40.9941 35.5635L40.361 36.108L40.0341 35.7298L40.6821 35.1872Z"
          fill="#D31D22"
        />
        <path
          id="Vector_540"
          d="M40.6187 35.4275C40.6543 35.4264 40.6833 35.4296 40.7146 35.4487C40.7506 35.4706 40.7737 35.4982 40.7834 35.5376C40.6777 35.6733 40.5196 35.7849 40.3998 35.9115C40.3517 35.9123 40.2673 35.8169 40.228 35.7825C40.3646 35.6708 40.4767 35.5338 40.6187 35.4275Z"
          fill="#250C28"
        />
        <path
          id="Vector_541"
          d="M41.4026 34.4658C41.4559 34.466 41.5154 34.4703 41.5663 34.487C41.6576 34.517 41.7523 34.5982 41.7932 34.686L41.8011 34.7043L41.8168 34.7424C41.8472 34.8347 41.8325 34.9522 41.7856 35.0355C41.7224 35.1476 41.6125 35.2027 41.4932 35.2355C41.4142 35.2382 41.3466 35.2353 41.2752 35.1975C41.1771 35.1456 41.0869 35.0433 41.0622 34.9339C41.0406 34.8384 41.0622 34.7331 41.1138 34.6508C41.1851 34.5371 41.2761 34.4925 41.4026 34.4658Z"
          fill="#250C28"
        />
        <path
          id="Vector_542"
          d="M39.2411 29.7516C39.2406 29.6152 39.2402 29.4788 39.2404 29.3425C39.2405 29.2695 39.231 29.1859 39.2573 29.1173L39.6435 29.5002C40.3484 30.2116 41.0653 30.9108 41.7734 31.619C41.9537 31.7992 42.1351 31.9783 42.3147 32.1591C42.396 32.2409 42.5223 32.343 42.5715 32.4471L42.5666 35.4667L42.2585 35.405C42.2419 35.3661 42.2444 35.3324 42.2434 35.2908L42.2525 32.7468C42.2112 32.6352 42.048 32.5111 41.9594 32.4265C41.8147 32.2886 41.6719 32.149 41.53 32.0081C40.8858 31.3684 40.2498 30.7196 39.5924 30.0935C39.5662 30.0437 39.5114 30.0008 39.4715 29.9611C39.3982 29.8882 39.3279 29.8086 39.2411 29.7516Z"
          fill="#F8F5EC"
        />
        <path
          id="Vector_543"
          d="M38.4724 30.6598L38.4895 30.7318L38.5506 30.7317C38.5738 30.9022 38.5602 31.0851 38.562 31.2576C38.5665 31.6776 38.5649 32.0975 38.5618 32.5175C38.5531 33.6723 38.54 34.8244 38.5541 35.9795C38.5582 36.3144 38.5655 36.6484 38.5736 36.9832C38.5773 37.1341 38.5705 37.2879 38.5825 37.4383L37.971 38.4963L38.961 37.6763L38.9838 37.6677L39.4062 37.3999L39.4095 37.5367L39.4062 37.5464C39.4286 37.7075 39.3706 37.9126 39.4232 38.0618L37.4273 39.6153L37.2787 39.7269L37.2815 39.9157L36.6901 39.912L36.1951 39.91L35.8284 39.9049L35.8211 39.9154C35.7304 39.8915 35.6319 39.9001 35.5385 39.9005C35.406 39.901 35.2731 39.896 35.1408 39.9008C35.0591 39.9038 34.9604 39.926 34.883 39.9007L34.3445 37.8507L34.3371 37.8453L34.2159 37.3013L34.2543 37.2927L34.2569 36.7789L35.0068 36.7794L35.1228 36.7783L35.6183 36.7785L36.5125 36.7792L36.681 36.7781L36.7688 36.7768L36.7717 36.6451L36.7681 33.4961L36.7634 32.2887C36.9399 32.1133 37.0738 31.9437 37.2176 31.742C37.2438 31.7053 37.2618 31.6774 37.3014 31.6545C37.418 31.6782 37.5527 31.6632 37.6718 31.661C37.69 31.4521 37.6724 31.2281 37.6724 31.0177C37.6724 30.9349 37.6584 30.8303 37.6895 30.7528L37.689 30.7421C37.8389 30.7398 37.9893 30.7355 38.1391 30.7384C38.2214 30.74 38.3907 30.7721 38.4592 30.7393L38.4724 30.6598Z"
          fill="#5D5670"
        />
        <path
          id="Vector_544"
          d="M39.4062 37.3999L39.4095 37.5367L39.4062 37.5464C39.4286 37.7075 39.3706 37.9126 39.4232 38.0618L37.4273 39.6153L37.4292 39.5943C37.4412 39.5473 37.4837 39.4835 37.5047 39.4383C37.5887 39.2571 37.6768 39.0805 37.776 38.9069C37.8154 38.8379 37.8573 38.7505 37.9126 38.6936C37.9904 38.6134 38.1105 38.5456 38.2004 38.475C38.4551 38.275 38.7087 38.0734 38.9616 37.8711C38.9737 37.8132 38.9924 37.7291 38.961 37.6763L38.9838 37.6677L39.4062 37.3999Z"
          fill="#B1969E"
        />
        <path
          id="Vector_545"
          d="M39.4063 37.3999L39.4095 37.5367L39.4062 37.5464L38.9616 37.8711C38.9738 37.8132 38.9925 37.7291 38.9611 37.6763L38.9838 37.6677L39.4063 37.3999Z"
          fill="#797388"
        />
        <path
          id="Vector_546"
          d="M37.6895 30.7528L38.2415 30.7542C38.2416 31.4078 38.2423 32.0614 38.2457 32.715C38.2466 32.8814 38.2475 33.0479 38.2487 33.2143C38.2494 33.3087 38.242 33.4114 38.2637 33.5037L38.1315 33.5075L37.0452 33.5056L36.7681 33.4961L36.7634 32.2887C36.9399 32.1133 37.0738 31.9437 37.2176 31.742C37.2438 31.7053 37.2618 31.6774 37.3014 31.6545C37.418 31.6782 37.5527 31.6632 37.6718 31.661C37.69 31.4521 37.6724 31.2281 37.6724 31.0177C37.6724 30.9349 37.6584 30.8304 37.6895 30.7528Z"
          fill="url(#paint31_linear_11_402)"
        />
        <path
          id="Vector_547"
          d="M37.3014 31.6545C37.418 31.6782 37.5527 31.6632 37.6718 31.661L37.046 32.4047L37.0452 33.5056L36.7681 33.4961L36.7634 32.2887C36.9399 32.1133 37.0738 31.9437 37.2176 31.742C37.2438 31.7053 37.2618 31.6774 37.3014 31.6545Z"
          fill="#B90822"
        />
        <path
          id="Vector_548"
          d="M38.2637 33.5037C38.287 33.5658 38.2807 33.6368 38.2815 33.7023C38.2828 33.8244 38.2831 33.9466 38.2835 34.0687C38.2853 34.697 38.2847 35.3253 38.2853 35.9535C38.2855 36.1252 38.2851 36.2968 38.2862 36.4685C38.2868 36.5689 38.2796 36.6797 38.297 36.7784L37.8748 36.7802L37.8546 36.7768L37.7958 36.7765L36.7688 36.7768L36.7717 36.6451L36.7681 33.4961L37.0452 33.5056L38.1315 33.5075L38.2637 33.5037Z"
          fill="#528295"
        />
        <path
          id="Vector_549"
          d="M37.1476 34.6745L37.9549 34.6724L37.9561 34.8759L37.1465 34.8795L37.1476 34.6745Z"
          fill="#130B24"
        />
        <path
          id="Vector_550"
          d="M37.1475 35.0218L37.9592 35.0218L37.9598 35.2287C37.8655 35.2443 37.7578 35.2347 37.6619 35.2353C37.4901 35.2364 37.3184 35.2384 37.1466 35.2403L37.1475 35.0218Z"
          fill="#130B24"
        />
        <path
          id="Vector_551"
          d="M37.1517 34.3164L37.9538 34.3132L37.9554 34.5375L37.1501 34.5368L37.1517 34.3164Z"
          fill="#130B24"
        />
        <path
          id="Vector_552"
          d="M37.1476 35.3734L37.965 35.3706L37.9667 35.597L37.1471 35.5984L37.1476 35.3734Z"
          fill="#130B24"
        />
        <path
          id="Vector_553"
          d="M37.1478 35.7372L37.9668 35.7358L37.967 35.9616L37.147 35.963L37.1478 35.7372Z"
          fill="#130B24"
        />
        <path
          id="Vector_554"
          d="M37.1501 33.9521L37.9732 33.9516L37.9758 34.1865L37.1479 34.1902L37.1501 33.9521Z"
          fill="#130B24"
        />
        <path
          id="Vector_555"
          d="M37.14 36.1125L37.9624 36.1086L37.961 36.3709L37.1403 36.3719L37.14 36.1125Z"
          fill="#130B24"
        />
        <path
          id="Vector_556"
          d="M38.2637 33.5037C38.287 33.5658 38.2807 33.6368 38.2814 33.7023C38.2828 33.8244 38.2831 33.9466 38.2834 34.0687C38.2852 34.697 38.2847 35.3253 38.2853 35.9535C38.2855 36.1252 38.2851 36.2968 38.2862 36.4685C38.2868 36.5689 38.2796 36.6797 38.297 36.7784L37.8747 36.7802L37.8546 36.7768L37.7958 36.7765L36.7688 36.7768L36.7717 36.6451L38.1059 36.6297L38.1315 33.5075L38.2637 33.5037Z"
          fill="#32AEBE"
        />
        <path
          id="Vector_557"
          d="M36.7688 36.7768L37.7958 36.7765L37.8546 36.7768L37.8748 36.7802L38.297 36.7784C38.3068 36.7886 38.3203 36.7963 38.3263 36.8091C38.333 36.8237 38.3272 36.8877 38.3275 36.9058C38.3291 37.0348 38.3198 37.1762 38.3374 37.3031C38.2219 37.57 38.03 37.818 37.8769 38.0654C37.7347 38.2955 37.6082 38.5352 37.4628 38.7632C37.2141 39.153 36.9444 39.5265 36.6901 39.912L36.1951 39.91L35.8284 39.9049L35.8211 39.9155C35.7304 39.8915 35.6319 39.9001 35.5385 39.9005C35.406 39.901 35.2731 39.896 35.1408 39.9008C35.0591 39.9038 34.9604 39.926 34.883 39.9007L34.3445 37.8507L34.3371 37.8454L34.2159 37.3013L34.2543 37.2927L34.2569 36.7789L35.0068 36.7795L35.1228 36.7783L35.6183 36.7785L36.5125 36.7792L36.681 36.7781L36.7688 36.7768Z"
          fill="#1B1536"
        />
        <path
          id="Vector_558"
          d="M35.0068 36.7795L35.1229 36.7783C35.1746 36.8699 35.1382 37.0829 35.129 37.1875C35.1263 37.2184 35.1393 37.2612 35.1457 37.2917L34.2543 37.2927L34.257 36.7789L35.0068 36.7795Z"
          fill="#ED3131"
        />
        <path
          id="Vector_559"
          d="M35.1229 36.7783L35.6183 36.7785L36.5126 36.7792L36.6811 36.7781L36.683 37.0954L36.6731 37.2669L36.5123 37.2833L36.494 37.3L35.2415 37.2999L35.1457 37.2917C35.1393 37.2612 35.1263 37.2184 35.129 37.1875C35.1382 37.0829 35.1745 36.8699 35.1229 36.7783Z"
          fill="#D31D22"
        />
        <path
          id="Vector_560"
          d="M36.5126 36.7792L36.6811 36.7781L36.683 37.0954L36.6731 37.2669L36.5123 37.2833L36.5126 36.7792Z"
          fill="#130B24"
        />
        <path
          id="Vector_561"
          d="M35.1229 36.7783L35.6183 36.7785L35.6223 37.2995L35.2415 37.2999L35.1457 37.2917C35.1393 37.2612 35.1263 37.2184 35.129 37.1875C35.1382 37.0829 35.1745 36.8699 35.1229 36.7783Z"
          fill="#F56D3B"
        />
        <path
          id="Vector_562"
          d="M36.7688 36.7768L37.7958 36.7765L37.8546 36.7768L37.8748 36.7802L38.297 36.7784C38.3068 36.7886 38.3203 36.7963 38.3263 36.8091C38.333 36.8237 38.3272 36.8877 38.3275 36.9058C38.3291 37.0348 38.3198 37.1762 38.3374 37.3031C38.2219 37.57 38.03 37.818 37.8769 38.0654C37.7347 38.2955 37.6082 38.5352 37.4628 38.7632C37.2141 39.153 36.9444 39.5265 36.6901 39.912L36.1951 39.91C36.211 39.8475 36.2643 39.7837 36.2998 39.7305C36.369 39.6267 36.4363 39.5215 36.5028 39.4159C36.8339 38.8898 37.152 38.3523 37.5032 37.8393L36.3836 37.8357L36.494 37.3L36.5122 37.2833L36.6731 37.2669L36.683 37.0954L36.681 36.7781L36.7688 36.7768Z"
          fill="#250C28"
        />
        <path
          id="Vector_563"
          d="M37.7958 36.7765L37.8546 36.7768L37.8537 37.2798C37.8325 37.2894 37.8226 37.2932 37.7987 37.295L37.7958 36.7765Z"
          fill="#130B24"
        />
        <path
          id="Vector_564"
          d="M38.297 36.7784C38.3068 36.7886 38.3203 36.7963 38.3263 36.8091C38.333 36.8237 38.3272 36.8877 38.3275 36.9058C38.3291 37.0348 38.3198 37.1762 38.3374 37.3031C38.1874 37.2855 38.026 37.2953 37.8746 37.2934L37.8748 36.7802L38.297 36.7784Z"
          fill="#B90822"
        />
        <path
          id="Vector_565"
          d="M36.7688 36.7768L37.7958 36.7765L37.7987 37.295L36.6918 37.2913L36.683 37.0954L36.681 36.7781L36.7688 36.7768Z"
          fill="#B90822"
        />
        <path
          id="Vector_566"
          d="M36.2307 37.8484L36.3552 37.8492L36.3675 37.8687L35.8284 39.9049L35.8211 39.9154C35.7304 39.8915 35.632 39.9001 35.5385 39.9005C35.406 39.901 35.2731 39.896 35.1408 39.9008C35.0591 39.9038 34.9604 39.926 34.883 39.9007L34.3445 37.8507L36.2307 37.8484Z"
          fill="#5D5670"
        />
      </g>
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_11_402"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(124 -20.5) rotate(90) scale(72 124)"
      >
        <stop stop-color="#8015A7" />
        <stop
          offset="1"
          stop-color="#613690"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint1_linear_11_402"
        x1="248"
        y1="54.9996"
        x2="7.99999"
        y2="55"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="white"
          stop-opacity="0"
        />
        <stop
          offset="0.520833"
          stop-color="white"
          stop-opacity="0.499167"
        />
        <stop
          offset="1"
          stop-color="white"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_11_402"
        x1="248"
        y1="-0.000445312"
        x2="7.99999"
        y2="-1.42589e-05"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="white"
          stop-opacity="0"
        />
        <stop
          offset="0.520833"
          stop-color="white"
          stop-opacity="0.499167"
        />
        <stop
          offset="1"
          stop-color="white"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint3_linear_11_402"
        x1="25.2"
        y1="16"
        x2="48.4"
        y2="36.8"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C427FB" />
        <stop
          offset="1"
          stop-color="#22D7FF"
        />
      </linearGradient>
      <linearGradient
        id="paint4_linear_11_402"
        x1="37.2297"
        y1="40.942"
        x2="36.0597"
        y2="33.5101"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#140623" />
        <stop
          offset="1"
          stop-color="#480827"
        />
      </linearGradient>
      <linearGradient
        id="paint5_linear_11_402"
        x1="45.7519"
        y1="27.9184"
        x2="46.2222"
        y2="28.0256"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1C0319" />
        <stop
          offset="1"
          stop-color="#0E1027"
        />
      </linearGradient>
      <linearGradient
        id="paint6_linear_11_402"
        x1="47.0734"
        y1="31.0062"
        x2="46.2867"
        y2="30.9981"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#456D8A" />
        <stop
          offset="1"
          stop-color="#50899B"
        />
      </linearGradient>
      <linearGradient
        id="paint7_linear_11_402"
        x1="43.6364"
        y1="27.8529"
        x2="43.2288"
        y2="28.0626"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#010001" />
        <stop
          offset="1"
          stop-color="#160121"
        />
      </linearGradient>
      <linearGradient
        id="paint8_linear_11_402"
        x1="43.6272"
        y1="32.3951"
        x2="42.9316"
        y2="32.5942"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#080004" />
        <stop
          offset="1"
          stop-color="#160A23"
        />
      </linearGradient>
      <linearGradient
        id="paint9_linear_11_402"
        x1="43.615"
        y1="29.4384"
        x2="42.9368"
        y2="29.7152"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop
          offset="1"
          stop-color="#10081F"
        />
      </linearGradient>
      <linearGradient
        id="paint10_linear_11_402"
        x1="43.6719"
        y1="30.3508"
        x2="42.8821"
        y2="30.4504"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#020000" />
        <stop
          offset="1"
          stop-color="#110822"
        />
      </linearGradient>
      <linearGradient
        id="paint11_linear_11_402"
        x1="43.6124"
        y1="32.7147"
        x2="42.9193"
        y2="32.8617"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#010000" />
        <stop
          offset="1"
          stop-color="#1A0A1F"
        />
      </linearGradient>
      <linearGradient
        id="paint12_linear_11_402"
        x1="43.6538"
        y1="29.9238"
        x2="42.8979"
        y2="30.036"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop
          offset="1"
          stop-color="#100B2B"
        />
      </linearGradient>
      <linearGradient
        id="paint13_linear_11_402"
        x1="43.5609"
        y1="25.2089"
        x2="43.9353"
        y2="25.2114"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#282746" />
        <stop
          offset="1"
          stop-color="#4C678E"
        />
      </linearGradient>
      <linearGradient
        id="paint14_linear_11_402"
        x1="41.9284"
        y1="22.1711"
        x2="40.4189"
        y2="21.9178"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5E3652" />
        <stop
          offset="1"
          stop-color="#4B4B63"
        />
      </linearGradient>
      <linearGradient
        id="paint15_linear_11_402"
        x1="26.8948"
        y1="24.8315"
        x2="26.0903"
        y2="24.2659"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#120917" />
        <stop
          offset="1"
          stop-color="#232659"
        />
      </linearGradient>
      <linearGradient
        id="paint16_linear_11_402"
        x1="27.7352"
        y1="25.7095"
        x2="26.1202"
        y2="25.1077"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CDB7B4" />
        <stop
          offset="1"
          stop-color="#D4CDC5"
        />
      </linearGradient>
      <linearGradient
        id="paint17_linear_11_402"
        x1="28.8705"
        y1="24.9285"
        x2="26.8152"
        y2="25.7907"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9E041E" />
        <stop
          offset="1"
          stop-color="#7A1227"
        />
      </linearGradient>
      <linearGradient
        id="paint18_linear_11_402"
        x1="24.1334"
        y1="29.8034"
        x2="27.6611"
        y2="31.1833"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4498AC" />
        <stop
          offset="1"
          stop-color="#71AFB9"
        />
      </linearGradient>
      <linearGradient
        id="paint19_linear_11_402"
        x1="30.5439"
        y1="21.926"
        x2="29.335"
        y2="22.2635"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A19B9E" />
        <stop
          offset="1"
          stop-color="#AAB0B1"
        />
      </linearGradient>
      <linearGradient
        id="paint20_linear_11_402"
        x1="31.9129"
        y1="16.8897"
        x2="32.9276"
        y2="17.8229"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#443151" />
        <stop
          offset="1"
          stop-color="#655771"
        />
      </linearGradient>
      <linearGradient
        id="paint21_linear_11_402"
        x1="30.8748"
        y1="27.2005"
        x2="29.5912"
        y2="26.5096"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#636276" />
        <stop
          offset="1"
          stop-color="#807A86"
        />
      </linearGradient>
      <linearGradient
        id="paint22_linear_11_402"
        x1="34.0714"
        y1="18.9186"
        x2="33.0459"
        y2="21.1756"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C0816D" />
        <stop
          offset="1"
          stop-color="#9B999D"
        />
      </linearGradient>
      <linearGradient
        id="paint23_linear_11_402"
        x1="33.5997"
        y1="38.638"
        x2="31.8063"
        y2="38.9805"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#40395B" />
        <stop
          offset="1"
          stop-color="#6C5F7C"
        />
      </linearGradient>
      <linearGradient
        id="paint24_linear_11_402"
        x1="38.3279"
        y1="25.3867"
        x2="36.5712"
        y2="25.7305"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E9C8D1" />
        <stop
          offset="1"
          stop-color="#FAFFFF"
        />
      </linearGradient>
      <linearGradient
        id="paint25_linear_11_402"
        x1="36.2746"
        y1="21.2161"
        x2="36.6759"
        y2="21.1894"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2B0F2A" />
        <stop
          offset="1"
          stop-color="#4C122D"
        />
      </linearGradient>
      <linearGradient
        id="paint26_linear_11_402"
        x1="33.9397"
        y1="18.6509"
        x2="38.2927"
        y2="21.429"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B4B6B8" />
        <stop
          offset="1"
          stop-color="#EAEEEA"
        />
      </linearGradient>
      <linearGradient
        id="paint27_linear_11_402"
        x1="37.3918"
        y1="18.3021"
        x2="36.2314"
        y2="18.9651"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9494A1" />
        <stop
          offset="1"
          stop-color="#B9A4AD"
        />
      </linearGradient>
      <linearGradient
        id="paint28_linear_11_402"
        x1="39.3623"
        y1="36.9422"
        x2="39.1742"
        y2="36.0339"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#605673" />
        <stop
          offset="1"
          stop-color="#746D83"
        />
      </linearGradient>
      <linearGradient
        id="paint29_linear_11_402"
        x1="36.2923"
        y1="17.4078"
        x2="38.3633"
        y2="20.9243"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C11A30" />
        <stop
          offset="1"
          stop-color="#864E63"
        />
      </linearGradient>
      <linearGradient
        id="paint30_linear_11_402"
        x1="39.1456"
        y1="33.5956"
        x2="40.1157"
        y2="33.0819"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#71738C" />
        <stop
          offset="1"
          stop-color="#908D99"
        />
      </linearGradient>
      <linearGradient
        id="paint31_linear_11_402"
        x1="38.534"
        y1="31.9767"
        x2="36.797"
        y2="32.4507"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CCAEAA" />
        <stop
          offset="1"
          stop-color="#B8B0B0"
        />
      </linearGradient>
      <clipPath id="clip0_11_402">
        <rect
          width="248"
          height="56"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</div>
